/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AbstractJsonSchemaPropertyObject
 */
export interface AbstractJsonSchemaPropertyObject {
    /**
     * 
     * @type {string}
     * @memberof AbstractJsonSchemaPropertyObject
     */
    'title'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AbstractJsonSchemaPropertyObject
     */
    'readOnly'?: boolean;
}
/**
 * 
 * @export
 * @interface Alias
 */
export interface Alias {
    /**
     * 
     * @type {object}
     * @memberof Alias
     */
    'value'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof Alias
     */
    'present'?: boolean;
}
/**
 * 
 * @export
 * @interface AssociationObject
 */
export interface AssociationObject {
    /**
     * 
     * @type {object}
     * @memberof AssociationObject
     */
    'inverse'?: object;
    /**
     * 
     * @type {object}
     * @memberof AssociationObject
     */
    'obverse'?: object;
}
/**
 * 
 * @export
 * @interface CollectionModelEntityModelPlaywrightConfiguration
 */
export interface CollectionModelEntityModelPlaywrightConfiguration {
    /**
     * 
     * @type {PagedModelEntityModelPlaywrightConfigurationEmbedded}
     * @memberof CollectionModelEntityModelPlaywrightConfiguration
     */
    '_embedded'?: PagedModelEntityModelPlaywrightConfigurationEmbedded;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof CollectionModelEntityModelPlaywrightConfiguration
     */
    '_links'?: { [key: string]: Link; };
}
/**
 * 
 * @export
 * @interface CollectionModelEntityModelRequest
 */
export interface CollectionModelEntityModelRequest {
    /**
     * 
     * @type {PagedModelEntityModelRequestEmbedded}
     * @memberof CollectionModelEntityModelRequest
     */
    '_embedded'?: PagedModelEntityModelRequestEmbedded;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof CollectionModelEntityModelRequest
     */
    '_links'?: { [key: string]: Link; };
}
/**
 * 
 * @export
 * @interface CollectionModelEntityModelTestExecution
 */
export interface CollectionModelEntityModelTestExecution {
    /**
     * 
     * @type {PagedModelEntityModelTestExecutionEmbedded}
     * @memberof CollectionModelEntityModelTestExecution
     */
    '_embedded'?: PagedModelEntityModelTestExecutionEmbedded;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof CollectionModelEntityModelTestExecution
     */
    '_links'?: { [key: string]: Link; };
}
/**
 * 
 * @export
 * @interface CollectionModelEntityModelTestPauseData
 */
export interface CollectionModelEntityModelTestPauseData {
    /**
     * 
     * @type {PagedModelEntityModelTestPauseDataEmbedded}
     * @memberof CollectionModelEntityModelTestPauseData
     */
    '_embedded'?: PagedModelEntityModelTestPauseDataEmbedded;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof CollectionModelEntityModelTestPauseData
     */
    '_links'?: { [key: string]: Link; };
}
/**
 * 
 * @export
 * @interface CollectionModelEntityModelTrace
 */
export interface CollectionModelEntityModelTrace {
    /**
     * 
     * @type {PagedModelEntityModelTraceEmbedded}
     * @memberof CollectionModelEntityModelTrace
     */
    '_embedded'?: PagedModelEntityModelTraceEmbedded;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof CollectionModelEntityModelTrace
     */
    '_links'?: { [key: string]: Link; };
}
/**
 * 
 * @export
 * @interface CollectionModelObject
 */
export interface CollectionModelObject {
    /**
     * 
     * @type {CollectionModelObjectEmbedded}
     * @memberof CollectionModelObject
     */
    '_embedded'?: CollectionModelObjectEmbedded;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof CollectionModelObject
     */
    '_links'?: { [key: string]: Link; };
}
/**
 * 
 * @export
 * @interface CollectionModelObjectEmbedded
 */
export interface CollectionModelObjectEmbedded {
    /**
     * 
     * @type {Array<object>}
     * @memberof CollectionModelObjectEmbedded
     */
    'objects'?: Array<object>;
}
/**
 * 
 * @export
 * @interface CollectionModelTestExecution
 */
export interface CollectionModelTestExecution {
    /**
     * 
     * @type {CollectionModelTestExecutionEmbedded}
     * @memberof CollectionModelTestExecution
     */
    '_embedded'?: CollectionModelTestExecutionEmbedded;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof CollectionModelTestExecution
     */
    '_links'?: { [key: string]: Link; };
}
/**
 * 
 * @export
 * @interface CollectionModelTestExecutionEmbedded
 */
export interface CollectionModelTestExecutionEmbedded {
    /**
     * 
     * @type {Array<TestExecutionResponse>}
     * @memberof CollectionModelTestExecutionEmbedded
     */
    'testExecutions'?: Array<TestExecutionResponse>;
}
/**
 * 
 * @export
 * @interface CommandDto
 */
export interface CommandDto {
    /**
     * 
     * @type {number}
     * @memberof CommandDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommandDto
     */
    'commandType'?: CommandDtoCommandTypeEnum;
    /**
     * 
     * @type {LocateDto}
     * @memberof CommandDto
     */
    'locateDto'?: LocateDto;
    /**
     * 
     * @type {string}
     * @memberof CommandDto
     */
    'executeOption'?: CommandDtoExecuteOptionEnum;
    /**
     * 
     * @type {ExecuteOptionModifier}
     * @memberof CommandDto
     */
    'executeOptionModifier'?: ExecuteOptionModifier;
    /**
     * 
     * @type {string}
     * @memberof CommandDto
     */
    'executeValue'?: string;
    /**
     * 
     * @type {LocateDto}
     * @memberof CommandDto
     */
    'executeTarget'?: LocateDto;
    /**
     * 
     * @type {string}
     * @memberof CommandDto
     */
    'navigateUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommandDto
     */
    'checkStatusOption'?: CommandDtoCheckStatusOptionEnum;
    /**
     * 
     * @type {string}
     * @memberof CommandDto
     */
    'checkStatusValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommandDto
     */
    'valueOption'?: CommandDtoValueOptionEnum;
    /**
     * 
     * @type {string}
     * @memberof CommandDto
     */
    'variableName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommandDto
     */
    'compareValue'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommandDto
     */
    'prefabId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommandDto
     */
    'prefabName'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommandDto
     */
    'requestId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommandDto
     */
    'requestName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommandDto
     */
    'requestUrl'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CommandDto
     */
    'pathVariables'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CommandDto
     */
    'responseVariables'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof CommandDto
     */
    'requestJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommandDto
     */
    'systemTab'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommandDto
     */
    'waitInMs'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CommandDto
     */
    'dialogAccept'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommandDto
     */
    'jsonPath'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommandDto
     */
    'attribute'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommandDto
     */
    'orderIndex'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommandDto
     */
    'description'?: string;
    /**
     * 
     * @type {TimeOffset}
     * @memberof CommandDto
     */
    'timeOffset'?: TimeOffset;
    /**
     * 
     * @type {ImportTestDataCommandDto}
     * @memberof CommandDto
     */
    'importTestDataCommandDto'?: ImportTestDataCommandDto;
    /**
     * 
     * @type {PasswordDto}
     * @memberof CommandDto
     */
    'passwordDto'?: PasswordDto;
    /**
     * 
     * @type {ConditionDto}
     * @memberof CommandDto
     */
    'condition'?: ConditionDto;
}

export const CommandDtoCommandTypeEnum = {
    CheckStatus: 'CHECK_STATUS',
    Execute: 'EXECUTE',
    Navigate: 'NAVIGATE',
    SaveValue: 'SAVE_VALUE',
    CompareValue: 'COMPARE_VALUE',
    Prefab: 'PREFAB',
    Request: 'REQUEST',
    Wait: 'WAIT',
    Dialog: 'DIALOG',
    Pause: 'PAUSE',
    Import: 'IMPORT',
    PauseRecord: 'PAUSE_RECORD'
} as const;

export type CommandDtoCommandTypeEnum = typeof CommandDtoCommandTypeEnum[keyof typeof CommandDtoCommandTypeEnum];
export const CommandDtoExecuteOptionEnum = {
    Click: 'CLICK',
    Dblclick: 'DBLCLICK',
    Drag: 'DRAG',
    Fill: 'FILL',
    Check: 'CHECK',
    Clear: 'CLEAR',
    Uncheck: 'UNCHECK',
    Press: 'PRESS',
    PressSequentially: 'PRESS_SEQUENTIALLY',
    SelectOption: 'SELECT_OPTION',
    Hover: 'HOVER'
} as const;

export type CommandDtoExecuteOptionEnum = typeof CommandDtoExecuteOptionEnum[keyof typeof CommandDtoExecuteOptionEnum];
export const CommandDtoCheckStatusOptionEnum = {
    Checked: 'CHECKED',
    Enabled: 'ENABLED',
    Visible: 'VISIBLE',
    Disabled: 'DISABLED',
    Editable: 'EDITABLE',
    Hidden: 'HIDDEN',
    Empty: 'EMPTY',
    HasText: 'HAS_TEXT',
    HasValue: 'HAS_VALUE',
    HasClass: 'HAS_CLASS',
    ContainsText: 'CONTAINS_TEXT'
} as const;

export type CommandDtoCheckStatusOptionEnum = typeof CommandDtoCheckStatusOptionEnum[keyof typeof CommandDtoCheckStatusOptionEnum];
export const CommandDtoValueOptionEnum = {
    InnerText: 'INNER_TEXT',
    InputValue: 'INPUT_VALUE',
    InnerHtml: 'INNER_HTML',
    TextContent: 'TEXT_CONTENT',
    Attribute: 'ATTRIBUTE'
} as const;

export type CommandDtoValueOptionEnum = typeof CommandDtoValueOptionEnum[keyof typeof CommandDtoValueOptionEnum];

/**
 * 
 * @export
 * @interface ConditionDto
 */
export interface ConditionDto {
    /**
     * 
     * @type {string}
     * @memberof ConditionDto
     */
    'type'?: ConditionDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ConditionDto
     */
    'variableName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConditionDto
     */
    'checkValue'?: string;
}

export const ConditionDtoTypeEnum = {
    Exists: 'VAR_EXISTS',
    NotExists: 'VAR_NOT_EXISTS',
    Equals: 'VAR_EQUALS',
    NotEquals: 'VAR_NOT_EQUALS'
} as const;

export type ConditionDtoTypeEnum = typeof ConditionDtoTypeEnum[keyof typeof ConditionDtoTypeEnum];

/**
 * 
 * @export
 * @interface DeletionError
 */
export interface DeletionError {
    /**
     * 
     * @type {SystemDto}
     * @memberof DeletionError
     */
    'systemDto'?: SystemDto;
    /**
     * 
     * @type {number}
     * @memberof DeletionError
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeletionError
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeletionError
     */
    'creationType'?: DeletionErrorCreationTypeEnum;
}

export const DeletionErrorCreationTypeEnum = {
    Test: 'TEST',
    Prefab: 'PREFAB',
    TestPlan: 'TEST_PLAN'
} as const;

export type DeletionErrorCreationTypeEnum = typeof DeletionErrorCreationTypeEnum[keyof typeof DeletionErrorCreationTypeEnum];

/**
 * 
 * @export
 * @interface EntityModelPassword
 */
export interface EntityModelPassword {
    /**
     * 
     * @type {string}
     * @memberof EntityModelPassword
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityModelPassword
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityModelPassword
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof EntityModelPassword
     */
    '_links'?: { [key: string]: Link; };
}
/**
 * 
 * @export
 * @interface EntityModelPlaywrightConfiguration
 */
export interface EntityModelPlaywrightConfiguration {
    /**
     * 
     * @type {string}
     * @memberof EntityModelPlaywrightConfiguration
     */
    'configName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EntityModelPlaywrightConfiguration
     */
    'headless'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EntityModelPlaywrightConfiguration
     */
    'viewPortHeight'?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityModelPlaywrightConfiguration
     */
    'viewPortWidth'?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityModelPlaywrightConfiguration
     */
    'locale'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EntityModelPlaywrightConfiguration
     */
    'active'?: boolean;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof EntityModelPlaywrightConfiguration
     */
    '_links'?: { [key: string]: Link; };
}
/**
 * 
 * @export
 * @interface EntityModelRequest
 */
export interface EntityModelRequest {
    /**
     * 
     * @type {string}
     * @memberof EntityModelRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityModelRequest
     */
    'requestJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityModelRequest
     */
    'baseUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityModelRequest
     */
    'stage'?: EntityModelRequestStageEnum;
    /**
     * 
     * @type {string}
     * @memberof EntityModelRequest
     */
    'requestMethod'?: EntityModelRequestRequestMethodEnum;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof EntityModelRequest
     */
    '_links'?: { [key: string]: Link; };
}

export const EntityModelRequestStageEnum = {
    Ent: 'ENT',
    Kon: 'KON'
} as const;

export type EntityModelRequestStageEnum = typeof EntityModelRequestStageEnum[keyof typeof EntityModelRequestStageEnum];
export const EntityModelRequestRequestMethodEnum = {
    Get: 'GET',
    Post: 'POST'
} as const;

export type EntityModelRequestRequestMethodEnum = typeof EntityModelRequestRequestMethodEnum[keyof typeof EntityModelRequestRequestMethodEnum];

/**
 * 
 * @export
 * @interface EntityModelScheduledTestPlanTask
 */
export interface EntityModelScheduledTestPlanTask {
    /**
     * 
     * @type {number}
     * @memberof EntityModelScheduledTestPlanTask
     */
    'testPlanId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityModelScheduledTestPlanTask
     */
    'cronExpression'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityModelScheduledTestPlanTask
     */
    'creationTs'?: string;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof EntityModelScheduledTestPlanTask
     */
    '_links'?: { [key: string]: Link; };
}
/**
 * 
 * @export
 * @interface EntityModelSystem
 */
export interface EntityModelSystem {
    /**
     * 
     * @type {string}
     * @memberof EntityModelSystem
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityModelSystem
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof EntityModelSystem
     */
    '_links'?: { [key: string]: Link; };
}
/**
 * 
 * @export
 * @interface EntityModelTestExecution
 */
export interface EntityModelTestExecution {
    /**
     * 
     * @type {number}
     * @memberof EntityModelTestExecution
     */
    'testId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityModelTestExecution
     */
    'startTs'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityModelTestExecution
     */
    'endTs'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityModelTestExecution
     */
    'resumeTs'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityModelTestExecution
     */
    'runStatus'?: EntityModelTestExecutionRunStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof EntityModelTestExecution
     */
    'traceUrl'?: string;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof EntityModelTestExecution
     */
    '_links'?: { [key: string]: Link; };
}

export const EntityModelTestExecutionRunStatusEnum = {
    Success: 'SUCCESS',
    Failed: 'FAILED',
    Unknown: 'UNKNOWN',
    Paused: 'PAUSED',
    Executing: 'EXECUTING'
} as const;

export type EntityModelTestExecutionRunStatusEnum = typeof EntityModelTestExecutionRunStatusEnum[keyof typeof EntityModelTestExecutionRunStatusEnum];

/**
 * 
 * @export
 * @interface EntityModelTestPauseData
 */
export interface EntityModelTestPauseData {
    /**
     * 
     * @type {string}
     * @memberof EntityModelTestPauseData
     */
    'testJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityModelTestPauseData
     */
    'startTs'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityModelTestPauseData
     */
    'resumeTs'?: string;
    /**
     * 
     * @type {number}
     * @memberof EntityModelTestPauseData
     */
    'totalStep'?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityModelTestPauseData
     */
    'prefabStep'?: number;
    /**
     * 
     * @type {number}
     * @memberof EntityModelTestPauseData
     */
    'testExecutionId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EntityModelTestPauseData
     */
    'executeWithTrace'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EntityModelTestPauseData
     */
    'resumed'?: boolean;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof EntityModelTestPauseData
     */
    '_links'?: { [key: string]: Link; };
}
/**
 * 
 * @export
 * @interface EntityModelTestResult
 */
export interface EntityModelTestResult {
    /**
     * 
     * @type {number}
     * @memberof EntityModelTestResult
     */
    'testId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityModelTestResult
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityModelTestResult
     */
    'description'?: string;
    /**
     * 
     * @type {Array<TestStep>}
     * @memberof EntityModelTestResult
     */
    'testSteps'?: Array<TestStep>;
    /**
     * 
     * @type {Array<Variable>}
     * @memberof EntityModelTestResult
     */
    'predefinedVariables'?: Array<Variable>;
    /**
     * 
     * @type {Array<Variable>}
     * @memberof EntityModelTestResult
     */
    'runtimeVariables'?: Array<Variable>;
    /**
     * 
     * @type {string}
     * @memberof EntityModelTestResult
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityModelTestResult
     */
    'interpretedErrorMessage'?: string;
    /**
     * 
     * @type {number}
     * @memberof EntityModelTestResult
     */
    'successfullSteps'?: number;
    /**
     * 
     * @type {Array<Trace>}
     * @memberof EntityModelTestResult
     */
    'traces'?: Array<Trace>;
    /**
     * 
     * @type {boolean}
     * @memberof EntityModelTestResult
     */
    'used'?: boolean;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof EntityModelTestResult
     */
    '_links'?: { [key: string]: Link; };
}
/**
 * 
 * @export
 * @interface EntityModelTrace
 */
export interface EntityModelTrace {
    /**
     * 
     * @type {string}
     * @memberof EntityModelTrace
     */
    'filename'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntityModelTrace
     */
    'creationTs'?: string;
    /**
     * 
     * @type {number}
     * @memberof EntityModelTrace
     */
    'testResultId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EntityModelTrace
     */
    'traceUrl'?: string;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof EntityModelTrace
     */
    '_links'?: { [key: string]: Link; };
}
/**
 * 
 * @export
 * @interface ExecuteOptionModifier
 */
export interface ExecuteOptionModifier {
    /**
     * 
     * @type {number}
     * @memberof ExecuteOptionModifier
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ExecuteOptionModifier
     */
    'force'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ExecuteOptionModifier
     */
    'timeout'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ExecuteOptionModifier
     */
    'trial'?: boolean;
    /**
     * 
     * @type {Position}
     * @memberof ExecuteOptionModifier
     */
    'position'?: Position;
    /**
     * 
     * @type {string}
     * @memberof ExecuteOptionModifier
     */
    'button'?: ExecuteOptionModifierButtonEnum;
    /**
     * 
     * @type {number}
     * @memberof ExecuteOptionModifier
     */
    'clickCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecuteOptionModifier
     */
    'delay'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExecuteOptionModifier
     */
    'modifiers'?: Array<ExecuteOptionModifierModifiersEnum>;
    /**
     * 
     * @type {Position}
     * @memberof ExecuteOptionModifier
     */
    'sourcePosition'?: Position;
    /**
     * 
     * @type {Position}
     * @memberof ExecuteOptionModifier
     */
    'targetPosition'?: Position;
}

export const ExecuteOptionModifierButtonEnum = {
    Left: 'LEFT',
    Right: 'RIGHT',
    Middle: 'MIDDLE'
} as const;

export type ExecuteOptionModifierButtonEnum = typeof ExecuteOptionModifierButtonEnum[keyof typeof ExecuteOptionModifierButtonEnum];
export const ExecuteOptionModifierModifiersEnum = {
    Alt: 'ALT',
    Control: 'CONTROL',
    Controlormeta: 'CONTROLORMETA',
    Meta: 'META',
    Shift: 'SHIFT'
} as const;

export type ExecuteOptionModifierModifiersEnum = typeof ExecuteOptionModifierModifiersEnum[keyof typeof ExecuteOptionModifierModifiersEnum];

/**
 * 
 * @export
 * @interface ExecuteTestRequest
 */
export interface ExecuteTestRequest {
    /**
     * 
     * @type {number}
     * @memberof ExecuteTestRequest
     */
    'delay'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ExecuteTestRequest
     */
    'executeWithTrace'?: boolean;
}
/**
 * 
 * @export
 * @interface ExportInfoDto
 */
export interface ExportInfoDto {
    /**
     * 
     * @type {number}
     * @memberof ExportInfoDto
     */
    'testAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExportInfoDto
     */
    'systemAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExportInfoDto
     */
    'prefabAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExportInfoDto
     */
    'passwordAmount'?: number;
}
/**
 * 
 * @export
 * @interface FilterOptionDto
 */
export interface FilterOptionDto {
    /**
     * 
     * @type {string}
     * @memberof FilterOptionDto
     */
    'hasNotText'?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterOptionDto
     */
    'hasText'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FilterOptionDto
     */
    'pattern'?: boolean;
}
/**
 * 
 * @export
 * @interface ImportTestDataCommandDto
 */
export interface ImportTestDataCommandDto {
    /**
     * 
     * @type {number}
     * @memberof ImportTestDataCommandDto
     */
    'testId'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ImportTestDataCommandDto
     */
    'containsVariables'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ImportTestDataCommandDto
     */
    'useFailedTestExecution'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ImportTestDataCommandDto
     */
    'useUsedTestExecution'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ImportTestDataCommandDto
     */
    'startTs'?: string;
    /**
     * 
     * @type {TimeOffset}
     * @memberof ImportTestDataCommandDto
     */
    'timeOffset'?: TimeOffset;
}
/**
 * 
 * @export
 * @interface InstanceCreatorMetadataObject
 */
export interface InstanceCreatorMetadataObject {
    /**
     * 
     * @type {number}
     * @memberof InstanceCreatorMetadataObject
     */
    'parameterCount'?: number;
    /**
     * 
     * @type {Array<ParameterObjectObject>}
     * @memberof InstanceCreatorMetadataObject
     */
    'parameters'?: Array<ParameterObjectObject>;
}
/**
 * 
 * @export
 * @interface InstanceCreatorMetadataPersistentPropertyObject
 */
export interface InstanceCreatorMetadataPersistentPropertyObject {
    /**
     * 
     * @type {number}
     * @memberof InstanceCreatorMetadataPersistentPropertyObject
     */
    'parameterCount'?: number;
    /**
     * 
     * @type {Array<ParameterObjectPersistentPropertyObject>}
     * @memberof InstanceCreatorMetadataPersistentPropertyObject
     */
    'parameters'?: Array<ParameterObjectPersistentPropertyObject>;
}
/**
 * 
 * @export
 * @interface Item
 */
export interface Item {
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'type'?: string;
    /**
     * 
     * @type {{ [key: string]: AbstractJsonSchemaPropertyObject; }}
     * @memberof Item
     */
    'properties'?: { [key: string]: AbstractJsonSchemaPropertyObject; };
    /**
     * 
     * @type {Array<string>}
     * @memberof Item
     */
    'requiredProperties'?: Array<string>;
}
/**
 * 
 * @export
 * @interface JsonSchema
 */
export interface JsonSchema {
    /**
     * 
     * @type {string}
     * @memberof JsonSchema
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonSchema
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: AbstractJsonSchemaPropertyObject; }}
     * @memberof JsonSchema
     */
    'properties'?: { [key: string]: AbstractJsonSchemaPropertyObject; };
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonSchema
     */
    'requiredProperties'?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Item; }}
     * @memberof JsonSchema
     */
    'definitions'?: { [key: string]: Item; };
    /**
     * 
     * @type {string}
     * @memberof JsonSchema
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonSchema
     */
    '$schema'?: string;
}
/**
 * 
 * @export
 * @interface Link
 */
export interface Link {
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    'href'?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    'hreflang'?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    'deprecation'?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    'profile'?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Link
     */
    'templated'?: boolean;
}
/**
 * 
 * @export
 * @interface LocateDto
 */
export interface LocateDto {
    /**
     * 
     * @type {string}
     * @memberof LocateDto
     */
    'locateOption'?: LocateDtoLocateOptionEnum;
    /**
     * 
     * @type {string}
     * @memberof LocateDto
     */
    'role'?: LocateDtoRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof LocateDto
     */
    'checkValue'?: string;
    /**
     * 
     * @type {object}
     * @memberof LocateDto
     */
    'patternValue'?: object;
    /**
     * 
     * @type {FilterOptionDto}
     * @memberof LocateDto
     */
    'filterOption'?: FilterOptionDto;
    /**
     * 
     * @type {string}
     * @memberof LocateDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof LocateDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LocateDto
     */
    'nthElement'?: number;
    /**
     * 
     * @type {SystemDto}
     * @memberof LocateDto
     */
    'system'?: SystemDto;
    /**
     * 
     * @type {LocateDto}
     * @memberof LocateDto
     */
    'locate'?: LocateDto;
    /**
     * 
     * @type {boolean}
     * @memberof LocateDto
     */
    'exact'?: boolean;
}

export const LocateDtoLocateOptionEnum = {
    Role: 'ROLE',
    Label: 'LABEL',
    Placeholder: 'PLACEHOLDER',
    Text: 'TEXT',
    AltText: 'ALT_TEXT',
    Title: 'TITLE',
    TestId: 'TEST_ID',
    Xpath: 'XPATH',
    Css: 'CSS',
    Locator: 'LOCATOR',
    Frame: 'FRAME'
} as const;

export type LocateDtoLocateOptionEnum = typeof LocateDtoLocateOptionEnum[keyof typeof LocateDtoLocateOptionEnum];
export const LocateDtoRoleEnum = {
    Alert: 'ALERT',
    Alertdialog: 'ALERTDIALOG',
    Application: 'APPLICATION',
    Article: 'ARTICLE',
    Banner: 'BANNER',
    Blockquote: 'BLOCKQUOTE',
    Button: 'BUTTON',
    Caption: 'CAPTION',
    Cell: 'CELL',
    Checkbox: 'CHECKBOX',
    Code: 'CODE',
    Columnheader: 'COLUMNHEADER',
    Combobox: 'COMBOBOX',
    Complementary: 'COMPLEMENTARY',
    Contentinfo: 'CONTENTINFO',
    Definition: 'DEFINITION',
    Deletion: 'DELETION',
    Dialog: 'DIALOG',
    Directory: 'DIRECTORY',
    Document: 'DOCUMENT',
    Emphasis: 'EMPHASIS',
    Feed: 'FEED',
    Figure: 'FIGURE',
    Form: 'FORM',
    Generic: 'GENERIC',
    Grid: 'GRID',
    Gridcell: 'GRIDCELL',
    Group: 'GROUP',
    Heading: 'HEADING',
    Img: 'IMG',
    Insertion: 'INSERTION',
    Link: 'LINK',
    List: 'LIST',
    Listbox: 'LISTBOX',
    Listitem: 'LISTITEM',
    Log: 'LOG',
    Main: 'MAIN',
    Marquee: 'MARQUEE',
    Math: 'MATH',
    Meter: 'METER',
    Menu: 'MENU',
    Menubar: 'MENUBAR',
    Menuitem: 'MENUITEM',
    Menuitemcheckbox: 'MENUITEMCHECKBOX',
    Menuitemradio: 'MENUITEMRADIO',
    Navigation: 'NAVIGATION',
    None: 'NONE',
    Note: 'NOTE',
    Option: 'OPTION',
    Paragraph: 'PARAGRAPH',
    Presentation: 'PRESENTATION',
    Progressbar: 'PROGRESSBAR',
    Radio: 'RADIO',
    Radiogroup: 'RADIOGROUP',
    Region: 'REGION',
    Row: 'ROW',
    Rowgroup: 'ROWGROUP',
    Rowheader: 'ROWHEADER',
    Scrollbar: 'SCROLLBAR',
    Search: 'SEARCH',
    Searchbox: 'SEARCHBOX',
    Separator: 'SEPARATOR',
    Slider: 'SLIDER',
    Spinbutton: 'SPINBUTTON',
    Status: 'STATUS',
    Strong: 'STRONG',
    Subscript: 'SUBSCRIPT',
    Superscript: 'SUPERSCRIPT',
    Switch: 'SWITCH',
    Tab: 'TAB',
    Table: 'TABLE',
    Tablist: 'TABLIST',
    Tabpanel: 'TABPANEL',
    Term: 'TERM',
    Textbox: 'TEXTBOX',
    Time: 'TIME',
    Timer: 'TIMER',
    Toolbar: 'TOOLBAR',
    Tooltip: 'TOOLTIP',
    Tree: 'TREE',
    Treegrid: 'TREEGRID',
    Treeitem: 'TREEITEM'
} as const;

export type LocateDtoRoleEnum = typeof LocateDtoRoleEnum[keyof typeof LocateDtoRoleEnum];

/**
 * 
 * @export
 * @interface PageMetadata
 */
export interface PageMetadata {
    /**
     * 
     * @type {number}
     * @memberof PageMetadata
     */
    'size'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageMetadata
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageMetadata
     */
    'totalPages'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageMetadata
     */
    'number'?: number;
}
/**
 * 
 * @export
 * @interface PagePrefabDto
 */
export interface PagePrefabDto {
    /**
     * 
     * @type {number}
     * @memberof PagePrefabDto
     */
    'totalPages'?: number;
    /**
     * 
     * @type {number}
     * @memberof PagePrefabDto
     */
    'totalElements'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PagePrefabDto
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PagePrefabDto
     */
    'last'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PagePrefabDto
     */
    'size'?: number;
    /**
     * 
     * @type {Array<PrefabDto>}
     * @memberof PagePrefabDto
     */
    'content'?: Array<PrefabDto>;
    /**
     * 
     * @type {number}
     * @memberof PagePrefabDto
     */
    'number'?: number;
    /**
     * 
     * @type {SortObject}
     * @memberof PagePrefabDto
     */
    'sort'?: SortObject;
    /**
     * 
     * @type {PageableObject}
     * @memberof PagePrefabDto
     */
    'pageable'?: PageableObject;
    /**
     * 
     * @type {number}
     * @memberof PagePrefabDto
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PagePrefabDto
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageTestDto
 */
export interface PageTestDto {
    /**
     * 
     * @type {number}
     * @memberof PageTestDto
     */
    'totalPages'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageTestDto
     */
    'totalElements'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageTestDto
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageTestDto
     */
    'last'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageTestDto
     */
    'size'?: number;
    /**
     * 
     * @type {Array<TestDto>}
     * @memberof PageTestDto
     */
    'content'?: Array<TestDto>;
    /**
     * 
     * @type {number}
     * @memberof PageTestDto
     */
    'number'?: number;
    /**
     * 
     * @type {SortObject}
     * @memberof PageTestDto
     */
    'sort'?: SortObject;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageTestDto
     */
    'pageable'?: PageableObject;
    /**
     * 
     * @type {number}
     * @memberof PageTestDto
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageTestDto
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageTestExecutionDto
 */
export interface PageTestExecutionDto {
    /**
     * 
     * @type {number}
     * @memberof PageTestExecutionDto
     */
    'totalPages'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageTestExecutionDto
     */
    'totalElements'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageTestExecutionDto
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageTestExecutionDto
     */
    'last'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageTestExecutionDto
     */
    'size'?: number;
    /**
     * 
     * @type {Array<TestExecutionDto>}
     * @memberof PageTestExecutionDto
     */
    'content'?: Array<TestExecutionDto>;
    /**
     * 
     * @type {number}
     * @memberof PageTestExecutionDto
     */
    'number'?: number;
    /**
     * 
     * @type {SortObject}
     * @memberof PageTestExecutionDto
     */
    'sort'?: SortObject;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageTestExecutionDto
     */
    'pageable'?: PageableObject;
    /**
     * 
     * @type {number}
     * @memberof PageTestExecutionDto
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageTestExecutionDto
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageTestPlanDto
 */
export interface PageTestPlanDto {
    /**
     * 
     * @type {number}
     * @memberof PageTestPlanDto
     */
    'totalPages'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageTestPlanDto
     */
    'totalElements'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageTestPlanDto
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageTestPlanDto
     */
    'last'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageTestPlanDto
     */
    'size'?: number;
    /**
     * 
     * @type {Array<TestPlanDto>}
     * @memberof PageTestPlanDto
     */
    'content'?: Array<TestPlanDto>;
    /**
     * 
     * @type {number}
     * @memberof PageTestPlanDto
     */
    'number'?: number;
    /**
     * 
     * @type {SortObject}
     * @memberof PageTestPlanDto
     */
    'sort'?: SortObject;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageTestPlanDto
     */
    'pageable'?: PageableObject;
    /**
     * 
     * @type {number}
     * @memberof PageTestPlanDto
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageTestPlanDto
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageTestPlanTaskResponse
 */
export interface PageTestPlanTaskResponse {
    /**
     * 
     * @type {number}
     * @memberof PageTestPlanTaskResponse
     */
    'totalPages'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageTestPlanTaskResponse
     */
    'totalElements'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageTestPlanTaskResponse
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageTestPlanTaskResponse
     */
    'last'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageTestPlanTaskResponse
     */
    'size'?: number;
    /**
     * 
     * @type {Array<TestPlanTaskResponse>}
     * @memberof PageTestPlanTaskResponse
     */
    'content'?: Array<TestPlanTaskResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageTestPlanTaskResponse
     */
    'number'?: number;
    /**
     * 
     * @type {SortObject}
     * @memberof PageTestPlanTaskResponse
     */
    'sort'?: SortObject;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageTestPlanTaskResponse
     */
    'pageable'?: PageableObject;
    /**
     * 
     * @type {number}
     * @memberof PageTestPlanTaskResponse
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageTestPlanTaskResponse
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface Pageable
 */
export interface Pageable {
    /**
     * 
     * @type {number}
     * @memberof Pageable
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof Pageable
     */
    'size'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof Pageable
     */
    'sort'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PageableObject
 */
export interface PageableObject {
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    'offset'?: number;
    /**
     * 
     * @type {SortObject}
     * @memberof PageableObject
     */
    'sort'?: SortObject;
    /**
     * 
     * @type {boolean}
     * @memberof PageableObject
     */
    'paged'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    'pageNumber'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    'pageSize'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageableObject
     */
    'unpaged'?: boolean;
}
/**
 * 
 * @export
 * @interface PagedModelEntityModelPassword
 */
export interface PagedModelEntityModelPassword {
    /**
     * 
     * @type {PagedModelEntityModelPasswordEmbedded}
     * @memberof PagedModelEntityModelPassword
     */
    '_embedded'?: PagedModelEntityModelPasswordEmbedded;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof PagedModelEntityModelPassword
     */
    '_links'?: { [key: string]: Link; };
    /**
     * 
     * @type {PageMetadata}
     * @memberof PagedModelEntityModelPassword
     */
    'page'?: PageMetadata;
}
/**
 * 
 * @export
 * @interface PagedModelEntityModelPasswordEmbedded
 */
export interface PagedModelEntityModelPasswordEmbedded {
    /**
     * 
     * @type {Array<EntityModelPassword>}
     * @memberof PagedModelEntityModelPasswordEmbedded
     */
    'passwords'?: Array<EntityModelPassword>;
}
/**
 * 
 * @export
 * @interface PagedModelEntityModelPlaywrightConfiguration
 */
export interface PagedModelEntityModelPlaywrightConfiguration {
    /**
     * 
     * @type {PagedModelEntityModelPlaywrightConfigurationEmbedded}
     * @memberof PagedModelEntityModelPlaywrightConfiguration
     */
    '_embedded'?: PagedModelEntityModelPlaywrightConfigurationEmbedded;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof PagedModelEntityModelPlaywrightConfiguration
     */
    '_links'?: { [key: string]: Link; };
    /**
     * 
     * @type {PageMetadata}
     * @memberof PagedModelEntityModelPlaywrightConfiguration
     */
    'page'?: PageMetadata;
}
/**
 * 
 * @export
 * @interface PagedModelEntityModelPlaywrightConfigurationEmbedded
 */
export interface PagedModelEntityModelPlaywrightConfigurationEmbedded {
    /**
     * 
     * @type {Array<EntityModelPlaywrightConfiguration>}
     * @memberof PagedModelEntityModelPlaywrightConfigurationEmbedded
     */
    'playwrightConfigurations'?: Array<EntityModelPlaywrightConfiguration>;
}
/**
 * 
 * @export
 * @interface PagedModelEntityModelRequest
 */
export interface PagedModelEntityModelRequest {
    /**
     * 
     * @type {PagedModelEntityModelRequestEmbedded}
     * @memberof PagedModelEntityModelRequest
     */
    '_embedded'?: PagedModelEntityModelRequestEmbedded;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof PagedModelEntityModelRequest
     */
    '_links'?: { [key: string]: Link; };
    /**
     * 
     * @type {PageMetadata}
     * @memberof PagedModelEntityModelRequest
     */
    'page'?: PageMetadata;
}
/**
 * 
 * @export
 * @interface PagedModelEntityModelRequestEmbedded
 */
export interface PagedModelEntityModelRequestEmbedded {
    /**
     * 
     * @type {Array<EntityModelRequest>}
     * @memberof PagedModelEntityModelRequestEmbedded
     */
    'requests'?: Array<EntityModelRequest>;
}
/**
 * 
 * @export
 * @interface PagedModelEntityModelScheduledTestPlanTask
 */
export interface PagedModelEntityModelScheduledTestPlanTask {
    /**
     * 
     * @type {PagedModelEntityModelScheduledTestPlanTaskEmbedded}
     * @memberof PagedModelEntityModelScheduledTestPlanTask
     */
    '_embedded'?: PagedModelEntityModelScheduledTestPlanTaskEmbedded;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof PagedModelEntityModelScheduledTestPlanTask
     */
    '_links'?: { [key: string]: Link; };
    /**
     * 
     * @type {PageMetadata}
     * @memberof PagedModelEntityModelScheduledTestPlanTask
     */
    'page'?: PageMetadata;
}
/**
 * 
 * @export
 * @interface PagedModelEntityModelScheduledTestPlanTaskEmbedded
 */
export interface PagedModelEntityModelScheduledTestPlanTaskEmbedded {
    /**
     * 
     * @type {Array<EntityModelScheduledTestPlanTask>}
     * @memberof PagedModelEntityModelScheduledTestPlanTaskEmbedded
     */
    'scheduledTestPlanTasks'?: Array<EntityModelScheduledTestPlanTask>;
}
/**
 * 
 * @export
 * @interface PagedModelEntityModelSystem
 */
export interface PagedModelEntityModelSystem {
    /**
     * 
     * @type {PagedModelEntityModelSystemEmbedded}
     * @memberof PagedModelEntityModelSystem
     */
    '_embedded'?: PagedModelEntityModelSystemEmbedded;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof PagedModelEntityModelSystem
     */
    '_links'?: { [key: string]: Link; };
    /**
     * 
     * @type {PageMetadata}
     * @memberof PagedModelEntityModelSystem
     */
    'page'?: PageMetadata;
}
/**
 * 
 * @export
 * @interface PagedModelEntityModelSystemEmbedded
 */
export interface PagedModelEntityModelSystemEmbedded {
    /**
     * 
     * @type {Array<EntityModelSystem>}
     * @memberof PagedModelEntityModelSystemEmbedded
     */
    'systems'?: Array<EntityModelSystem>;
}
/**
 * 
 * @export
 * @interface PagedModelEntityModelTestExecution
 */
export interface PagedModelEntityModelTestExecution {
    /**
     * 
     * @type {PagedModelEntityModelTestExecutionEmbedded}
     * @memberof PagedModelEntityModelTestExecution
     */
    '_embedded'?: PagedModelEntityModelTestExecutionEmbedded;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof PagedModelEntityModelTestExecution
     */
    '_links'?: { [key: string]: Link; };
    /**
     * 
     * @type {PageMetadata}
     * @memberof PagedModelEntityModelTestExecution
     */
    'page'?: PageMetadata;
}
/**
 * 
 * @export
 * @interface PagedModelEntityModelTestExecutionEmbedded
 */
export interface PagedModelEntityModelTestExecutionEmbedded {
    /**
     * 
     * @type {Array<EntityModelTestExecution>}
     * @memberof PagedModelEntityModelTestExecutionEmbedded
     */
    'testExecutions'?: Array<EntityModelTestExecution>;
}
/**
 * 
 * @export
 * @interface PagedModelEntityModelTestPauseData
 */
export interface PagedModelEntityModelTestPauseData {
    /**
     * 
     * @type {PagedModelEntityModelTestPauseDataEmbedded}
     * @memberof PagedModelEntityModelTestPauseData
     */
    '_embedded'?: PagedModelEntityModelTestPauseDataEmbedded;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof PagedModelEntityModelTestPauseData
     */
    '_links'?: { [key: string]: Link; };
    /**
     * 
     * @type {PageMetadata}
     * @memberof PagedModelEntityModelTestPauseData
     */
    'page'?: PageMetadata;
}
/**
 * 
 * @export
 * @interface PagedModelEntityModelTestPauseDataEmbedded
 */
export interface PagedModelEntityModelTestPauseDataEmbedded {
    /**
     * 
     * @type {Array<EntityModelTestPauseData>}
     * @memberof PagedModelEntityModelTestPauseDataEmbedded
     */
    'testPauseDatas'?: Array<EntityModelTestPauseData>;
}
/**
 * 
 * @export
 * @interface PagedModelEntityModelTestResult
 */
export interface PagedModelEntityModelTestResult {
    /**
     * 
     * @type {PagedModelEntityModelTestResultEmbedded}
     * @memberof PagedModelEntityModelTestResult
     */
    '_embedded'?: PagedModelEntityModelTestResultEmbedded;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof PagedModelEntityModelTestResult
     */
    '_links'?: { [key: string]: Link; };
    /**
     * 
     * @type {PageMetadata}
     * @memberof PagedModelEntityModelTestResult
     */
    'page'?: PageMetadata;
}
/**
 * 
 * @export
 * @interface PagedModelEntityModelTestResultEmbedded
 */
export interface PagedModelEntityModelTestResultEmbedded {
    /**
     * 
     * @type {Array<EntityModelTestResult>}
     * @memberof PagedModelEntityModelTestResultEmbedded
     */
    'testResults'?: Array<EntityModelTestResult>;
}
/**
 * 
 * @export
 * @interface PagedModelEntityModelTrace
 */
export interface PagedModelEntityModelTrace {
    /**
     * 
     * @type {PagedModelEntityModelTraceEmbedded}
     * @memberof PagedModelEntityModelTrace
     */
    '_embedded'?: PagedModelEntityModelTraceEmbedded;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof PagedModelEntityModelTrace
     */
    '_links'?: { [key: string]: Link; };
    /**
     * 
     * @type {PageMetadata}
     * @memberof PagedModelEntityModelTrace
     */
    'page'?: PageMetadata;
}
/**
 * 
 * @export
 * @interface PagedModelEntityModelTraceEmbedded
 */
export interface PagedModelEntityModelTraceEmbedded {
    /**
     * 
     * @type {Array<EntityModelTrace>}
     * @memberof PagedModelEntityModelTraceEmbedded
     */
    'traces'?: Array<EntityModelTrace>;
}
/**
 * 
 * @export
 * @interface ParameterObjectObject
 */
export interface ParameterObjectObject {
    /**
     * 
     * @type {string}
     * @memberof ParameterObjectObject
     */
    'name'?: string;
    /**
     * 
     * @type {TypeInformationObject}
     * @memberof ParameterObjectObject
     */
    'type'?: TypeInformationObject;
    /**
     * 
     * @type {object}
     * @memberof ParameterObjectObject
     */
    'annotations'?: object;
    /**
     * 
     * @type {string}
     * @memberof ParameterObjectObject
     */
    'requiredValueExpression'?: string;
    /**
     * 
     * @type {string}
     * @memberof ParameterObjectObject
     */
    'spelExpression'?: string;
    /**
     * 
     * @type {string}
     * @memberof ParameterObjectObject
     */
    'valueExpression'?: string;
}
/**
 * 
 * @export
 * @interface ParameterObjectPersistentPropertyObject
 */
export interface ParameterObjectPersistentPropertyObject {
    /**
     * 
     * @type {string}
     * @memberof ParameterObjectPersistentPropertyObject
     */
    'name'?: string;
    /**
     * 
     * @type {TypeInformationObject}
     * @memberof ParameterObjectPersistentPropertyObject
     */
    'type'?: TypeInformationObject;
    /**
     * 
     * @type {object}
     * @memberof ParameterObjectPersistentPropertyObject
     */
    'annotations'?: object;
    /**
     * 
     * @type {string}
     * @memberof ParameterObjectPersistentPropertyObject
     */
    'requiredValueExpression'?: string;
    /**
     * 
     * @type {string}
     * @memberof ParameterObjectPersistentPropertyObject
     */
    'spelExpression'?: string;
    /**
     * 
     * @type {string}
     * @memberof ParameterObjectPersistentPropertyObject
     */
    'valueExpression'?: string;
}
/**
 * 
 * @export
 * @interface Password
 */
export interface Password {
    /**
     * 
     * @type {number}
     * @memberof Password
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Password
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Password
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof Password
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface PasswordDto
 */
export interface PasswordDto {
    /**
     * 
     * @type {number}
     * @memberof PasswordDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PasswordDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordDto
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordDto
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface PasswordRequestBody
 */
export interface PasswordRequestBody {
    /**
     * 
     * @type {number}
     * @memberof PasswordRequestBody
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PasswordRequestBody
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordRequestBody
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordRequestBody
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface PersistentEntityObjectObject
 */
export interface PersistentEntityObjectObject {
    /**
     * 
     * @type {string}
     * @memberof PersistentEntityObjectObject
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentEntityObjectObject
     */
    'immutable'?: boolean;
    /**
     * 
     * @type {PreferredConstructorObjectObject}
     * @memberof PersistentEntityObjectObject
     */
    'persistenceConstructor'?: PreferredConstructorObjectObject;
    /**
     * 
     * @type {InstanceCreatorMetadataObject}
     * @memberof PersistentEntityObjectObject
     */
    'instanceCreatorMetadata'?: InstanceCreatorMetadataObject;
    /**
     * 
     * @type {object}
     * @memberof PersistentEntityObjectObject
     */
    'requiredVersionProperty'?: object;
    /**
     * 
     * @type {object}
     * @memberof PersistentEntityObjectObject
     */
    'idProperty'?: object;
    /**
     * 
     * @type {Alias}
     * @memberof PersistentEntityObjectObject
     */
    'typeAlias'?: Alias;
    /**
     * 
     * @type {object}
     * @memberof PersistentEntityObjectObject
     */
    'versionProperty'?: object;
    /**
     * 
     * @type {object}
     * @memberof PersistentEntityObjectObject
     */
    'requiredIdProperty'?: object;
    /**
     * 
     * @type {TypeInformationObject}
     * @memberof PersistentEntityObjectObject
     */
    'typeInformation'?: TypeInformationObject;
}
/**
 * 
 * @export
 * @interface PersistentEntityObjectPersistentPropertyObject
 */
export interface PersistentEntityObjectPersistentPropertyObject {
    /**
     * 
     * @type {string}
     * @memberof PersistentEntityObjectPersistentPropertyObject
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentEntityObjectPersistentPropertyObject
     */
    'immutable'?: boolean;
    /**
     * 
     * @type {PreferredConstructorObjectPersistentPropertyObject}
     * @memberof PersistentEntityObjectPersistentPropertyObject
     */
    'persistenceConstructor'?: PreferredConstructorObjectPersistentPropertyObject;
    /**
     * 
     * @type {InstanceCreatorMetadataPersistentPropertyObject}
     * @memberof PersistentEntityObjectPersistentPropertyObject
     */
    'instanceCreatorMetadata'?: InstanceCreatorMetadataPersistentPropertyObject;
    /**
     * 
     * @type {PersistentPropertyObject}
     * @memberof PersistentEntityObjectPersistentPropertyObject
     */
    'requiredVersionProperty'?: PersistentPropertyObject;
    /**
     * 
     * @type {PersistentPropertyObject}
     * @memberof PersistentEntityObjectPersistentPropertyObject
     */
    'idProperty'?: PersistentPropertyObject;
    /**
     * 
     * @type {Alias}
     * @memberof PersistentEntityObjectPersistentPropertyObject
     */
    'typeAlias'?: Alias;
    /**
     * 
     * @type {PersistentPropertyObject}
     * @memberof PersistentEntityObjectPersistentPropertyObject
     */
    'versionProperty'?: PersistentPropertyObject;
    /**
     * 
     * @type {PersistentPropertyObject}
     * @memberof PersistentEntityObjectPersistentPropertyObject
     */
    'requiredIdProperty'?: PersistentPropertyObject;
    /**
     * 
     * @type {TypeInformationObject}
     * @memberof PersistentEntityObjectPersistentPropertyObject
     */
    'typeInformation'?: TypeInformationObject;
}
/**
 * 
 * @export
 * @interface PersistentEntityResource
 */
export interface PersistentEntityResource {
    /**
     * 
     * @type {object}
     * @memberof PersistentEntityResource
     */
    'content'?: object;
    /**
     * 
     * @type {object}
     * @memberof PersistentEntityResource
     */
    'embeddeds'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentEntityResource
     */
    'nested'?: boolean;
    /**
     * 
     * @type {object}
     * @memberof PersistentEntityResource
     */
    'target'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentEntityResource
     */
    'new'?: boolean;
    /**
     * 
     * @type {PersistentPropertyAccessorObject}
     * @memberof PersistentEntityResource
     */
    'propertyAccessor'?: PersistentPropertyAccessorObject;
    /**
     * 
     * @type {PersistentEntityObjectPersistentPropertyObject}
     * @memberof PersistentEntityResource
     */
    'persistentEntity'?: PersistentEntityObjectPersistentPropertyObject;
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof PersistentEntityResource
     */
    '_links'?: { [key: string]: Link; };
}
/**
 * 
 * @export
 * @interface PersistentPropertyAccessorObject
 */
export interface PersistentPropertyAccessorObject {
    /**
     * 
     * @type {object}
     * @memberof PersistentPropertyAccessorObject
     */
    'bean'?: object;
}
/**
 * 
 * @export
 * @interface PersistentPropertyObject
 */
export interface PersistentPropertyObject {
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObject
     */
    'entity'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PersistentPropertyObject
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObject
     */
    'array'?: boolean;
    /**
     * 
     * @type {PersistentPropertyObjectField}
     * @memberof PersistentPropertyObject
     */
    'field'?: PersistentPropertyObjectField;
    /**
     * 
     * @type {PersistentEntityObjectObject}
     * @memberof PersistentPropertyObject
     */
    'owner'?: PersistentEntityObjectObject;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObject
     */
    'transient'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObject
     */
    'readable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObject
     */
    'writable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObject
     */
    'immutable'?: boolean;
    /**
     * 
     * @type {object}
     * @memberof PersistentPropertyObject
     */
    'persistentEntityTypeInformation'?: object;
    /**
     * 
     * @type {TypeInformationObject}
     * @memberof PersistentPropertyObject
     */
    'associationTargetTypeInformation'?: TypeInformationObject;
    /**
     * 
     * @type {PersistentPropertyObjectWither}
     * @memberof PersistentPropertyObject
     */
    'wither'?: PersistentPropertyObjectWither;
    /**
     * 
     * @type {AssociationObject}
     * @memberof PersistentPropertyObject
     */
    'association'?: AssociationObject;
    /**
     * 
     * @type {PersistentPropertyObjectWither}
     * @memberof PersistentPropertyObject
     */
    'setter'?: PersistentPropertyObjectWither;
    /**
     * 
     * @type {PersistentPropertyObjectWither}
     * @memberof PersistentPropertyObject
     */
    'getter'?: PersistentPropertyObjectWither;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObject
     */
    'idProperty'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObject
     */
    'map'?: boolean;
    /**
     * 
     * @type {PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration}
     * @memberof PersistentPropertyObject
     */
    'requiredGetter'?: PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration;
    /**
     * 
     * @type {PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration}
     * @memberof PersistentPropertyObject
     */
    'requiredSetter'?: PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration;
    /**
     * 
     * @type {PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration}
     * @memberof PersistentPropertyObject
     */
    'requiredWither'?: PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration;
    /**
     * 
     * @type {PersistentPropertyObjectField}
     * @memberof PersistentPropertyObject
     */
    'requiredField'?: PersistentPropertyObjectField;
    /**
     * 
     * @type {string}
     * @memberof PersistentPropertyObject
     */
    'spelExpression'?: string;
    /**
     * 
     * @type {AssociationObject}
     * @memberof PersistentPropertyObject
     */
    'requiredAssociation'?: AssociationObject;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObject
     */
    'versionProperty'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObject
     */
    'collectionLike'?: boolean;
    /**
     * 
     * @type {TypeInformationObject}
     * @memberof PersistentPropertyObject
     */
    'typeInformation'?: TypeInformationObject;
}
/**
 * 
 * @export
 * @interface PersistentPropertyObjectField
 */
export interface PersistentPropertyObjectField {
    /**
     * 
     * @type {string}
     * @memberof PersistentPropertyObjectField
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof PersistentPropertyObjectField
     */
    'modifiers'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObjectField
     */
    'synthetic'?: boolean;
    /**
     * 
     * @type {Array<object>}
     * @memberof PersistentPropertyObjectField
     */
    'declaredAnnotations'?: Array<object>;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObjectField
     * @deprecated
     */
    'accessible'?: boolean;
    /**
     * 
     * @type {PersistentPropertyObjectFieldGenericType}
     * @memberof PersistentPropertyObjectField
     */
    'genericType'?: PersistentPropertyObjectFieldGenericType;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObjectField
     */
    'enumConstant'?: boolean;
    /**
     * 
     * @type {PersistentPropertyObjectFieldAnnotatedType}
     * @memberof PersistentPropertyObjectField
     */
    'annotatedType'?: PersistentPropertyObjectFieldAnnotatedType;
    /**
     * 
     * @type {Array<object>}
     * @memberof PersistentPropertyObjectField
     */
    'annotations'?: Array<object>;
}
/**
 * 
 * @export
 * @interface PersistentPropertyObjectFieldAnnotatedType
 */
export interface PersistentPropertyObjectFieldAnnotatedType {
    /**
     * 
     * @type {Array<object>}
     * @memberof PersistentPropertyObjectFieldAnnotatedType
     */
    'annotations'?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof PersistentPropertyObjectFieldAnnotatedType
     */
    'declaredAnnotations'?: Array<object>;
    /**
     * 
     * @type {PersistentPropertyObjectFieldGenericType}
     * @memberof PersistentPropertyObjectFieldAnnotatedType
     */
    'type'?: PersistentPropertyObjectFieldGenericType;
}
/**
 * 
 * @export
 * @interface PersistentPropertyObjectFieldGenericType
 */
export interface PersistentPropertyObjectFieldGenericType {
    /**
     * 
     * @type {string}
     * @memberof PersistentPropertyObjectFieldGenericType
     */
    'typeName'?: string;
}
/**
 * 
 * @export
 * @interface PersistentPropertyObjectWither
 */
export interface PersistentPropertyObjectWither {
    /**
     * 
     * @type {string}
     * @memberof PersistentPropertyObjectWither
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof PersistentPropertyObjectWither
     */
    'modifiers'?: number;
    /**
     * 
     * @type {Array<PersistentPropertyObjectWitherTypeParametersInner>}
     * @memberof PersistentPropertyObjectWither
     */
    'typeParameters'?: Array<PersistentPropertyObjectWitherTypeParametersInner>;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObjectWither
     */
    'synthetic'?: boolean;
    /**
     * 
     * @type {Array<object>}
     * @memberof PersistentPropertyObjectWither
     */
    'declaredAnnotations'?: Array<object>;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObjectWither
     * @deprecated
     */
    'accessible'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObjectWither
     */
    'varArgs'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PersistentPropertyObjectWither
     */
    'parameterCount'?: number;
    /**
     * 
     * @type {Array<Array<object>>}
     * @memberof PersistentPropertyObjectWither
     */
    'parameterAnnotations'?: Array<Array<object>>;
    /**
     * 
     * @type {Array<PersistentPropertyObjectFieldGenericType>}
     * @memberof PersistentPropertyObjectWither
     */
    'genericParameterTypes'?: Array<PersistentPropertyObjectFieldGenericType>;
    /**
     * 
     * @type {Array<PersistentPropertyObjectFieldGenericType>}
     * @memberof PersistentPropertyObjectWither
     */
    'genericExceptionTypes'?: Array<PersistentPropertyObjectFieldGenericType>;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObjectWither
     */
    'default'?: boolean;
    /**
     * 
     * @type {PersistentPropertyObjectFieldGenericType}
     * @memberof PersistentPropertyObjectWither
     */
    'genericReturnType'?: PersistentPropertyObjectFieldGenericType;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObjectWither
     */
    'bridge'?: boolean;
    /**
     * 
     * @type {object}
     * @memberof PersistentPropertyObjectWither
     */
    'defaultValue'?: object;
    /**
     * 
     * @type {PersistentPropertyObjectFieldAnnotatedType}
     * @memberof PersistentPropertyObjectWither
     */
    'annotatedReturnType'?: PersistentPropertyObjectFieldAnnotatedType;
    /**
     * 
     * @type {Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationAnnotatedParameterTypesInner>}
     * @memberof PersistentPropertyObjectWither
     */
    'annotatedParameterTypes'?: Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationAnnotatedParameterTypesInner>;
    /**
     * 
     * @type {Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInner>}
     * @memberof PersistentPropertyObjectWither
     */
    'parameters'?: Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInner>;
    /**
     * 
     * @type {PersistentPropertyObjectFieldAnnotatedType}
     * @memberof PersistentPropertyObjectWither
     */
    'annotatedReceiverType'?: PersistentPropertyObjectFieldAnnotatedType;
    /**
     * 
     * @type {Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationAnnotatedParameterTypesInner>}
     * @memberof PersistentPropertyObjectWither
     */
    'annotatedExceptionTypes'?: Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationAnnotatedParameterTypesInner>;
    /**
     * 
     * @type {Array<object>}
     * @memberof PersistentPropertyObjectWither
     */
    'annotations'?: Array<object>;
}
/**
 * 
 * @export
 * @interface PersistentPropertyObjectWitherTypeParametersInner
 */
export interface PersistentPropertyObjectWitherTypeParametersInner {
    /**
     * 
     * @type {PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration}
     * @memberof PersistentPropertyObjectWitherTypeParametersInner
     */
    'genericDeclaration'?: PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration;
    /**
     * 
     * @type {Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationAnnotatedParameterTypesInner>}
     * @memberof PersistentPropertyObjectWitherTypeParametersInner
     */
    'annotatedBounds'?: Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationAnnotatedParameterTypesInner>;
    /**
     * 
     * @type {string}
     * @memberof PersistentPropertyObjectWitherTypeParametersInner
     */
    'name'?: string;
    /**
     * 
     * @type {Array<PersistentPropertyObjectFieldGenericType>}
     * @memberof PersistentPropertyObjectWitherTypeParametersInner
     */
    'bounds'?: Array<PersistentPropertyObjectFieldGenericType>;
    /**
     * 
     * @type {string}
     * @memberof PersistentPropertyObjectWitherTypeParametersInner
     */
    'typeName'?: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof PersistentPropertyObjectWitherTypeParametersInner
     */
    'annotations'?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof PersistentPropertyObjectWitherTypeParametersInner
     */
    'declaredAnnotations'?: Array<object>;
}
/**
 * 
 * @export
 * @interface PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration
 */
export interface PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration {
    /**
     * 
     * @type {string}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration
     */
    'modifiers'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration
     */
    'synthetic'?: boolean;
    /**
     * 
     * @type {Array<object>}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration
     */
    'declaredAnnotations'?: Array<object>;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration
     * @deprecated
     */
    'accessible'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration
     */
    'varArgs'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration
     */
    'parameterCount'?: number;
    /**
     * 
     * @type {Array<Array<object>>}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration
     */
    'parameterAnnotations'?: Array<Array<object>>;
    /**
     * 
     * @type {Array<PersistentPropertyObjectFieldGenericType>}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration
     */
    'genericParameterTypes'?: Array<PersistentPropertyObjectFieldGenericType>;
    /**
     * 
     * @type {Array<PersistentPropertyObjectFieldGenericType>}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration
     */
    'genericExceptionTypes'?: Array<PersistentPropertyObjectFieldGenericType>;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration
     */
    'default'?: boolean;
    /**
     * 
     * @type {PersistentPropertyObjectFieldGenericType}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration
     */
    'genericReturnType'?: PersistentPropertyObjectFieldGenericType;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration
     */
    'bridge'?: boolean;
    /**
     * 
     * @type {object}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration
     */
    'defaultValue'?: object;
    /**
     * 
     * @type {PersistentPropertyObjectFieldAnnotatedType}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration
     */
    'annotatedReturnType'?: PersistentPropertyObjectFieldAnnotatedType;
    /**
     * 
     * @type {Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationAnnotatedParameterTypesInner>}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration
     */
    'annotatedParameterTypes'?: Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationAnnotatedParameterTypesInner>;
    /**
     * 
     * @type {Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInner>}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration
     */
    'parameters'?: Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInner>;
    /**
     * 
     * @type {PersistentPropertyObjectFieldAnnotatedType}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration
     */
    'annotatedReceiverType'?: PersistentPropertyObjectFieldAnnotatedType;
    /**
     * 
     * @type {Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationAnnotatedParameterTypesInner>}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration
     */
    'annotatedExceptionTypes'?: Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationAnnotatedParameterTypesInner>;
    /**
     * 
     * @type {Array<object>}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclaration
     */
    'annotations'?: Array<object>;
}
/**
 * 
 * @export
 * @interface PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationAnnotatedParameterTypesInner
 */
export interface PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationAnnotatedParameterTypesInner {
    /**
     * 
     * @type {PersistentPropertyObjectFieldAnnotatedType}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationAnnotatedParameterTypesInner
     */
    'annotatedOwnerType'?: PersistentPropertyObjectFieldAnnotatedType;
    /**
     * 
     * @type {Array<object>}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationAnnotatedParameterTypesInner
     */
    'annotations'?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationAnnotatedParameterTypesInner
     */
    'declaredAnnotations'?: Array<object>;
    /**
     * 
     * @type {PersistentPropertyObjectFieldGenericType}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationAnnotatedParameterTypesInner
     */
    'type'?: PersistentPropertyObjectFieldGenericType;
}
/**
 * 
 * @export
 * @interface PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInner
 */
export interface PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInner {
    /**
     * 
     * @type {string}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInner
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInner
     */
    'modifiers'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInner
     */
    'synthetic'?: boolean;
    /**
     * 
     * @type {Array<object>}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInner
     */
    'annotations'?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInner
     */
    'declaredAnnotations'?: Array<object>;
    /**
     * 
     * @type {PersistentPropertyObjectFieldAnnotatedType}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInner
     */
    'annotatedType'?: PersistentPropertyObjectFieldAnnotatedType;
    /**
     * 
     * @type {PersistentPropertyObjectFieldGenericType}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInner
     */
    'parameterizedType'?: PersistentPropertyObjectFieldGenericType;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInner
     */
    'varArgs'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInner
     */
    'namePresent'?: boolean;
    /**
     * 
     * @type {PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutable}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInner
     */
    'declaringExecutable'?: PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutable;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInner
     */
    'implicit'?: boolean;
}
/**
 * 
 * @export
 * @interface PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutable
 */
export interface PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutable {
    /**
     * 
     * @type {string}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutable
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutable
     */
    'modifiers'?: number;
    /**
     * 
     * @type {Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutableTypeParametersInner>}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutable
     */
    'typeParameters'?: Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutableTypeParametersInner>;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutable
     */
    'synthetic'?: boolean;
    /**
     * 
     * @type {Array<object>}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutable
     */
    'declaredAnnotations'?: Array<object>;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutable
     */
    'varArgs'?: boolean;
    /**
     * 
     * @type {Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationAnnotatedParameterTypesInner>}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutable
     */
    'annotatedParameterTypes'?: Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationAnnotatedParameterTypesInner>;
    /**
     * 
     * @type {number}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutable
     */
    'parameterCount'?: number;
    /**
     * 
     * @type {Array<Array<object>>}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutable
     */
    'parameterAnnotations'?: Array<Array<object>>;
    /**
     * 
     * @type {Array<PersistentPropertyObjectFieldGenericType>}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutable
     */
    'genericParameterTypes'?: Array<PersistentPropertyObjectFieldGenericType>;
    /**
     * 
     * @type {Array<PersistentPropertyObjectFieldGenericType>}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutable
     */
    'genericExceptionTypes'?: Array<PersistentPropertyObjectFieldGenericType>;
    /**
     * 
     * @type {PersistentPropertyObjectFieldAnnotatedType}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutable
     */
    'annotatedReturnType'?: PersistentPropertyObjectFieldAnnotatedType;
    /**
     * 
     * @type {PersistentPropertyObjectFieldAnnotatedType}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutable
     */
    'annotatedReceiverType'?: PersistentPropertyObjectFieldAnnotatedType;
    /**
     * 
     * @type {Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationAnnotatedParameterTypesInner>}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutable
     */
    'annotatedExceptionTypes'?: Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationAnnotatedParameterTypesInner>;
    /**
     * 
     * @type {Array<object>}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutable
     */
    'annotations'?: Array<object>;
    /**
     * 
     * @type {boolean}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutable
     * @deprecated
     */
    'accessible'?: boolean;
}
/**
 * 
 * @export
 * @interface PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutableTypeParametersInner
 */
export interface PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutableTypeParametersInner {
    /**
     * 
     * @type {object}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutableTypeParametersInner
     */
    'genericDeclaration'?: object;
    /**
     * 
     * @type {Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationAnnotatedParameterTypesInner>}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutableTypeParametersInner
     */
    'annotatedBounds'?: Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationAnnotatedParameterTypesInner>;
    /**
     * 
     * @type {string}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutableTypeParametersInner
     */
    'name'?: string;
    /**
     * 
     * @type {Array<PersistentPropertyObjectFieldGenericType>}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutableTypeParametersInner
     */
    'bounds'?: Array<PersistentPropertyObjectFieldGenericType>;
    /**
     * 
     * @type {string}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutableTypeParametersInner
     */
    'typeName'?: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutableTypeParametersInner
     */
    'annotations'?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInnerDeclaringExecutableTypeParametersInner
     */
    'declaredAnnotations'?: Array<object>;
}
/**
 * 
 * @export
 * @interface PlaywrightConfiguration
 */
export interface PlaywrightConfiguration {
    /**
     * 
     * @type {number}
     * @memberof PlaywrightConfiguration
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaywrightConfiguration
     */
    'configName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PlaywrightConfiguration
     */
    'headless'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PlaywrightConfiguration
     */
    'viewPortHeight'?: number;
    /**
     * 
     * @type {number}
     * @memberof PlaywrightConfiguration
     */
    'viewPortWidth'?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaywrightConfiguration
     */
    'locale'?: string;
    /**
     * 
     * @type {Proxy}
     * @memberof PlaywrightConfiguration
     */
    'proxy'?: Proxy;
    /**
     * 
     * @type {boolean}
     * @memberof PlaywrightConfiguration
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface PlaywrightConfigurationDto
 */
export interface PlaywrightConfigurationDto {
    /**
     * 
     * @type {number}
     * @memberof PlaywrightConfigurationDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaywrightConfigurationDto
     */
    'configName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PlaywrightConfigurationDto
     */
    'headless'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PlaywrightConfigurationDto
     */
    'viewPortHeight'?: number;
    /**
     * 
     * @type {number}
     * @memberof PlaywrightConfigurationDto
     */
    'viewPortWidth'?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaywrightConfigurationDto
     */
    'locale'?: string;
    /**
     * 
     * @type {ProxyDto}
     * @memberof PlaywrightConfigurationDto
     */
    'proxy'?: ProxyDto;
    /**
     * 
     * @type {boolean}
     * @memberof PlaywrightConfigurationDto
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface PlaywrightConfigurationRequestBody
 */
export interface PlaywrightConfigurationRequestBody {
    /**
     * 
     * @type {number}
     * @memberof PlaywrightConfigurationRequestBody
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaywrightConfigurationRequestBody
     */
    'configName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PlaywrightConfigurationRequestBody
     */
    'headless'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PlaywrightConfigurationRequestBody
     */
    'viewPortHeight'?: number;
    /**
     * 
     * @type {number}
     * @memberof PlaywrightConfigurationRequestBody
     */
    'viewPortWidth'?: number;
    /**
     * 
     * @type {string}
     * @memberof PlaywrightConfigurationRequestBody
     */
    'locale'?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaywrightConfigurationRequestBody
     */
    'proxy'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PlaywrightConfigurationRequestBody
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface Position
 */
export interface Position {
    /**
     * 
     * @type {number}
     * @memberof Position
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof Position
     */
    'y'?: number;
}
/**
 * 
 * @export
 * @interface PrefabDto
 */
export interface PrefabDto {
    /**
     * 
     * @type {number}
     * @memberof PrefabDto
     */
    'id'?: number;
    /**
     * 
     * @type {SystemDto}
     * @memberof PrefabDto
     */
    'system': SystemDto;
    /**
     * 
     * @type {string}
     * @memberof PrefabDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrefabDto
     */
    'description'?: string;
    /**
     * 
     * @type {Array<CommandDto>}
     * @memberof PrefabDto
     */
    'commandDtos'?: Array<CommandDto>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PrefabDto
     */
    'predefinedVariables'?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface PreferredConstructorObjectObject
 */
export interface PreferredConstructorObjectObject {
    /**
     * 
     * @type {Array<ParameterObjectObject>}
     * @memberof PreferredConstructorObjectObject
     */
    'parameters'?: Array<ParameterObjectObject>;
    /**
     * 
     * @type {PreferredConstructorObjectObjectConstructor}
     * @memberof PreferredConstructorObjectObject
     */
    'constructor'?: PreferredConstructorObjectObjectConstructor;
    /**
     * 
     * @type {boolean}
     * @memberof PreferredConstructorObjectObject
     */
    'noArgConstructor'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PreferredConstructorObjectObject
     */
    'explicitlyAnnotated'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PreferredConstructorObjectObject
     */
    'parameterCount'?: number;
}
/**
 * 
 * @export
 * @interface PreferredConstructorObjectObjectConstructor
 */
export interface PreferredConstructorObjectObjectConstructor {
    /**
     * 
     * @type {string}
     * @memberof PreferredConstructorObjectObjectConstructor
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof PreferredConstructorObjectObjectConstructor
     */
    'modifiers'?: number;
    /**
     * 
     * @type {Array<PreferredConstructorObjectObjectConstructorTypeParametersInner>}
     * @memberof PreferredConstructorObjectObjectConstructor
     */
    'typeParameters'?: Array<PreferredConstructorObjectObjectConstructorTypeParametersInner>;
    /**
     * 
     * @type {boolean}
     * @memberof PreferredConstructorObjectObjectConstructor
     */
    'synthetic'?: boolean;
    /**
     * 
     * @type {Array<object>}
     * @memberof PreferredConstructorObjectObjectConstructor
     */
    'declaredAnnotations'?: Array<object>;
    /**
     * 
     * @type {boolean}
     * @memberof PreferredConstructorObjectObjectConstructor
     * @deprecated
     */
    'accessible'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PreferredConstructorObjectObjectConstructor
     */
    'varArgs'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PreferredConstructorObjectObjectConstructor
     */
    'parameterCount'?: number;
    /**
     * 
     * @type {Array<Array<object>>}
     * @memberof PreferredConstructorObjectObjectConstructor
     */
    'parameterAnnotations'?: Array<Array<object>>;
    /**
     * 
     * @type {Array<PersistentPropertyObjectFieldGenericType>}
     * @memberof PreferredConstructorObjectObjectConstructor
     */
    'genericParameterTypes'?: Array<PersistentPropertyObjectFieldGenericType>;
    /**
     * 
     * @type {Array<PersistentPropertyObjectFieldGenericType>}
     * @memberof PreferredConstructorObjectObjectConstructor
     */
    'genericExceptionTypes'?: Array<PersistentPropertyObjectFieldGenericType>;
    /**
     * 
     * @type {PersistentPropertyObjectFieldAnnotatedType}
     * @memberof PreferredConstructorObjectObjectConstructor
     */
    'annotatedReturnType'?: PersistentPropertyObjectFieldAnnotatedType;
    /**
     * 
     * @type {PersistentPropertyObjectFieldAnnotatedType}
     * @memberof PreferredConstructorObjectObjectConstructor
     */
    'annotatedReceiverType'?: PersistentPropertyObjectFieldAnnotatedType;
    /**
     * 
     * @type {Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationAnnotatedParameterTypesInner>}
     * @memberof PreferredConstructorObjectObjectConstructor
     */
    'annotatedParameterTypes'?: Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationAnnotatedParameterTypesInner>;
    /**
     * 
     * @type {Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInner>}
     * @memberof PreferredConstructorObjectObjectConstructor
     */
    'parameters'?: Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationParametersInner>;
    /**
     * 
     * @type {Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationAnnotatedParameterTypesInner>}
     * @memberof PreferredConstructorObjectObjectConstructor
     */
    'annotatedExceptionTypes'?: Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationAnnotatedParameterTypesInner>;
    /**
     * 
     * @type {Array<object>}
     * @memberof PreferredConstructorObjectObjectConstructor
     */
    'annotations'?: Array<object>;
}
/**
 * 
 * @export
 * @interface PreferredConstructorObjectObjectConstructorTypeParametersInner
 */
export interface PreferredConstructorObjectObjectConstructorTypeParametersInner {
    /**
     * 
     * @type {Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationAnnotatedParameterTypesInner>}
     * @memberof PreferredConstructorObjectObjectConstructorTypeParametersInner
     */
    'annotatedBounds'?: Array<PersistentPropertyObjectWitherTypeParametersInnerGenericDeclarationAnnotatedParameterTypesInner>;
    /**
     * 
     * @type {string}
     * @memberof PreferredConstructorObjectObjectConstructorTypeParametersInner
     */
    'name'?: string;
    /**
     * 
     * @type {Array<PersistentPropertyObjectFieldGenericType>}
     * @memberof PreferredConstructorObjectObjectConstructorTypeParametersInner
     */
    'bounds'?: Array<PersistentPropertyObjectFieldGenericType>;
    /**
     * 
     * @type {string}
     * @memberof PreferredConstructorObjectObjectConstructorTypeParametersInner
     */
    'typeName'?: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof PreferredConstructorObjectObjectConstructorTypeParametersInner
     */
    'annotations'?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof PreferredConstructorObjectObjectConstructorTypeParametersInner
     */
    'declaredAnnotations'?: Array<object>;
}
/**
 * 
 * @export
 * @interface PreferredConstructorObjectPersistentPropertyObject
 */
export interface PreferredConstructorObjectPersistentPropertyObject {
    /**
     * 
     * @type {Array<ParameterObjectPersistentPropertyObject>}
     * @memberof PreferredConstructorObjectPersistentPropertyObject
     */
    'parameters'?: Array<ParameterObjectPersistentPropertyObject>;
    /**
     * 
     * @type {PreferredConstructorObjectObjectConstructor}
     * @memberof PreferredConstructorObjectPersistentPropertyObject
     */
    'constructor'?: PreferredConstructorObjectObjectConstructor;
    /**
     * 
     * @type {boolean}
     * @memberof PreferredConstructorObjectPersistentPropertyObject
     */
    'noArgConstructor'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PreferredConstructorObjectPersistentPropertyObject
     */
    'explicitlyAnnotated'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PreferredConstructorObjectPersistentPropertyObject
     */
    'parameterCount'?: number;
}
/**
 * 
 * @export
 * @interface Proxy
 */
export interface Proxy {
    /**
     * 
     * @type {number}
     * @memberof Proxy
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Proxy
     */
    'server'?: string;
    /**
     * 
     * @type {string}
     * @memberof Proxy
     */
    'bypass'?: string;
    /**
     * 
     * @type {string}
     * @memberof Proxy
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof Proxy
     */
    'password'?: string;
}
/**
 * 
 * @export
 * @interface ProxyDto
 */
export interface ProxyDto {
    /**
     * 
     * @type {number}
     * @memberof ProxyDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProxyDto
     */
    'server'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProxyDto
     */
    'bypass'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProxyDto
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProxyDto
     */
    'password'?: string;
}
/**
 * 
 * @export
 * @interface RepresentationModelObject
 */
export interface RepresentationModelObject {
    /**
     * 
     * @type {{ [key: string]: Link; }}
     * @memberof RepresentationModelObject
     */
    '_links'?: { [key: string]: Link; };
}
/**
 * 
 * @export
 * @interface Request
 */
export interface Request {
    /**
     * 
     * @type {number}
     * @memberof Request
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Request
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Request
     */
    'requestJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof Request
     */
    'baseUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof Request
     */
    'stage'?: RequestStageEnum;
    /**
     * 
     * @type {string}
     * @memberof Request
     */
    'requestMethod'?: RequestRequestMethodEnum;
    /**
     * 
     * @type {System}
     * @memberof Request
     */
    'system'?: System;
}

export const RequestStageEnum = {
    Ent: 'ENT',
    Kon: 'KON'
} as const;

export type RequestStageEnum = typeof RequestStageEnum[keyof typeof RequestStageEnum];
export const RequestRequestMethodEnum = {
    Get: 'GET',
    Post: 'POST'
} as const;

export type RequestRequestMethodEnum = typeof RequestRequestMethodEnum[keyof typeof RequestRequestMethodEnum];

/**
 * 
 * @export
 * @interface RequestDto
 */
export interface RequestDto {
    /**
     * 
     * @type {number}
     * @memberof RequestDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof RequestDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestDto
     */
    'requestJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestDto
     */
    'baseUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestDto
     */
    'stage'?: RequestDtoStageEnum;
    /**
     * 
     * @type {string}
     * @memberof RequestDto
     */
    'requestMethod'?: RequestDtoRequestMethodEnum;
    /**
     * 
     * @type {System}
     * @memberof RequestDto
     */
    'system'?: System;
    /**
     * 
     * @type {Array<string>}
     * @memberof RequestDto
     */
    'pathVariables'?: Array<string>;
}

export const RequestDtoStageEnum = {
    Ent: 'ENT',
    Kon: 'KON'
} as const;

export type RequestDtoStageEnum = typeof RequestDtoStageEnum[keyof typeof RequestDtoStageEnum];
export const RequestDtoRequestMethodEnum = {
    Get: 'GET',
    Post: 'POST'
} as const;

export type RequestDtoRequestMethodEnum = typeof RequestDtoRequestMethodEnum[keyof typeof RequestDtoRequestMethodEnum];

/**
 * 
 * @export
 * @interface RequestRequestBody
 */
export interface RequestRequestBody {
    /**
     * 
     * @type {number}
     * @memberof RequestRequestBody
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof RequestRequestBody
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestRequestBody
     */
    'requestJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestRequestBody
     */
    'baseUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestRequestBody
     */
    'stage'?: RequestRequestBodyStageEnum;
    /**
     * 
     * @type {string}
     * @memberof RequestRequestBody
     */
    'requestMethod'?: RequestRequestBodyRequestMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof RequestRequestBody
     */
    'system'?: string;
}

export const RequestRequestBodyStageEnum = {
    Ent: 'ENT',
    Kon: 'KON'
} as const;

export type RequestRequestBodyStageEnum = typeof RequestRequestBodyStageEnum[keyof typeof RequestRequestBodyStageEnum];
export const RequestRequestBodyRequestMethodEnum = {
    Get: 'GET',
    Post: 'POST'
} as const;

export type RequestRequestBodyRequestMethodEnum = typeof RequestRequestBodyRequestMethodEnum[keyof typeof RequestRequestBodyRequestMethodEnum];

/**
 * 
 * @export
 * @interface ScheduledTestPlanTask
 */
export interface ScheduledTestPlanTask {
    /**
     * 
     * @type {number}
     * @memberof ScheduledTestPlanTask
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ScheduledTestPlanTask
     */
    'testPlanId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ScheduledTestPlanTask
     */
    'cronExpression'?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduledTestPlanTask
     */
    'creationTs'?: string;
}
/**
 * 
 * @export
 * @interface ScheduledTestPlanTaskRequestBody
 */
export interface ScheduledTestPlanTaskRequestBody {
    /**
     * 
     * @type {number}
     * @memberof ScheduledTestPlanTaskRequestBody
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ScheduledTestPlanTaskRequestBody
     */
    'testPlanId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ScheduledTestPlanTaskRequestBody
     */
    'cronExpression'?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduledTestPlanTaskRequestBody
     */
    'creationTs'?: string;
}
/**
 * 
 * @export
 * @interface SortObject
 */
export interface SortObject {
    /**
     * 
     * @type {boolean}
     * @memberof SortObject
     */
    'empty'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SortObject
     */
    'sorted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SortObject
     */
    'unsorted'?: boolean;
}
/**
 * 
 * @export
 * @interface System
 */
export interface System {
    /**
     * 
     * @type {number}
     * @memberof System
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof System
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof System
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface SystemDto
 */
export interface SystemDto {
    /**
     * 
     * @type {number}
     * @memberof SystemDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SystemDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemDto
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface SystemRequestBody
 */
export interface SystemRequestBody {
    /**
     * 
     * @type {number}
     * @memberof SystemRequestBody
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SystemRequestBody
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemRequestBody
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface TestDto
 */
export interface TestDto {
    /**
     * 
     * @type {number}
     * @memberof TestDto
     */
    'id'?: number;
    /**
     * 
     * @type {SystemDto}
     * @memberof TestDto
     */
    'system': SystemDto;
    /**
     * 
     * @type {string}
     * @memberof TestDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TestDto
     */
    'description'?: string;
    /**
     * 
     * @type {Array<CommandDto>}
     * @memberof TestDto
     */
    'commandDtos'?: Array<CommandDto>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof TestDto
     */
    'predefinedVariables'?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface TestExecutionDto
 */
export interface TestExecutionDto {
    /**
     * 
     * @type {number}
     * @memberof TestExecutionDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TestExecutionDto
     */
    'testId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TestExecutionDto
     */
    'startTs'?: string;
    /**
     * 
     * @type {string}
     * @memberof TestExecutionDto
     */
    'endTs'?: string;
    /**
     * 
     * @type {string}
     * @memberof TestExecutionDto
     */
    'resumeTs'?: string;
    /**
     * 
     * @type {TestResultDto}
     * @memberof TestExecutionDto
     */
    'result'?: TestResultDto;
    /**
     * 
     * @type {string}
     * @memberof TestExecutionDto
     */
    'runStatus'?: TestExecutionDtoRunStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof TestExecutionDto
     */
    'traceUrl'?: string;
}

export const TestExecutionDtoRunStatusEnum = {
    Success: 'SUCCESS',
    Failed: 'FAILED',
    Unknown: 'UNKNOWN',
    Paused: 'PAUSED',
    Executing: 'EXECUTING'
} as const;

export type TestExecutionDtoRunStatusEnum = typeof TestExecutionDtoRunStatusEnum[keyof typeof TestExecutionDtoRunStatusEnum];

/**
 * 
 * @export
 * @interface TestExecutionRequestBody
 */
export interface TestExecutionRequestBody {
    /**
     * 
     * @type {number}
     * @memberof TestExecutionRequestBody
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TestExecutionRequestBody
     */
    'testId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TestExecutionRequestBody
     */
    'startTs'?: string;
    /**
     * 
     * @type {string}
     * @memberof TestExecutionRequestBody
     */
    'endTs'?: string;
    /**
     * 
     * @type {string}
     * @memberof TestExecutionRequestBody
     */
    'resumeTs'?: string;
    /**
     * 
     * @type {string}
     * @memberof TestExecutionRequestBody
     */
    'testResult'?: string;
    /**
     * 
     * @type {string}
     * @memberof TestExecutionRequestBody
     */
    'runStatus'?: TestExecutionRequestBodyRunStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof TestExecutionRequestBody
     */
    'traceUrl'?: string;
}

export const TestExecutionRequestBodyRunStatusEnum = {
    Success: 'SUCCESS',
    Failed: 'FAILED',
    Unknown: 'UNKNOWN',
    Paused: 'PAUSED',
    Executing: 'EXECUTING'
} as const;

export type TestExecutionRequestBodyRunStatusEnum = typeof TestExecutionRequestBodyRunStatusEnum[keyof typeof TestExecutionRequestBodyRunStatusEnum];

/**
 * 
 * @export
 * @interface TestExecutionResponse
 */
export interface TestExecutionResponse {
    /**
     * 
     * @type {number}
     * @memberof TestExecutionResponse
     */
    'testId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TestExecutionResponse
     */
    'startTs'?: string;
    /**
     * 
     * @type {string}
     * @memberof TestExecutionResponse
     */
    'endTs'?: string;
    /**
     * 
     * @type {string}
     * @memberof TestExecutionResponse
     */
    'resumeTs'?: string;
    /**
     * 
     * @type {string}
     * @memberof TestExecutionResponse
     */
    'runStatus'?: TestExecutionResponseRunStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof TestExecutionResponse
     */
    'traceUrl'?: string;
}

export const TestExecutionResponseRunStatusEnum = {
    Success: 'SUCCESS',
    Failed: 'FAILED',
    Unknown: 'UNKNOWN',
    Paused: 'PAUSED',
    Executing: 'EXECUTING'
} as const;

export type TestExecutionResponseRunStatusEnum = typeof TestExecutionResponseRunStatusEnum[keyof typeof TestExecutionResponseRunStatusEnum];

/**
 * 
 * @export
 * @interface TestPauseDataRequestBody
 */
export interface TestPauseDataRequestBody {
    /**
     * 
     * @type {number}
     * @memberof TestPauseDataRequestBody
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TestPauseDataRequestBody
     */
    'testJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof TestPauseDataRequestBody
     */
    'startTs'?: string;
    /**
     * 
     * @type {string}
     * @memberof TestPauseDataRequestBody
     */
    'resumeTs'?: string;
    /**
     * 
     * @type {number}
     * @memberof TestPauseDataRequestBody
     */
    'totalStep'?: number;
    /**
     * 
     * @type {number}
     * @memberof TestPauseDataRequestBody
     */
    'prefabStep'?: number;
    /**
     * 
     * @type {number}
     * @memberof TestPauseDataRequestBody
     */
    'testExecutionId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TestPauseDataRequestBody
     */
    'executeWithTrace'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TestPauseDataRequestBody
     */
    'resumed'?: boolean;
}
/**
 * 
 * @export
 * @interface TestPlanDto
 */
export interface TestPlanDto {
    /**
     * 
     * @type {string}
     * @memberof TestPlanDto
     */
    'name'?: string;
    /**
     * 
     * @type {Array<TestPlanTestDto>}
     * @memberof TestPlanDto
     */
    'testPlanTestDtos'?: Array<TestPlanTestDto>;
    /**
     * 
     * @type {number}
     * @memberof TestPlanDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TestPlanDto
     */
    'latestRunStatus'?: TestPlanDtoLatestRunStatusEnum;
}

export const TestPlanDtoLatestRunStatusEnum = {
    Success: 'SUCCESS',
    Failed: 'FAILED',
    Unknown: 'UNKNOWN',
    Paused: 'PAUSED',
    Executing: 'EXECUTING'
} as const;

export type TestPlanDtoLatestRunStatusEnum = typeof TestPlanDtoLatestRunStatusEnum[keyof typeof TestPlanDtoLatestRunStatusEnum];

/**
 * 
 * @export
 * @interface TestPlanExecutionDto
 */
export interface TestPlanExecutionDto {
    /**
     * 
     * @type {number}
     * @memberof TestPlanExecutionDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TestPlanExecutionDto
     */
    'executionTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof TestPlanExecutionDto
     */
    'runStatus'?: TestPlanExecutionDtoRunStatusEnum;
    /**
     * 
     * @type {Array<TestExecutionDto>}
     * @memberof TestPlanExecutionDto
     */
    'testExecutions'?: Array<TestExecutionDto>;
    /**
     * 
     * @type {TestPlanDto}
     * @memberof TestPlanExecutionDto
     */
    'testPlan'?: TestPlanDto;
}

export const TestPlanExecutionDtoRunStatusEnum = {
    Success: 'SUCCESS',
    Failed: 'FAILED',
    Unknown: 'UNKNOWN',
    Paused: 'PAUSED',
    Executing: 'EXECUTING'
} as const;

export type TestPlanExecutionDtoRunStatusEnum = typeof TestPlanExecutionDtoRunStatusEnum[keyof typeof TestPlanExecutionDtoRunStatusEnum];

/**
 * 
 * @export
 * @interface TestPlanStatistic
 */
export interface TestPlanStatistic {
    /**
     * 
     * @type {TestPlanDto}
     * @memberof TestPlanStatistic
     */
    'testPlan'?: TestPlanDto;
    /**
     * 
     * @type {number}
     * @memberof TestPlanStatistic
     */
    'success'?: number;
    /**
     * 
     * @type {number}
     * @memberof TestPlanStatistic
     */
    'fail'?: number;
    /**
     * 
     * @type {string}
     * @memberof TestPlanStatistic
     */
    'latestRun'?: string;
}
/**
 * 
 * @export
 * @interface TestPlanTaskResponse
 */
export interface TestPlanTaskResponse {
    /**
     * 
     * @type {number}
     * @memberof TestPlanTaskResponse
     */
    'id'?: number;
    /**
     * 
     * @type {TestPlanDto}
     * @memberof TestPlanTaskResponse
     */
    'testPlan'?: TestPlanDto;
    /**
     * 
     * @type {string}
     * @memberof TestPlanTaskResponse
     */
    'cronExpression'?: string;
    /**
     * 
     * @type {string}
     * @memberof TestPlanTaskResponse
     */
    'creationTs'?: string;
}
/**
 * 
 * @export
 * @interface TestPlanTestDto
 */
export interface TestPlanTestDto {
    /**
     * 
     * @type {number}
     * @memberof TestPlanTestDto
     */
    'id'?: number;
    /**
     * 
     * @type {TestDto}
     * @memberof TestPlanTestDto
     */
    'testDto'?: TestDto;
    /**
     * 
     * @type {boolean}
     * @memberof TestPlanTestDto
     */
    'activeTrace'?: boolean;
}
/**
 * 
 * @export
 * @interface TestResultDto
 */
export interface TestResultDto {
    /**
     * 
     * @type {number}
     * @memberof TestResultDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TestResultDto
     */
    'testId'?: number;
    /**
     * 
     * @type {System}
     * @memberof TestResultDto
     */
    'system'?: System;
    /**
     * 
     * @type {string}
     * @memberof TestResultDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TestResultDto
     */
    'description'?: string;
    /**
     * 
     * @type {Array<TestStep>}
     * @memberof TestResultDto
     */
    'testSteps'?: Array<TestStep>;
    /**
     * 
     * @type {Array<Variable>}
     * @memberof TestResultDto
     */
    'predefinedVariables'?: Array<Variable>;
    /**
     * 
     * @type {Array<Variable>}
     * @memberof TestResultDto
     */
    'runtimeVariables'?: Array<Variable>;
    /**
     * 
     * @type {string}
     * @memberof TestResultDto
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {number}
     * @memberof TestResultDto
     */
    'successfullSteps'?: number;
    /**
     * 
     * @type {string}
     * @memberof TestResultDto
     */
    'interpretedErrorMessage'?: string;
    /**
     * 
     * @type {Array<Trace>}
     * @memberof TestResultDto
     */
    'traces'?: Array<Trace>;
    /**
     * 
     * @type {boolean}
     * @memberof TestResultDto
     */
    'used'?: boolean;
}
/**
 * 
 * @export
 * @interface TestResultRequestBody
 */
export interface TestResultRequestBody {
    /**
     * 
     * @type {number}
     * @memberof TestResultRequestBody
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TestResultRequestBody
     */
    'testId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TestResultRequestBody
     */
    'system'?: string;
    /**
     * 
     * @type {string}
     * @memberof TestResultRequestBody
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TestResultRequestBody
     */
    'description'?: string;
    /**
     * 
     * @type {Array<TestStep>}
     * @memberof TestResultRequestBody
     */
    'testSteps'?: Array<TestStep>;
    /**
     * 
     * @type {Array<Variable>}
     * @memberof TestResultRequestBody
     */
    'predefinedVariables'?: Array<Variable>;
    /**
     * 
     * @type {Array<Variable>}
     * @memberof TestResultRequestBody
     */
    'runtimeVariables'?: Array<Variable>;
    /**
     * 
     * @type {string}
     * @memberof TestResultRequestBody
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof TestResultRequestBody
     */
    'interpretedErrorMessage'?: string;
    /**
     * 
     * @type {number}
     * @memberof TestResultRequestBody
     */
    'successfullSteps'?: number;
    /**
     * 
     * @type {Array<Trace>}
     * @memberof TestResultRequestBody
     */
    'traces'?: Array<Trace>;
    /**
     * 
     * @type {boolean}
     * @memberof TestResultRequestBody
     */
    'used'?: boolean;
}
/**
 * 
 * @export
 * @interface TestRunStatistic
 */
export interface TestRunStatistic {
    /**
     * 
     * @type {number}
     * @memberof TestRunStatistic
     */
    'successFullTestRuns'?: number;
    /**
     * 
     * @type {number}
     * @memberof TestRunStatistic
     */
    'failedFullTestRuns'?: number;
}
/**
 * 
 * @export
 * @interface TestStep
 */
export interface TestStep {
    /**
     * 
     * @type {string}
     * @memberof TestStep
     */
    'commandName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TestStep
     */
    'description'?: string;
    /**
     * 
     * @type {CommandDto}
     * @memberof TestStep
     */
    'command'?: CommandDto;
    /**
     * 
     * @type {string}
     * @memberof TestStep
     */
    'executeState'?: TestStepExecuteStateEnum;
    /**
     * 
     * @type {boolean}
     * @memberof TestStep
     */
    'prefab'?: boolean;
}

export const TestStepExecuteStateEnum = {
    Success: 'SUCCESS',
    Failed: 'FAILED',
    Paused: 'PAUSED',
    Ignored: 'IGNORED'
} as const;

export type TestStepExecuteStateEnum = typeof TestStepExecuteStateEnum[keyof typeof TestStepExecuteStateEnum];

/**
 * 
 * @export
 * @interface TimeOffset
 */
export interface TimeOffset {
    /**
     * 
     * @type {number}
     * @memberof TimeOffset
     */
    'days'?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeOffset
     */
    'hours'?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeOffset
     */
    'minutes'?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeOffset
     */
    'seconds'?: number;
}
/**
 * 
 * @export
 * @interface Trace
 */
export interface Trace {
    /**
     * 
     * @type {number}
     * @memberof Trace
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Trace
     */
    'filename'?: string;
    /**
     * 
     * @type {string}
     * @memberof Trace
     */
    'creationTs'?: string;
    /**
     * 
     * @type {number}
     * @memberof Trace
     */
    'testResultId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Trace
     */
    'traceUrl'?: string;
}
/**
 * 
 * @export
 * @interface TraceRequestBody
 */
export interface TraceRequestBody {
    /**
     * 
     * @type {number}
     * @memberof TraceRequestBody
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TraceRequestBody
     */
    'filename'?: string;
    /**
     * 
     * @type {string}
     * @memberof TraceRequestBody
     */
    'creationTs'?: string;
    /**
     * 
     * @type {number}
     * @memberof TraceRequestBody
     */
    'testResultId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TraceRequestBody
     */
    'traceUrl'?: string;
}
/**
 * 
 * @export
 * @interface TypeInformationObject
 */
export interface TypeInformationObject {
    /**
     * 
     * @type {Array<TypeInformationObject>}
     * @memberof TypeInformationObject
     */
    'typeArguments'?: Array<TypeInformationObject>;
    /**
     * 
     * @type {TypeInformationObject}
     * @memberof TypeInformationObject
     */
    'componentType'?: TypeInformationObject;
    /**
     * 
     * @type {TypeInformationObject}
     * @memberof TypeInformationObject
     */
    'requiredComponentType'?: TypeInformationObject;
    /**
     * 
     * @type {TypeInformationObject}
     * @memberof TypeInformationObject
     */
    'requiredMapValueType'?: TypeInformationObject;
    /**
     * 
     * @type {TypeInformationObject}
     * @memberof TypeInformationObject
     */
    'actualType'?: TypeInformationObject;
    /**
     * 
     * @type {boolean}
     * @memberof TypeInformationObject
     */
    'map'?: boolean;
    /**
     * 
     * @type {TypeInformationObject}
     * @memberof TypeInformationObject
     */
    'mapValueType'?: TypeInformationObject;
    /**
     * 
     * @type {TypeInformationObject}
     * @memberof TypeInformationObject
     */
    'userTypeInformation'?: TypeInformationObject;
    /**
     * 
     * @type {TypeInformationObject}
     * @memberof TypeInformationObject
     */
    'rawTypeInformation'?: TypeInformationObject;
    /**
     * 
     * @type {TypeInformationObject}
     * @memberof TypeInformationObject
     */
    'requiredActualType'?: TypeInformationObject;
    /**
     * 
     * @type {boolean}
     * @memberof TypeInformationObject
     */
    'collectionLike'?: boolean;
}
/**
 * 
 * @export
 * @interface Variable
 */
export interface Variable {
    /**
     * 
     * @type {string}
     * @memberof Variable
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Variable
     */
    'value'?: string;
}

/**
 * AbstractCommandEntityControllerApi - axios parameter creator
 * @export
 */
export const AbstractCommandEntityControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * delete-abstractcommand
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourceAbstractcommandDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteItemResourceAbstractcommandDelete', 'id', id)
            const localVarPath = `/abstractCommands/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-abstractcommand
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourceAbstractcommandGet1: async (page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/abstractCommands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-abstractcommand
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourceAbstractcommandGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getItemResourceAbstractcommandGet', 'id', id)
            const localVarPath = `/abstractCommands/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch-abstractcommand
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourceAbstractcommandPatch: async (id: string, persistentEntityResource: PersistentEntityResource, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchItemResourceAbstractcommandPatch', 'id', id)
            // verify required parameter 'persistentEntityResource' is not null or undefined
            assertParamExists('patchItemResourceAbstractcommandPatch', 'persistentEntityResource', persistentEntityResource)
            const localVarPath = `/abstractCommands/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(persistentEntityResource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create-abstractcommand
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourceAbstractcommandPost: async (persistentEntityResource: PersistentEntityResource, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'persistentEntityResource' is not null or undefined
            assertParamExists('postCollectionResourceAbstractcommandPost', 'persistentEntityResource', persistentEntityResource)
            const localVarPath = `/abstractCommands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(persistentEntityResource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-abstractcommand
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourceAbstractcommandPut: async (id: string, persistentEntityResource: PersistentEntityResource, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putItemResourceAbstractcommandPut', 'id', id)
            // verify required parameter 'persistentEntityResource' is not null or undefined
            assertParamExists('putItemResourceAbstractcommandPut', 'persistentEntityResource', persistentEntityResource)
            const localVarPath = `/abstractCommands/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(persistentEntityResource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AbstractCommandEntityControllerApi - functional programming interface
 * @export
 */
export const AbstractCommandEntityControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AbstractCommandEntityControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * delete-abstractcommand
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteItemResourceAbstractcommandDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteItemResourceAbstractcommandDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-abstractcommand
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollectionResourceAbstractcommandGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollectionResourceAbstractcommandGet1(page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-abstractcommand
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getItemResourceAbstractcommandGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getItemResourceAbstractcommandGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * patch-abstractcommand
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchItemResourceAbstractcommandPatch(id: string, persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchItemResourceAbstractcommandPatch(id, persistentEntityResource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * create-abstractcommand
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCollectionResourceAbstractcommandPost(persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCollectionResourceAbstractcommandPost(persistentEntityResource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-abstractcommand
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putItemResourceAbstractcommandPut(id: string, persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putItemResourceAbstractcommandPut(id, persistentEntityResource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AbstractCommandEntityControllerApi - factory interface
 * @export
 */
export const AbstractCommandEntityControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AbstractCommandEntityControllerApiFp(configuration)
    return {
        /**
         * delete-abstractcommand
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourceAbstractcommandDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteItemResourceAbstractcommandDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-abstractcommand
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourceAbstractcommandGet1(page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.getCollectionResourceAbstractcommandGet1(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * get-abstractcommand
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourceAbstractcommandGet(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.getItemResourceAbstractcommandGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * patch-abstractcommand
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourceAbstractcommandPatch(id: string, persistentEntityResource: PersistentEntityResource, options?: any): AxiosPromise<void> {
            return localVarFp.patchItemResourceAbstractcommandPatch(id, persistentEntityResource, options).then((request) => request(axios, basePath));
        },
        /**
         * create-abstractcommand
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourceAbstractcommandPost(persistentEntityResource: PersistentEntityResource, options?: any): AxiosPromise<void> {
            return localVarFp.postCollectionResourceAbstractcommandPost(persistentEntityResource, options).then((request) => request(axios, basePath));
        },
        /**
         * update-abstractcommand
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourceAbstractcommandPut(id: string, persistentEntityResource: PersistentEntityResource, options?: any): AxiosPromise<void> {
            return localVarFp.putItemResourceAbstractcommandPut(id, persistentEntityResource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AbstractCommandEntityControllerApi - object-oriented interface
 * @export
 * @class AbstractCommandEntityControllerApi
 * @extends {BaseAPI}
 */
export class AbstractCommandEntityControllerApi extends BaseAPI {
    /**
     * delete-abstractcommand
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbstractCommandEntityControllerApi
     */
    public deleteItemResourceAbstractcommandDelete(id: string, options?: AxiosRequestConfig) {
        return AbstractCommandEntityControllerApiFp(this.configuration).deleteItemResourceAbstractcommandDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-abstractcommand
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbstractCommandEntityControllerApi
     */
    public getCollectionResourceAbstractcommandGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return AbstractCommandEntityControllerApiFp(this.configuration).getCollectionResourceAbstractcommandGet1(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-abstractcommand
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbstractCommandEntityControllerApi
     */
    public getItemResourceAbstractcommandGet(id: string, options?: AxiosRequestConfig) {
        return AbstractCommandEntityControllerApiFp(this.configuration).getItemResourceAbstractcommandGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * patch-abstractcommand
     * @param {string} id 
     * @param {PersistentEntityResource} persistentEntityResource 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbstractCommandEntityControllerApi
     */
    public patchItemResourceAbstractcommandPatch(id: string, persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig) {
        return AbstractCommandEntityControllerApiFp(this.configuration).patchItemResourceAbstractcommandPatch(id, persistentEntityResource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create-abstractcommand
     * @param {PersistentEntityResource} persistentEntityResource 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbstractCommandEntityControllerApi
     */
    public postCollectionResourceAbstractcommandPost(persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig) {
        return AbstractCommandEntityControllerApiFp(this.configuration).postCollectionResourceAbstractcommandPost(persistentEntityResource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-abstractcommand
     * @param {string} id 
     * @param {PersistentEntityResource} persistentEntityResource 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbstractCommandEntityControllerApi
     */
    public putItemResourceAbstractcommandPut(id: string, persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig) {
        return AbstractCommandEntityControllerApiFp(this.configuration).putItemResourceAbstractcommandPut(id, persistentEntityResource, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ExportControllerApi - axios parameter creator
 * @export
 */
export const ExportControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<number>} testExecutionIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTestExecutionsJson: async (testExecutionIds: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testExecutionIds' is not null or undefined
            assertParamExists('exportTestExecutionsJson', 'testExecutionIds', testExecutionIds)
            const localVarPath = `/api/export/testexecution/json`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (testExecutionIds) {
                localVarQueryParameter['testExecutionIds'] = testExecutionIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} testExecutionIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTestExecutionsToCsv: async (testExecutionIds: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testExecutionIds' is not null or undefined
            assertParamExists('exportTestExecutionsToCsv', 'testExecutionIds', testExecutionIds)
            const localVarPath = `/api/export/testexecution/csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (testExecutionIds) {
                localVarQueryParameter['testExecutionIds'] = testExecutionIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} testResultIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTestResultsJson: async (testResultIds: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testResultIds' is not null or undefined
            assertParamExists('exportTestResultsJson', 'testResultIds', testResultIds)
            const localVarPath = `/api/export/testresult/json`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (testResultIds) {
                localVarQueryParameter['testResultIds'] = testResultIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} testResultIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTestResultsToCsv: async (testResultIds: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testResultIds' is not null or undefined
            assertParamExists('exportTestResultsToCsv', 'testResultIds', testResultIds)
            const localVarPath = `/api/export/testresult/csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (testResultIds) {
                localVarQueryParameter['testResultIds'] = testResultIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExportControllerApi - functional programming interface
 * @export
 */
export const ExportControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExportControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<number>} testExecutionIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportTestExecutionsJson(testExecutionIds: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportTestExecutionsJson(testExecutionIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} testExecutionIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportTestExecutionsToCsv(testExecutionIds: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportTestExecutionsToCsv(testExecutionIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} testResultIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportTestResultsJson(testResultIds: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportTestResultsJson(testResultIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} testResultIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportTestResultsToCsv(testResultIds: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportTestResultsToCsv(testResultIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ExportControllerApi - factory interface
 * @export
 */
export const ExportControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExportControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {Array<number>} testExecutionIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTestExecutionsJson(testExecutionIds: Array<number>, options?: any): AxiosPromise<string> {
            return localVarFp.exportTestExecutionsJson(testExecutionIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} testExecutionIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTestExecutionsToCsv(testExecutionIds: Array<number>, options?: any): AxiosPromise<string> {
            return localVarFp.exportTestExecutionsToCsv(testExecutionIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} testResultIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTestResultsJson(testResultIds: Array<number>, options?: any): AxiosPromise<string> {
            return localVarFp.exportTestResultsJson(testResultIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} testResultIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTestResultsToCsv(testResultIds: Array<number>, options?: any): AxiosPromise<string> {
            return localVarFp.exportTestResultsToCsv(testResultIds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExportControllerApi - object-oriented interface
 * @export
 * @class ExportControllerApi
 * @extends {BaseAPI}
 */
export class ExportControllerApi extends BaseAPI {
    /**
     * 
     * @param {Array<number>} testExecutionIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportControllerApi
     */
    public exportTestExecutionsJson(testExecutionIds: Array<number>, options?: AxiosRequestConfig) {
        return ExportControllerApiFp(this.configuration).exportTestExecutionsJson(testExecutionIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} testExecutionIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportControllerApi
     */
    public exportTestExecutionsToCsv(testExecutionIds: Array<number>, options?: AxiosRequestConfig) {
        return ExportControllerApiFp(this.configuration).exportTestExecutionsToCsv(testExecutionIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} testResultIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportControllerApi
     */
    public exportTestResultsJson(testResultIds: Array<number>, options?: AxiosRequestConfig) {
        return ExportControllerApiFp(this.configuration).exportTestResultsJson(testResultIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} testResultIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportControllerApi
     */
    public exportTestResultsToCsv(testResultIds: Array<number>, options?: AxiosRequestConfig) {
        return ExportControllerApiFp(this.configuration).exportTestResultsToCsv(testResultIds, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ExportTestControllerApi - axios parameter creator
 * @export
 */
export const ExportTestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAllTests: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/test/export/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTestsByIds: async (ids: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('exportTestsByIds', 'ids', ids)
            const localVarPath = `/api/test/export/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportInfo: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/test/export/exportInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExportTestControllerApi - functional programming interface
 * @export
 */
export const ExportTestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExportTestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportAllTests(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportAllTests(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportTestsByIds(ids: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportTestsByIds(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExportInfo(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExportInfo(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ExportTestControllerApi - factory interface
 * @export
 */
export const ExportTestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExportTestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAllTests(options?: any): AxiosPromise<object> {
            return localVarFp.exportAllTests(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTestsByIds(ids: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.exportTestsByIds(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportInfo(options?: any): AxiosPromise<ExportInfoDto> {
            return localVarFp.getExportInfo(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExportTestControllerApi - object-oriented interface
 * @export
 * @class ExportTestControllerApi
 * @extends {BaseAPI}
 */
export class ExportTestControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportTestControllerApi
     */
    public exportAllTests(options?: AxiosRequestConfig) {
        return ExportTestControllerApiFp(this.configuration).exportAllTests(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportTestControllerApi
     */
    public exportTestsByIds(ids: Array<number>, options?: AxiosRequestConfig) {
        return ExportTestControllerApiFp(this.configuration).exportTestsByIds(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportTestControllerApi
     */
    public getExportInfo(options?: AxiosRequestConfig) {
        return ExportTestControllerApiFp(this.configuration).getExportInfo(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ExternalMappingInformationControllerApi - axios parameter creator
 * @export
 */
export const ExternalMappingInformationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocateById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLocateById', 'id', id)
            const localVarPath = `/api/external/locate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPasswordById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPasswordById', 'id', id)
            const localVarPath = `/api/external/password/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPasswordByName: async (name: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getPasswordByName', 'name', name)
            const localVarPath = `/api/external/password/name/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrefabById1: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPrefabById1', 'id', id)
            const localVarPath = `/api/external/prefab/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequestById1: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRequestById1', 'id', id)
            const localVarPath = `/api/external/request/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExternalMappingInformationControllerApi - functional programming interface
 * @export
 */
export const ExternalMappingInformationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExternalMappingInformationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocateById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocateById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPasswordById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Password>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPasswordById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPasswordByName(name: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Password>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPasswordByName(name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrefabById1(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrefabById1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRequestById1(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Request>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRequestById1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ExternalMappingInformationControllerApi - factory interface
 * @export
 */
export const ExternalMappingInformationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExternalMappingInformationControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocateById(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.getLocateById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPasswordById(id: number, options?: any): AxiosPromise<Password> {
            return localVarFp.getPasswordById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPasswordByName(name: string, options?: any): AxiosPromise<Password> {
            return localVarFp.getPasswordByName(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrefabById1(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.getPrefabById1(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequestById1(id: number, options?: any): AxiosPromise<Request> {
            return localVarFp.getRequestById1(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExternalMappingInformationControllerApi - object-oriented interface
 * @export
 * @class ExternalMappingInformationControllerApi
 * @extends {BaseAPI}
 */
export class ExternalMappingInformationControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalMappingInformationControllerApi
     */
    public getLocateById(id: number, options?: AxiosRequestConfig) {
        return ExternalMappingInformationControllerApiFp(this.configuration).getLocateById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalMappingInformationControllerApi
     */
    public getPasswordById(id: number, options?: AxiosRequestConfig) {
        return ExternalMappingInformationControllerApiFp(this.configuration).getPasswordById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalMappingInformationControllerApi
     */
    public getPasswordByName(name: string, options?: AxiosRequestConfig) {
        return ExternalMappingInformationControllerApiFp(this.configuration).getPasswordByName(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalMappingInformationControllerApi
     */
    public getPrefabById1(id: number, options?: AxiosRequestConfig) {
        return ExternalMappingInformationControllerApiFp(this.configuration).getPrefabById1(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalMappingInformationControllerApi
     */
    public getRequestById1(id: number, options?: AxiosRequestConfig) {
        return ExternalMappingInformationControllerApiFp(this.configuration).getRequestById1(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ImportTestControllerApi - axios parameter creator
 * @export
 */
export const ImportTestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPasswords: async (requestBody: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('checkPasswords', 'requestBody', requestBody)
            const localVarPath = `/api/test/import/checkPasswords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile: async (file: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadFile', 'file', file)
            const localVarPath = `/api/test/import/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImportTestControllerApi - functional programming interface
 * @export
 */
export const ImportTestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImportTestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkPasswords(requestBody: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkPasswords(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadFile(file: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadFile(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ImportTestControllerApi - factory interface
 * @export
 */
export const ImportTestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImportTestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPasswords(requestBody: Array<string>, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.checkPasswords(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile(file: File, options?: any): AxiosPromise<string> {
            return localVarFp.uploadFile(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ImportTestControllerApi - object-oriented interface
 * @export
 * @class ImportTestControllerApi
 * @extends {BaseAPI}
 */
export class ImportTestControllerApi extends BaseAPI {
    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportTestControllerApi
     */
    public checkPasswords(requestBody: Array<string>, options?: AxiosRequestConfig) {
        return ImportTestControllerApiFp(this.configuration).checkPasswords(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportTestControllerApi
     */
    public uploadFile(file: File, options?: AxiosRequestConfig) {
        return ImportTestControllerApiFp(this.configuration).uploadFile(file, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * KeycloakControllerApi - axios parameter creator
 * @export
 */
export const KeycloakControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isKeycloakEnabled: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/keycloak/keycloak-enabled`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KeycloakControllerApi - functional programming interface
 * @export
 */
export const KeycloakControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KeycloakControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isKeycloakEnabled(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isKeycloakEnabled(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * KeycloakControllerApi - factory interface
 * @export
 */
export const KeycloakControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KeycloakControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isKeycloakEnabled(options?: any): AxiosPromise<boolean> {
            return localVarFp.isKeycloakEnabled(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KeycloakControllerApi - object-oriented interface
 * @export
 * @class KeycloakControllerApi
 * @extends {BaseAPI}
 */
export class KeycloakControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeycloakControllerApi
     */
    public isKeycloakEnabled(options?: AxiosRequestConfig) {
        return KeycloakControllerApiFp(this.configuration).isKeycloakEnabled(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LocateControllerApi - axios parameter creator
 * @export
 */
export const LocateControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Locate
         * @param {LocateDto} locateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocate: async (locateDto: LocateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locateDto' is not null or undefined
            assertParamExists('createLocate', 'locateDto', locateDto)
            const localVarPath = `/api/locate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(locateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Locate by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocate: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteLocate', 'id', id)
            const localVarPath = `/api/locate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Locates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLocates: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/locate/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Locate by System
         * @param {string} systemName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocatesBySystem: async (systemName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemName' is not null or undefined
            assertParamExists('getLocatesBySystem', 'systemName', systemName)
            const localVarPath = `/api/locate/system/{systemName}`
                .replace(`{${"systemName"}}`, encodeURIComponent(String(systemName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Locate
         * @param {LocateDto} locateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocate: async (locateDto: LocateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locateDto' is not null or undefined
            assertParamExists('updateLocate', 'locateDto', locateDto)
            const localVarPath = `/api/locate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(locateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocateControllerApi - functional programming interface
 * @export
 */
export const LocateControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocateControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Locate
         * @param {LocateDto} locateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLocate(locateDto: LocateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLocate(locateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete Locate by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLocate(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLocate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all Locates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllLocates(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LocateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllLocates(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Locate by System
         * @param {string} systemName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocatesBySystem(systemName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LocateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocatesBySystem(systemName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Locate
         * @param {LocateDto} locateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLocate(locateDto: LocateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLocate(locateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LocateControllerApi - factory interface
 * @export
 */
export const LocateControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocateControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Locate
         * @param {LocateDto} locateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocate(locateDto: LocateDto, options?: any): AxiosPromise<object> {
            return localVarFp.createLocate(locateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Locate by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocate(id: number, options?: any): AxiosPromise<object> {
            return localVarFp.deleteLocate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all Locates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLocates(options?: any): AxiosPromise<Array<LocateDto>> {
            return localVarFp.getAllLocates(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Locate by System
         * @param {string} systemName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocatesBySystem(systemName: string, options?: any): AxiosPromise<Array<LocateDto>> {
            return localVarFp.getLocatesBySystem(systemName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Locate
         * @param {LocateDto} locateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocate(locateDto: LocateDto, options?: any): AxiosPromise<object> {
            return localVarFp.updateLocate(locateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocateControllerApi - object-oriented interface
 * @export
 * @class LocateControllerApi
 * @extends {BaseAPI}
 */
export class LocateControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create Locate
     * @param {LocateDto} locateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocateControllerApi
     */
    public createLocate(locateDto: LocateDto, options?: AxiosRequestConfig) {
        return LocateControllerApiFp(this.configuration).createLocate(locateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Locate by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocateControllerApi
     */
    public deleteLocate(id: number, options?: AxiosRequestConfig) {
        return LocateControllerApiFp(this.configuration).deleteLocate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all Locates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocateControllerApi
     */
    public getAllLocates(options?: AxiosRequestConfig) {
        return LocateControllerApiFp(this.configuration).getAllLocates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Locate by System
     * @param {string} systemName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocateControllerApi
     */
    public getLocatesBySystem(systemName: string, options?: AxiosRequestConfig) {
        return LocateControllerApiFp(this.configuration).getLocatesBySystem(systemName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Locate
     * @param {LocateDto} locateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocateControllerApi
     */
    public updateLocate(locateDto: LocateDto, options?: AxiosRequestConfig) {
        return LocateControllerApiFp(this.configuration).updateLocate(locateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LocateEntityControllerApi - axios parameter creator
 * @export
 */
export const LocateEntityControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * delete-locate
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourceLocateDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteItemResourceLocateDelete', 'id', id)
            const localVarPath = `/locates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-locate
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourceLocateGet1: async (page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/locates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-locate
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourceLocateGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getItemResourceLocateGet', 'id', id)
            const localVarPath = `/locates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch-locate
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourceLocatePatch: async (id: string, persistentEntityResource: PersistentEntityResource, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchItemResourceLocatePatch', 'id', id)
            // verify required parameter 'persistentEntityResource' is not null or undefined
            assertParamExists('patchItemResourceLocatePatch', 'persistentEntityResource', persistentEntityResource)
            const localVarPath = `/locates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(persistentEntityResource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create-locate
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourceLocatePost: async (persistentEntityResource: PersistentEntityResource, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'persistentEntityResource' is not null or undefined
            assertParamExists('postCollectionResourceLocatePost', 'persistentEntityResource', persistentEntityResource)
            const localVarPath = `/locates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(persistentEntityResource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-locate
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourceLocatePut: async (id: string, persistentEntityResource: PersistentEntityResource, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putItemResourceLocatePut', 'id', id)
            // verify required parameter 'persistentEntityResource' is not null or undefined
            assertParamExists('putItemResourceLocatePut', 'persistentEntityResource', persistentEntityResource)
            const localVarPath = `/locates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(persistentEntityResource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocateEntityControllerApi - functional programming interface
 * @export
 */
export const LocateEntityControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocateEntityControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * delete-locate
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteItemResourceLocateDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteItemResourceLocateDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-locate
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollectionResourceLocateGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollectionResourceLocateGet1(page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-locate
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getItemResourceLocateGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getItemResourceLocateGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * patch-locate
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchItemResourceLocatePatch(id: string, persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchItemResourceLocatePatch(id, persistentEntityResource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * create-locate
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCollectionResourceLocatePost(persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCollectionResourceLocatePost(persistentEntityResource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-locate
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putItemResourceLocatePut(id: string, persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putItemResourceLocatePut(id, persistentEntityResource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LocateEntityControllerApi - factory interface
 * @export
 */
export const LocateEntityControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocateEntityControllerApiFp(configuration)
    return {
        /**
         * delete-locate
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourceLocateDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteItemResourceLocateDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-locate
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourceLocateGet1(page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.getCollectionResourceLocateGet1(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * get-locate
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourceLocateGet(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.getItemResourceLocateGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * patch-locate
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourceLocatePatch(id: string, persistentEntityResource: PersistentEntityResource, options?: any): AxiosPromise<void> {
            return localVarFp.patchItemResourceLocatePatch(id, persistentEntityResource, options).then((request) => request(axios, basePath));
        },
        /**
         * create-locate
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourceLocatePost(persistentEntityResource: PersistentEntityResource, options?: any): AxiosPromise<void> {
            return localVarFp.postCollectionResourceLocatePost(persistentEntityResource, options).then((request) => request(axios, basePath));
        },
        /**
         * update-locate
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourceLocatePut(id: string, persistentEntityResource: PersistentEntityResource, options?: any): AxiosPromise<void> {
            return localVarFp.putItemResourceLocatePut(id, persistentEntityResource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocateEntityControllerApi - object-oriented interface
 * @export
 * @class LocateEntityControllerApi
 * @extends {BaseAPI}
 */
export class LocateEntityControllerApi extends BaseAPI {
    /**
     * delete-locate
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocateEntityControllerApi
     */
    public deleteItemResourceLocateDelete(id: string, options?: AxiosRequestConfig) {
        return LocateEntityControllerApiFp(this.configuration).deleteItemResourceLocateDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-locate
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocateEntityControllerApi
     */
    public getCollectionResourceLocateGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return LocateEntityControllerApiFp(this.configuration).getCollectionResourceLocateGet1(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-locate
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocateEntityControllerApi
     */
    public getItemResourceLocateGet(id: string, options?: AxiosRequestConfig) {
        return LocateEntityControllerApiFp(this.configuration).getItemResourceLocateGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * patch-locate
     * @param {string} id 
     * @param {PersistentEntityResource} persistentEntityResource 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocateEntityControllerApi
     */
    public patchItemResourceLocatePatch(id: string, persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig) {
        return LocateEntityControllerApiFp(this.configuration).patchItemResourceLocatePatch(id, persistentEntityResource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create-locate
     * @param {PersistentEntityResource} persistentEntityResource 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocateEntityControllerApi
     */
    public postCollectionResourceLocatePost(persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig) {
        return LocateEntityControllerApiFp(this.configuration).postCollectionResourceLocatePost(persistentEntityResource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-locate
     * @param {string} id 
     * @param {PersistentEntityResource} persistentEntityResource 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocateEntityControllerApi
     */
    public putItemResourceLocatePut(id: string, persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig) {
        return LocateEntityControllerApiFp(this.configuration).putItemResourceLocatePut(id, persistentEntityResource, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LocatePropertyReferenceControllerApi - axios parameter creator
 * @export
 */
export const LocatePropertyReferenceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * patch-locate-by-locate-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceLocatePatch: async (id: string, collectionModelObject: CollectionModelObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPropertyReferenceLocatePatch', 'id', id)
            // verify required parameter 'collectionModelObject' is not null or undefined
            assertParamExists('createPropertyReferenceLocatePatch', 'collectionModelObject', collectionModelObject)
            const localVarPath = `/locates/{id}/locate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionModelObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch-system-by-locate-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceLocatePatch1: async (id: string, collectionModelObject: CollectionModelObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPropertyReferenceLocatePatch1', 'id', id)
            // verify required parameter 'collectionModelObject' is not null or undefined
            assertParamExists('createPropertyReferenceLocatePatch1', 'collectionModelObject', collectionModelObject)
            const localVarPath = `/locates/{id}/system`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionModelObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-locate-by-locate-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceLocatePut: async (id: string, collectionModelObject: CollectionModelObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPropertyReferenceLocatePut', 'id', id)
            // verify required parameter 'collectionModelObject' is not null or undefined
            assertParamExists('createPropertyReferenceLocatePut', 'collectionModelObject', collectionModelObject)
            const localVarPath = `/locates/{id}/locate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionModelObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-system-by-locate-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceLocatePut1: async (id: string, collectionModelObject: CollectionModelObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPropertyReferenceLocatePut1', 'id', id)
            // verify required parameter 'collectionModelObject' is not null or undefined
            assertParamExists('createPropertyReferenceLocatePut1', 'collectionModelObject', collectionModelObject)
            const localVarPath = `/locates/{id}/system`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionModelObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete-locate-by-locate-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceIdLocateDelete: async (id: string, propertyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePropertyReferenceIdLocateDelete', 'id', id)
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('deletePropertyReferenceIdLocateDelete', 'propertyId', propertyId)
            const localVarPath = `/locates/{id}/locate/{propertyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete-system-by-locate-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceIdLocateDelete1: async (id: string, propertyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePropertyReferenceIdLocateDelete1', 'id', id)
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('deletePropertyReferenceIdLocateDelete1', 'propertyId', propertyId)
            const localVarPath = `/locates/{id}/system/{propertyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete-locate-by-locate-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceLocateDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePropertyReferenceLocateDelete', 'id', id)
            const localVarPath = `/locates/{id}/locate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete-system-by-locate-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceLocateDelete1: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePropertyReferenceLocateDelete1', 'id', id)
            const localVarPath = `/locates/{id}/system`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-locate-by-locate-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceLocateGet: async (id: string, propertyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('followPropertyReferenceLocateGet', 'id', id)
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('followPropertyReferenceLocateGet', 'propertyId', propertyId)
            const localVarPath = `/locates/{id}/locate/{propertyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-locate-by-locate-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceLocateGet1: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('followPropertyReferenceLocateGet1', 'id', id)
            const localVarPath = `/locates/{id}/locate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-system-by-locate-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceLocateGet2: async (id: string, propertyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('followPropertyReferenceLocateGet2', 'id', id)
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('followPropertyReferenceLocateGet2', 'propertyId', propertyId)
            const localVarPath = `/locates/{id}/system/{propertyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-system-by-locate-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceLocateGet21: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('followPropertyReferenceLocateGet21', 'id', id)
            const localVarPath = `/locates/{id}/system`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocatePropertyReferenceControllerApi - functional programming interface
 * @export
 */
export const LocatePropertyReferenceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocatePropertyReferenceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * patch-locate-by-locate-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReferenceLocatePatch(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReferenceLocatePatch(id, collectionModelObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * patch-system-by-locate-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReferenceLocatePatch1(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelSystem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReferenceLocatePatch1(id, collectionModelObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-locate-by-locate-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReferenceLocatePut(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReferenceLocatePut(id, collectionModelObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-system-by-locate-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReferenceLocatePut1(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelSystem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReferenceLocatePut1(id, collectionModelObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete-locate-by-locate-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePropertyReferenceIdLocateDelete(id: string, propertyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePropertyReferenceIdLocateDelete(id, propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete-system-by-locate-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePropertyReferenceIdLocateDelete1(id: string, propertyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePropertyReferenceIdLocateDelete1(id, propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete-locate-by-locate-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePropertyReferenceLocateDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePropertyReferenceLocateDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete-system-by-locate-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePropertyReferenceLocateDelete1(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePropertyReferenceLocateDelete1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-locate-by-locate-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followPropertyReferenceLocateGet(id: string, propertyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followPropertyReferenceLocateGet(id, propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-locate-by-locate-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followPropertyReferenceLocateGet1(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followPropertyReferenceLocateGet1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-system-by-locate-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followPropertyReferenceLocateGet2(id: string, propertyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelSystem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followPropertyReferenceLocateGet2(id, propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-system-by-locate-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followPropertyReferenceLocateGet21(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelSystem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followPropertyReferenceLocateGet21(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LocatePropertyReferenceControllerApi - factory interface
 * @export
 */
export const LocatePropertyReferenceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocatePropertyReferenceControllerApiFp(configuration)
    return {
        /**
         * patch-locate-by-locate-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceLocatePatch(id: string, collectionModelObject: CollectionModelObject, options?: any): AxiosPromise<void> {
            return localVarFp.createPropertyReferenceLocatePatch(id, collectionModelObject, options).then((request) => request(axios, basePath));
        },
        /**
         * patch-system-by-locate-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceLocatePatch1(id: string, collectionModelObject: CollectionModelObject, options?: any): AxiosPromise<EntityModelSystem> {
            return localVarFp.createPropertyReferenceLocatePatch1(id, collectionModelObject, options).then((request) => request(axios, basePath));
        },
        /**
         * update-locate-by-locate-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceLocatePut(id: string, collectionModelObject: CollectionModelObject, options?: any): AxiosPromise<void> {
            return localVarFp.createPropertyReferenceLocatePut(id, collectionModelObject, options).then((request) => request(axios, basePath));
        },
        /**
         * update-system-by-locate-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceLocatePut1(id: string, collectionModelObject: CollectionModelObject, options?: any): AxiosPromise<EntityModelSystem> {
            return localVarFp.createPropertyReferenceLocatePut1(id, collectionModelObject, options).then((request) => request(axios, basePath));
        },
        /**
         * delete-locate-by-locate-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceIdLocateDelete(id: string, propertyId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePropertyReferenceIdLocateDelete(id, propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * delete-system-by-locate-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceIdLocateDelete1(id: string, propertyId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePropertyReferenceIdLocateDelete1(id, propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * delete-locate-by-locate-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceLocateDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePropertyReferenceLocateDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * delete-system-by-locate-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceLocateDelete1(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePropertyReferenceLocateDelete1(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-locate-by-locate-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceLocateGet(id: string, propertyId: string, options?: any): AxiosPromise<void> {
            return localVarFp.followPropertyReferenceLocateGet(id, propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * get-locate-by-locate-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceLocateGet1(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.followPropertyReferenceLocateGet1(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-system-by-locate-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceLocateGet2(id: string, propertyId: string, options?: any): AxiosPromise<EntityModelSystem> {
            return localVarFp.followPropertyReferenceLocateGet2(id, propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * get-system-by-locate-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceLocateGet21(id: string, options?: any): AxiosPromise<EntityModelSystem> {
            return localVarFp.followPropertyReferenceLocateGet21(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocatePropertyReferenceControllerApi - object-oriented interface
 * @export
 * @class LocatePropertyReferenceControllerApi
 * @extends {BaseAPI}
 */
export class LocatePropertyReferenceControllerApi extends BaseAPI {
    /**
     * patch-locate-by-locate-Id
     * @param {string} id 
     * @param {CollectionModelObject} collectionModelObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocatePropertyReferenceControllerApi
     */
    public createPropertyReferenceLocatePatch(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig) {
        return LocatePropertyReferenceControllerApiFp(this.configuration).createPropertyReferenceLocatePatch(id, collectionModelObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * patch-system-by-locate-Id
     * @param {string} id 
     * @param {CollectionModelObject} collectionModelObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocatePropertyReferenceControllerApi
     */
    public createPropertyReferenceLocatePatch1(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig) {
        return LocatePropertyReferenceControllerApiFp(this.configuration).createPropertyReferenceLocatePatch1(id, collectionModelObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-locate-by-locate-Id
     * @param {string} id 
     * @param {CollectionModelObject} collectionModelObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocatePropertyReferenceControllerApi
     */
    public createPropertyReferenceLocatePut(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig) {
        return LocatePropertyReferenceControllerApiFp(this.configuration).createPropertyReferenceLocatePut(id, collectionModelObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-system-by-locate-Id
     * @param {string} id 
     * @param {CollectionModelObject} collectionModelObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocatePropertyReferenceControllerApi
     */
    public createPropertyReferenceLocatePut1(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig) {
        return LocatePropertyReferenceControllerApiFp(this.configuration).createPropertyReferenceLocatePut1(id, collectionModelObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete-locate-by-locate-Id
     * @param {string} id 
     * @param {string} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocatePropertyReferenceControllerApi
     */
    public deletePropertyReferenceIdLocateDelete(id: string, propertyId: string, options?: AxiosRequestConfig) {
        return LocatePropertyReferenceControllerApiFp(this.configuration).deletePropertyReferenceIdLocateDelete(id, propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete-system-by-locate-Id
     * @param {string} id 
     * @param {string} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocatePropertyReferenceControllerApi
     */
    public deletePropertyReferenceIdLocateDelete1(id: string, propertyId: string, options?: AxiosRequestConfig) {
        return LocatePropertyReferenceControllerApiFp(this.configuration).deletePropertyReferenceIdLocateDelete1(id, propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete-locate-by-locate-Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocatePropertyReferenceControllerApi
     */
    public deletePropertyReferenceLocateDelete(id: string, options?: AxiosRequestConfig) {
        return LocatePropertyReferenceControllerApiFp(this.configuration).deletePropertyReferenceLocateDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete-system-by-locate-Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocatePropertyReferenceControllerApi
     */
    public deletePropertyReferenceLocateDelete1(id: string, options?: AxiosRequestConfig) {
        return LocatePropertyReferenceControllerApiFp(this.configuration).deletePropertyReferenceLocateDelete1(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-locate-by-locate-Id
     * @param {string} id 
     * @param {string} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocatePropertyReferenceControllerApi
     */
    public followPropertyReferenceLocateGet(id: string, propertyId: string, options?: AxiosRequestConfig) {
        return LocatePropertyReferenceControllerApiFp(this.configuration).followPropertyReferenceLocateGet(id, propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-locate-by-locate-Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocatePropertyReferenceControllerApi
     */
    public followPropertyReferenceLocateGet1(id: string, options?: AxiosRequestConfig) {
        return LocatePropertyReferenceControllerApiFp(this.configuration).followPropertyReferenceLocateGet1(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-system-by-locate-Id
     * @param {string} id 
     * @param {string} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocatePropertyReferenceControllerApi
     */
    public followPropertyReferenceLocateGet2(id: string, propertyId: string, options?: AxiosRequestConfig) {
        return LocatePropertyReferenceControllerApiFp(this.configuration).followPropertyReferenceLocateGet2(id, propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-system-by-locate-Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocatePropertyReferenceControllerApi
     */
    public followPropertyReferenceLocateGet21(id: string, options?: AxiosRequestConfig) {
        return LocatePropertyReferenceControllerApiFp(this.configuration).followPropertyReferenceLocateGet21(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LocateSearchControllerApi - axios parameter creator
 * @export
 */
export const LocateSearchControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchLocateGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/locates/search/findAllByNameIsNotNull`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {System} [system] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchLocateGet1: async (system?: System, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/locates/search/findAllBySystem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (system !== undefined) {
                localVarQueryParameter['system'] = system;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocateSearchControllerApi - functional programming interface
 * @export
 */
export const LocateSearchControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocateSearchControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSearchLocateGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSearchLocateGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {System} [system] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSearchLocateGet1(system?: System, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSearchLocateGet1(system, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LocateSearchControllerApi - factory interface
 * @export
 */
export const LocateSearchControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocateSearchControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchLocateGet(options?: any): AxiosPromise<void> {
            return localVarFp.executeSearchLocateGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {System} [system] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchLocateGet1(system?: System, options?: any): AxiosPromise<void> {
            return localVarFp.executeSearchLocateGet1(system, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocateSearchControllerApi - object-oriented interface
 * @export
 * @class LocateSearchControllerApi
 * @extends {BaseAPI}
 */
export class LocateSearchControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocateSearchControllerApi
     */
    public executeSearchLocateGet(options?: AxiosRequestConfig) {
        return LocateSearchControllerApiFp(this.configuration).executeSearchLocateGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {System} [system] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocateSearchControllerApi
     */
    public executeSearchLocateGet1(system?: System, options?: AxiosRequestConfig) {
        return LocateSearchControllerApiFp(this.configuration).executeSearchLocateGet1(system, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MgmtInfoControllerApi - axios parameter creator
 * @export
 */
export const MgmtInfoControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuildTimestamp: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/version/info/build`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MgmtInfoControllerApi - functional programming interface
 * @export
 */
export const MgmtInfoControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MgmtInfoControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBuildTimestamp(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBuildTimestamp(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MgmtInfoControllerApi - factory interface
 * @export
 */
export const MgmtInfoControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MgmtInfoControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuildTimestamp(options?: any): AxiosPromise<string> {
            return localVarFp.getBuildTimestamp(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MgmtInfoControllerApi - object-oriented interface
 * @export
 * @class MgmtInfoControllerApi
 * @extends {BaseAPI}
 */
export class MgmtInfoControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MgmtInfoControllerApi
     */
    public getBuildTimestamp(options?: AxiosRequestConfig) {
        return MgmtInfoControllerApiFp(this.configuration).getBuildTimestamp(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ParsingControllerApi - axios parameter creator
 * @export
 */
export const ParsingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Parse CodeGen
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParsedCommands: async (body: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getParsedCommands', 'body', body)
            const localVarPath = `/api/parsing/codegen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Parse Locator
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParsedLocator: async (body: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getParsedLocator', 'body', body)
            const localVarPath = `/api/parsing/locator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ParsingControllerApi - functional programming interface
 * @export
 */
export const ParsingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ParsingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Parse CodeGen
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParsedCommands(body: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParsedCommands(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Parse Locator
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParsedLocator(body: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParsedLocator(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ParsingControllerApi - factory interface
 * @export
 */
export const ParsingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ParsingControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Parse CodeGen
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParsedCommands(body: string, options?: any): AxiosPromise<object> {
            return localVarFp.getParsedCommands(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Parse Locator
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParsedLocator(body: string, options?: any): AxiosPromise<LocateDto> {
            return localVarFp.getParsedLocator(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ParsingControllerApi - object-oriented interface
 * @export
 * @class ParsingControllerApi
 * @extends {BaseAPI}
 */
export class ParsingControllerApi extends BaseAPI {
    /**
     * 
     * @summary Parse CodeGen
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParsingControllerApi
     */
    public getParsedCommands(body: string, options?: AxiosRequestConfig) {
        return ParsingControllerApiFp(this.configuration).getParsedCommands(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Parse Locator
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParsingControllerApi
     */
    public getParsedLocator(body: string, options?: AxiosRequestConfig) {
        return ParsingControllerApiFp(this.configuration).getParsedLocator(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PasswordControllerApi - axios parameter creator
 * @export
 */
export const PasswordControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PasswordDto} passwordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNewPassword: async (passwordDto: PasswordDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordDto' is not null or undefined
            assertParamExists('addNewPassword', 'passwordDto', passwordDto)
            const localVarPath = `/api/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePasswordById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePasswordById', 'id', id)
            const localVarPath = `/api/password/id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePasswordByName: async (name: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('deletePasswordByName', 'name', name)
            const localVarPath = `/api/password/(/name`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPasswordNameAndDescriptionById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPasswordNameAndDescriptionById', 'id', id)
            const localVarPath = `/api/password/byId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPasswords: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PasswordDto} passwordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword: async (passwordDto: PasswordDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordDto' is not null or undefined
            assertParamExists('updatePassword', 'passwordDto', passwordDto)
            const localVarPath = `/api/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PasswordControllerApi - functional programming interface
 * @export
 */
export const PasswordControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PasswordControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {PasswordDto} passwordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addNewPassword(passwordDto: PasswordDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addNewPassword(passwordDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePasswordById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePasswordById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePasswordByName(name: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePasswordByName(name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPasswordNameAndDescriptionById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PasswordDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPasswordNameAndDescriptionById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPasswords(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PasswordDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPasswords(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PasswordDto} passwordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePassword(passwordDto: PasswordDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePassword(passwordDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PasswordControllerApi - factory interface
 * @export
 */
export const PasswordControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PasswordControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {PasswordDto} passwordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNewPassword(passwordDto: PasswordDto, options?: any): AxiosPromise<string> {
            return localVarFp.addNewPassword(passwordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePasswordById(id: number, options?: any): AxiosPromise<string> {
            return localVarFp.deletePasswordById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePasswordByName(name: string, options?: any): AxiosPromise<string> {
            return localVarFp.deletePasswordByName(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPasswordNameAndDescriptionById(id: number, options?: any): AxiosPromise<PasswordDto> {
            return localVarFp.getPasswordNameAndDescriptionById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPasswords(options?: any): AxiosPromise<Array<PasswordDto>> {
            return localVarFp.getPasswords(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PasswordDto} passwordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword(passwordDto: PasswordDto, options?: any): AxiosPromise<string> {
            return localVarFp.updatePassword(passwordDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PasswordControllerApi - object-oriented interface
 * @export
 * @class PasswordControllerApi
 * @extends {BaseAPI}
 */
export class PasswordControllerApi extends BaseAPI {
    /**
     * 
     * @param {PasswordDto} passwordDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordControllerApi
     */
    public addNewPassword(passwordDto: PasswordDto, options?: AxiosRequestConfig) {
        return PasswordControllerApiFp(this.configuration).addNewPassword(passwordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordControllerApi
     */
    public deletePasswordById(id: number, options?: AxiosRequestConfig) {
        return PasswordControllerApiFp(this.configuration).deletePasswordById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordControllerApi
     */
    public deletePasswordByName(name: string, options?: AxiosRequestConfig) {
        return PasswordControllerApiFp(this.configuration).deletePasswordByName(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordControllerApi
     */
    public getPasswordNameAndDescriptionById(id: number, options?: AxiosRequestConfig) {
        return PasswordControllerApiFp(this.configuration).getPasswordNameAndDescriptionById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordControllerApi
     */
    public getPasswords(options?: AxiosRequestConfig) {
        return PasswordControllerApiFp(this.configuration).getPasswords(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PasswordDto} passwordDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordControllerApi
     */
    public updatePassword(passwordDto: PasswordDto, options?: AxiosRequestConfig) {
        return PasswordControllerApiFp(this.configuration).updatePassword(passwordDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PasswordEntityControllerApi - axios parameter creator
 * @export
 */
export const PasswordEntityControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * delete-password
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourcePasswordDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteItemResourcePasswordDelete', 'id', id)
            const localVarPath = `/passwords/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-password
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourcePasswordGet1: async (page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/passwords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-password
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourcePasswordGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getItemResourcePasswordGet', 'id', id)
            const localVarPath = `/passwords/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch-password
         * @param {string} id 
         * @param {PasswordRequestBody} passwordRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourcePasswordPatch: async (id: string, passwordRequestBody: PasswordRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchItemResourcePasswordPatch', 'id', id)
            // verify required parameter 'passwordRequestBody' is not null or undefined
            assertParamExists('patchItemResourcePasswordPatch', 'passwordRequestBody', passwordRequestBody)
            const localVarPath = `/passwords/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create-password
         * @param {PasswordRequestBody} passwordRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourcePasswordPost: async (passwordRequestBody: PasswordRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordRequestBody' is not null or undefined
            assertParamExists('postCollectionResourcePasswordPost', 'passwordRequestBody', passwordRequestBody)
            const localVarPath = `/passwords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-password
         * @param {string} id 
         * @param {PasswordRequestBody} passwordRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourcePasswordPut: async (id: string, passwordRequestBody: PasswordRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putItemResourcePasswordPut', 'id', id)
            // verify required parameter 'passwordRequestBody' is not null or undefined
            assertParamExists('putItemResourcePasswordPut', 'passwordRequestBody', passwordRequestBody)
            const localVarPath = `/passwords/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PasswordEntityControllerApi - functional programming interface
 * @export
 */
export const PasswordEntityControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PasswordEntityControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * delete-password
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteItemResourcePasswordDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteItemResourcePasswordDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-password
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollectionResourcePasswordGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedModelEntityModelPassword>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollectionResourcePasswordGet1(page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-password
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getItemResourcePasswordGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelPassword>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getItemResourcePasswordGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * patch-password
         * @param {string} id 
         * @param {PasswordRequestBody} passwordRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchItemResourcePasswordPatch(id: string, passwordRequestBody: PasswordRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelPassword>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchItemResourcePasswordPatch(id, passwordRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * create-password
         * @param {PasswordRequestBody} passwordRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCollectionResourcePasswordPost(passwordRequestBody: PasswordRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelPassword>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCollectionResourcePasswordPost(passwordRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-password
         * @param {string} id 
         * @param {PasswordRequestBody} passwordRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putItemResourcePasswordPut(id: string, passwordRequestBody: PasswordRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelPassword>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putItemResourcePasswordPut(id, passwordRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PasswordEntityControllerApi - factory interface
 * @export
 */
export const PasswordEntityControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PasswordEntityControllerApiFp(configuration)
    return {
        /**
         * delete-password
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourcePasswordDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteItemResourcePasswordDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-password
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourcePasswordGet1(page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PagedModelEntityModelPassword> {
            return localVarFp.getCollectionResourcePasswordGet1(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * get-password
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourcePasswordGet(id: string, options?: any): AxiosPromise<EntityModelPassword> {
            return localVarFp.getItemResourcePasswordGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * patch-password
         * @param {string} id 
         * @param {PasswordRequestBody} passwordRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourcePasswordPatch(id: string, passwordRequestBody: PasswordRequestBody, options?: any): AxiosPromise<EntityModelPassword> {
            return localVarFp.patchItemResourcePasswordPatch(id, passwordRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * create-password
         * @param {PasswordRequestBody} passwordRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourcePasswordPost(passwordRequestBody: PasswordRequestBody, options?: any): AxiosPromise<EntityModelPassword> {
            return localVarFp.postCollectionResourcePasswordPost(passwordRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * update-password
         * @param {string} id 
         * @param {PasswordRequestBody} passwordRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourcePasswordPut(id: string, passwordRequestBody: PasswordRequestBody, options?: any): AxiosPromise<EntityModelPassword> {
            return localVarFp.putItemResourcePasswordPut(id, passwordRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PasswordEntityControllerApi - object-oriented interface
 * @export
 * @class PasswordEntityControllerApi
 * @extends {BaseAPI}
 */
export class PasswordEntityControllerApi extends BaseAPI {
    /**
     * delete-password
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordEntityControllerApi
     */
    public deleteItemResourcePasswordDelete(id: string, options?: AxiosRequestConfig) {
        return PasswordEntityControllerApiFp(this.configuration).deleteItemResourcePasswordDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-password
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordEntityControllerApi
     */
    public getCollectionResourcePasswordGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return PasswordEntityControllerApiFp(this.configuration).getCollectionResourcePasswordGet1(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-password
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordEntityControllerApi
     */
    public getItemResourcePasswordGet(id: string, options?: AxiosRequestConfig) {
        return PasswordEntityControllerApiFp(this.configuration).getItemResourcePasswordGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * patch-password
     * @param {string} id 
     * @param {PasswordRequestBody} passwordRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordEntityControllerApi
     */
    public patchItemResourcePasswordPatch(id: string, passwordRequestBody: PasswordRequestBody, options?: AxiosRequestConfig) {
        return PasswordEntityControllerApiFp(this.configuration).patchItemResourcePasswordPatch(id, passwordRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create-password
     * @param {PasswordRequestBody} passwordRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordEntityControllerApi
     */
    public postCollectionResourcePasswordPost(passwordRequestBody: PasswordRequestBody, options?: AxiosRequestConfig) {
        return PasswordEntityControllerApiFp(this.configuration).postCollectionResourcePasswordPost(passwordRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-password
     * @param {string} id 
     * @param {PasswordRequestBody} passwordRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordEntityControllerApi
     */
    public putItemResourcePasswordPut(id: string, passwordRequestBody: PasswordRequestBody, options?: AxiosRequestConfig) {
        return PasswordEntityControllerApiFp(this.configuration).putItemResourcePasswordPut(id, passwordRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PasswordSearchControllerApi - axios parameter creator
 * @export
 */
export const PasswordSearchControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchPasswordGet: async (name?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/passwords/search/findPasswordByName`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PasswordSearchControllerApi - functional programming interface
 * @export
 */
export const PasswordSearchControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PasswordSearchControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSearchPasswordGet(name?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelPassword>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSearchPasswordGet(name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PasswordSearchControllerApi - factory interface
 * @export
 */
export const PasswordSearchControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PasswordSearchControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchPasswordGet(name?: string, options?: any): AxiosPromise<EntityModelPassword> {
            return localVarFp.executeSearchPasswordGet(name, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PasswordSearchControllerApi - object-oriented interface
 * @export
 * @class PasswordSearchControllerApi
 * @extends {BaseAPI}
 */
export class PasswordSearchControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordSearchControllerApi
     */
    public executeSearchPasswordGet(name?: string, options?: AxiosRequestConfig) {
        return PasswordSearchControllerApiFp(this.configuration).executeSearchPasswordGet(name, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PlaywrightConfigurationControllerApi - axios parameter creator
 * @export
 */
export const PlaywrightConfigurationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateConfiguration: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('activateConfiguration', 'id', id)
            const localVarPath = `/api/playwright/config/activate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaywrightConfigurationDto} playwrightConfigurationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConfiguration: async (playwrightConfigurationDto: PlaywrightConfigurationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'playwrightConfigurationDto' is not null or undefined
            assertParamExists('createConfiguration', 'playwrightConfigurationDto', playwrightConfigurationDto)
            const localVarPath = `/api/playwright/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(playwrightConfigurationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConfiguration: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteConfiguration', 'id', id)
            const localVarPath = `/api/playwright/config/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivePlaywrightConfiguration: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/playwright/config/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlaywrightConfigurations: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/playwright/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaywrightConfigurationDto} playwrightConfigurationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfiguration: async (playwrightConfigurationDto: PlaywrightConfigurationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'playwrightConfigurationDto' is not null or undefined
            assertParamExists('updateConfiguration', 'playwrightConfigurationDto', playwrightConfigurationDto)
            const localVarPath = `/api/playwright/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(playwrightConfigurationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlaywrightConfigurationControllerApi - functional programming interface
 * @export
 */
export const PlaywrightConfigurationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlaywrightConfigurationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateConfiguration(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaywrightConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateConfiguration(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaywrightConfigurationDto} playwrightConfigurationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createConfiguration(playwrightConfigurationDto: PlaywrightConfigurationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaywrightConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createConfiguration(playwrightConfigurationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteConfiguration(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteConfiguration(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivePlaywrightConfiguration(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaywrightConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivePlaywrightConfiguration(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlaywrightConfigurations(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlaywrightConfigurationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlaywrightConfigurations(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PlaywrightConfigurationDto} playwrightConfigurationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateConfiguration(playwrightConfigurationDto: PlaywrightConfigurationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaywrightConfigurationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateConfiguration(playwrightConfigurationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PlaywrightConfigurationControllerApi - factory interface
 * @export
 */
export const PlaywrightConfigurationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlaywrightConfigurationControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateConfiguration(id: number, options?: any): AxiosPromise<PlaywrightConfiguration> {
            return localVarFp.activateConfiguration(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaywrightConfigurationDto} playwrightConfigurationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConfiguration(playwrightConfigurationDto: PlaywrightConfigurationDto, options?: any): AxiosPromise<PlaywrightConfiguration> {
            return localVarFp.createConfiguration(playwrightConfigurationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConfiguration(id: number, options?: any): AxiosPromise<string> {
            return localVarFp.deleteConfiguration(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivePlaywrightConfiguration(options?: any): AxiosPromise<PlaywrightConfiguration> {
            return localVarFp.getActivePlaywrightConfiguration(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlaywrightConfigurations(options?: any): AxiosPromise<Array<PlaywrightConfigurationDto>> {
            return localVarFp.getPlaywrightConfigurations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaywrightConfigurationDto} playwrightConfigurationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfiguration(playwrightConfigurationDto: PlaywrightConfigurationDto, options?: any): AxiosPromise<PlaywrightConfigurationDto> {
            return localVarFp.updateConfiguration(playwrightConfigurationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlaywrightConfigurationControllerApi - object-oriented interface
 * @export
 * @class PlaywrightConfigurationControllerApi
 * @extends {BaseAPI}
 */
export class PlaywrightConfigurationControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaywrightConfigurationControllerApi
     */
    public activateConfiguration(id: number, options?: AxiosRequestConfig) {
        return PlaywrightConfigurationControllerApiFp(this.configuration).activateConfiguration(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaywrightConfigurationDto} playwrightConfigurationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaywrightConfigurationControllerApi
     */
    public createConfiguration(playwrightConfigurationDto: PlaywrightConfigurationDto, options?: AxiosRequestConfig) {
        return PlaywrightConfigurationControllerApiFp(this.configuration).createConfiguration(playwrightConfigurationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaywrightConfigurationControllerApi
     */
    public deleteConfiguration(id: number, options?: AxiosRequestConfig) {
        return PlaywrightConfigurationControllerApiFp(this.configuration).deleteConfiguration(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaywrightConfigurationControllerApi
     */
    public getActivePlaywrightConfiguration(options?: AxiosRequestConfig) {
        return PlaywrightConfigurationControllerApiFp(this.configuration).getActivePlaywrightConfiguration(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaywrightConfigurationControllerApi
     */
    public getPlaywrightConfigurations(options?: AxiosRequestConfig) {
        return PlaywrightConfigurationControllerApiFp(this.configuration).getPlaywrightConfigurations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaywrightConfigurationDto} playwrightConfigurationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaywrightConfigurationControllerApi
     */
    public updateConfiguration(playwrightConfigurationDto: PlaywrightConfigurationDto, options?: AxiosRequestConfig) {
        return PlaywrightConfigurationControllerApiFp(this.configuration).updateConfiguration(playwrightConfigurationDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PlaywrightConfigurationEntityControllerApi - axios parameter creator
 * @export
 */
export const PlaywrightConfigurationEntityControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * delete-playwrightconfiguration
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourcePlaywrightconfigurationDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteItemResourcePlaywrightconfigurationDelete', 'id', id)
            const localVarPath = `/playwrightConfigurations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-playwrightconfiguration
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourcePlaywrightconfigurationGet1: async (page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/playwrightConfigurations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-playwrightconfiguration
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourcePlaywrightconfigurationGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getItemResourcePlaywrightconfigurationGet', 'id', id)
            const localVarPath = `/playwrightConfigurations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch-playwrightconfiguration
         * @param {string} id 
         * @param {PlaywrightConfigurationRequestBody} playwrightConfigurationRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourcePlaywrightconfigurationPatch: async (id: string, playwrightConfigurationRequestBody: PlaywrightConfigurationRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchItemResourcePlaywrightconfigurationPatch', 'id', id)
            // verify required parameter 'playwrightConfigurationRequestBody' is not null or undefined
            assertParamExists('patchItemResourcePlaywrightconfigurationPatch', 'playwrightConfigurationRequestBody', playwrightConfigurationRequestBody)
            const localVarPath = `/playwrightConfigurations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(playwrightConfigurationRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create-playwrightconfiguration
         * @param {PlaywrightConfigurationRequestBody} playwrightConfigurationRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourcePlaywrightconfigurationPost: async (playwrightConfigurationRequestBody: PlaywrightConfigurationRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'playwrightConfigurationRequestBody' is not null or undefined
            assertParamExists('postCollectionResourcePlaywrightconfigurationPost', 'playwrightConfigurationRequestBody', playwrightConfigurationRequestBody)
            const localVarPath = `/playwrightConfigurations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(playwrightConfigurationRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-playwrightconfiguration
         * @param {string} id 
         * @param {PlaywrightConfigurationRequestBody} playwrightConfigurationRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourcePlaywrightconfigurationPut: async (id: string, playwrightConfigurationRequestBody: PlaywrightConfigurationRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putItemResourcePlaywrightconfigurationPut', 'id', id)
            // verify required parameter 'playwrightConfigurationRequestBody' is not null or undefined
            assertParamExists('putItemResourcePlaywrightconfigurationPut', 'playwrightConfigurationRequestBody', playwrightConfigurationRequestBody)
            const localVarPath = `/playwrightConfigurations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(playwrightConfigurationRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlaywrightConfigurationEntityControllerApi - functional programming interface
 * @export
 */
export const PlaywrightConfigurationEntityControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlaywrightConfigurationEntityControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * delete-playwrightconfiguration
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteItemResourcePlaywrightconfigurationDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteItemResourcePlaywrightconfigurationDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-playwrightconfiguration
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollectionResourcePlaywrightconfigurationGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedModelEntityModelPlaywrightConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollectionResourcePlaywrightconfigurationGet1(page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-playwrightconfiguration
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getItemResourcePlaywrightconfigurationGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelPlaywrightConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getItemResourcePlaywrightconfigurationGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * patch-playwrightconfiguration
         * @param {string} id 
         * @param {PlaywrightConfigurationRequestBody} playwrightConfigurationRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchItemResourcePlaywrightconfigurationPatch(id: string, playwrightConfigurationRequestBody: PlaywrightConfigurationRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelPlaywrightConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchItemResourcePlaywrightconfigurationPatch(id, playwrightConfigurationRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * create-playwrightconfiguration
         * @param {PlaywrightConfigurationRequestBody} playwrightConfigurationRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCollectionResourcePlaywrightconfigurationPost(playwrightConfigurationRequestBody: PlaywrightConfigurationRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelPlaywrightConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCollectionResourcePlaywrightconfigurationPost(playwrightConfigurationRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-playwrightconfiguration
         * @param {string} id 
         * @param {PlaywrightConfigurationRequestBody} playwrightConfigurationRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putItemResourcePlaywrightconfigurationPut(id: string, playwrightConfigurationRequestBody: PlaywrightConfigurationRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelPlaywrightConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putItemResourcePlaywrightconfigurationPut(id, playwrightConfigurationRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PlaywrightConfigurationEntityControllerApi - factory interface
 * @export
 */
export const PlaywrightConfigurationEntityControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlaywrightConfigurationEntityControllerApiFp(configuration)
    return {
        /**
         * delete-playwrightconfiguration
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourcePlaywrightconfigurationDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteItemResourcePlaywrightconfigurationDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-playwrightconfiguration
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourcePlaywrightconfigurationGet1(page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PagedModelEntityModelPlaywrightConfiguration> {
            return localVarFp.getCollectionResourcePlaywrightconfigurationGet1(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * get-playwrightconfiguration
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourcePlaywrightconfigurationGet(id: string, options?: any): AxiosPromise<EntityModelPlaywrightConfiguration> {
            return localVarFp.getItemResourcePlaywrightconfigurationGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * patch-playwrightconfiguration
         * @param {string} id 
         * @param {PlaywrightConfigurationRequestBody} playwrightConfigurationRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourcePlaywrightconfigurationPatch(id: string, playwrightConfigurationRequestBody: PlaywrightConfigurationRequestBody, options?: any): AxiosPromise<EntityModelPlaywrightConfiguration> {
            return localVarFp.patchItemResourcePlaywrightconfigurationPatch(id, playwrightConfigurationRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * create-playwrightconfiguration
         * @param {PlaywrightConfigurationRequestBody} playwrightConfigurationRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourcePlaywrightconfigurationPost(playwrightConfigurationRequestBody: PlaywrightConfigurationRequestBody, options?: any): AxiosPromise<EntityModelPlaywrightConfiguration> {
            return localVarFp.postCollectionResourcePlaywrightconfigurationPost(playwrightConfigurationRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * update-playwrightconfiguration
         * @param {string} id 
         * @param {PlaywrightConfigurationRequestBody} playwrightConfigurationRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourcePlaywrightconfigurationPut(id: string, playwrightConfigurationRequestBody: PlaywrightConfigurationRequestBody, options?: any): AxiosPromise<EntityModelPlaywrightConfiguration> {
            return localVarFp.putItemResourcePlaywrightconfigurationPut(id, playwrightConfigurationRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlaywrightConfigurationEntityControllerApi - object-oriented interface
 * @export
 * @class PlaywrightConfigurationEntityControllerApi
 * @extends {BaseAPI}
 */
export class PlaywrightConfigurationEntityControllerApi extends BaseAPI {
    /**
     * delete-playwrightconfiguration
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaywrightConfigurationEntityControllerApi
     */
    public deleteItemResourcePlaywrightconfigurationDelete(id: string, options?: AxiosRequestConfig) {
        return PlaywrightConfigurationEntityControllerApiFp(this.configuration).deleteItemResourcePlaywrightconfigurationDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-playwrightconfiguration
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaywrightConfigurationEntityControllerApi
     */
    public getCollectionResourcePlaywrightconfigurationGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return PlaywrightConfigurationEntityControllerApiFp(this.configuration).getCollectionResourcePlaywrightconfigurationGet1(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-playwrightconfiguration
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaywrightConfigurationEntityControllerApi
     */
    public getItemResourcePlaywrightconfigurationGet(id: string, options?: AxiosRequestConfig) {
        return PlaywrightConfigurationEntityControllerApiFp(this.configuration).getItemResourcePlaywrightconfigurationGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * patch-playwrightconfiguration
     * @param {string} id 
     * @param {PlaywrightConfigurationRequestBody} playwrightConfigurationRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaywrightConfigurationEntityControllerApi
     */
    public patchItemResourcePlaywrightconfigurationPatch(id: string, playwrightConfigurationRequestBody: PlaywrightConfigurationRequestBody, options?: AxiosRequestConfig) {
        return PlaywrightConfigurationEntityControllerApiFp(this.configuration).patchItemResourcePlaywrightconfigurationPatch(id, playwrightConfigurationRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create-playwrightconfiguration
     * @param {PlaywrightConfigurationRequestBody} playwrightConfigurationRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaywrightConfigurationEntityControllerApi
     */
    public postCollectionResourcePlaywrightconfigurationPost(playwrightConfigurationRequestBody: PlaywrightConfigurationRequestBody, options?: AxiosRequestConfig) {
        return PlaywrightConfigurationEntityControllerApiFp(this.configuration).postCollectionResourcePlaywrightconfigurationPost(playwrightConfigurationRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-playwrightconfiguration
     * @param {string} id 
     * @param {PlaywrightConfigurationRequestBody} playwrightConfigurationRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaywrightConfigurationEntityControllerApi
     */
    public putItemResourcePlaywrightconfigurationPut(id: string, playwrightConfigurationRequestBody: PlaywrightConfigurationRequestBody, options?: AxiosRequestConfig) {
        return PlaywrightConfigurationEntityControllerApiFp(this.configuration).putItemResourcePlaywrightconfigurationPut(id, playwrightConfigurationRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PlaywrightConfigurationSearchControllerApi - axios parameter creator
 * @export
 */
export const PlaywrightConfigurationSearchControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchPlaywrightconfigurationGet: async (active?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/playwrightConfigurations/search/findAllByIsActive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlaywrightConfigurationSearchControllerApi - functional programming interface
 * @export
 */
export const PlaywrightConfigurationSearchControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlaywrightConfigurationSearchControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSearchPlaywrightconfigurationGet(active?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionModelEntityModelPlaywrightConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSearchPlaywrightconfigurationGet(active, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PlaywrightConfigurationSearchControllerApi - factory interface
 * @export
 */
export const PlaywrightConfigurationSearchControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlaywrightConfigurationSearchControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchPlaywrightconfigurationGet(active?: boolean, options?: any): AxiosPromise<CollectionModelEntityModelPlaywrightConfiguration> {
            return localVarFp.executeSearchPlaywrightconfigurationGet(active, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlaywrightConfigurationSearchControllerApi - object-oriented interface
 * @export
 * @class PlaywrightConfigurationSearchControllerApi
 * @extends {BaseAPI}
 */
export class PlaywrightConfigurationSearchControllerApi extends BaseAPI {
    /**
     * 
     * @param {boolean} [active] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaywrightConfigurationSearchControllerApi
     */
    public executeSearchPlaywrightconfigurationGet(active?: boolean, options?: AxiosRequestConfig) {
        return PlaywrightConfigurationSearchControllerApiFp(this.configuration).executeSearchPlaywrightconfigurationGet(active, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PlaywrightControllerApi - axios parameter creator
 * @export
 */
export const PlaywrightControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} traceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadTrace: async (traceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'traceId' is not null or undefined
            assertParamExists('downloadTrace', 'traceId', traceId)
            const localVarPath = `/api/playwright/traces/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (traceId !== undefined) {
                localVarQueryParameter['traceId'] = traceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} testResultId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTracesForTestResultId: async (testResultId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testResultId' is not null or undefined
            assertParamExists('getTracesForTestResultId', 'testResultId', testResultId)
            const localVarPath = `/api/playwright/traces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (testResultId !== undefined) {
                localVarQueryParameter['testResultId'] = testResultId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlaywrightControllerApi - functional programming interface
 * @export
 */
export const PlaywrightControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlaywrightControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} traceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadTrace(traceId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadTrace(traceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} testResultId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTracesForTestResultId(testResultId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Trace>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTracesForTestResultId(testResultId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PlaywrightControllerApi - factory interface
 * @export
 */
export const PlaywrightControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlaywrightControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} traceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadTrace(traceId: number, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.downloadTrace(traceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} testResultId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTracesForTestResultId(testResultId: number, options?: any): AxiosPromise<Array<Trace>> {
            return localVarFp.getTracesForTestResultId(testResultId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlaywrightControllerApi - object-oriented interface
 * @export
 * @class PlaywrightControllerApi
 * @extends {BaseAPI}
 */
export class PlaywrightControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} traceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaywrightControllerApi
     */
    public downloadTrace(traceId: number, options?: AxiosRequestConfig) {
        return PlaywrightControllerApiFp(this.configuration).downloadTrace(traceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} testResultId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaywrightControllerApi
     */
    public getTracesForTestResultId(testResultId: number, options?: AxiosRequestConfig) {
        return PlaywrightControllerApiFp(this.configuration).getTracesForTestResultId(testResultId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PrefabControllerApi - axios parameter creator
 * @export
 */
export const PrefabControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new Prefab from CommandDtoList, name of test and for which system
         * @param {PrefabDto} prefabDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewPrefab: async (prefabDto: PrefabDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prefabDto' is not null or undefined
            assertParamExists('createNewPrefab', 'prefabDto', prefabDto)
            const localVarPath = `/api/prefab`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(prefabDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Prefab by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePrefab: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePrefab', 'id', id)
            const localVarPath = `/api/prefab/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Prefabs for the system with Page
         * @param {string} systemName 
         * @param {number} pageSize 
         * @param {number} pageNumber 
         * @param {Array<string>} sortPage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPageablePrefabsBySystem: async (systemName: string, pageSize: number, pageNumber: number, sortPage: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemName' is not null or undefined
            assertParamExists('getAllPageablePrefabsBySystem', 'systemName', systemName)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('getAllPageablePrefabsBySystem', 'pageSize', pageSize)
            // verify required parameter 'pageNumber' is not null or undefined
            assertParamExists('getAllPageablePrefabsBySystem', 'pageNumber', pageNumber)
            // verify required parameter 'sortPage' is not null or undefined
            assertParamExists('getAllPageablePrefabsBySystem', 'sortPage', sortPage)
            const localVarPath = `/api/prefab/system/{systemName}/pageable`
                .replace(`{${"systemName"}}`, encodeURIComponent(String(systemName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (sortPage) {
                localVarQueryParameter['sortPage'] = sortPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Prefabs for the system
         * @param {string} systemName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPrefabsBySystem: async (systemName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemName' is not null or undefined
            assertParamExists('getAllPrefabsBySystem', 'systemName', systemName)
            const localVarPath = `/api/prefab/system/{systemName}`
                .replace(`{${"systemName"}}`, encodeURIComponent(String(systemName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Prefab by Id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrefabById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPrefabById', 'id', id)
            const localVarPath = `/api/prefab/id/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update existing Prefab with new commandDtoList, name of test, system and id
         * @param {PrefabDto} prefabDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrefab: async (prefabDto: PrefabDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prefabDto' is not null or undefined
            assertParamExists('updatePrefab', 'prefabDto', prefabDto)
            const localVarPath = `/api/prefab`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(prefabDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Predefined-Variables
         * @param {number} id 
         * @param {{ [key: string]: string; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrefabPredefinedVariables: async (id: number, requestBody: { [key: string]: string; }, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePrefabPredefinedVariables', 'id', id)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('updatePrefabPredefinedVariables', 'requestBody', requestBody)
            const localVarPath = `/api/prefab/variables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrefabControllerApi - functional programming interface
 * @export
 */
export const PrefabControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrefabControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create new Prefab from CommandDtoList, name of test and for which system
         * @param {PrefabDto} prefabDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNewPrefab(prefabDto: PrefabDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNewPrefab(prefabDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete Prefab by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePrefab(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePrefab(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all Prefabs for the system with Page
         * @param {string} systemName 
         * @param {number} pageSize 
         * @param {number} pageNumber 
         * @param {Array<string>} sortPage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPageablePrefabsBySystem(systemName: string, pageSize: number, pageNumber: number, sortPage: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagePrefabDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPageablePrefabsBySystem(systemName, pageSize, pageNumber, sortPage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all Prefabs for the system
         * @param {string} systemName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPrefabsBySystem(systemName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PrefabDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPrefabsBySystem(systemName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Prefab by Id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrefabById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrefabDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrefabById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update existing Prefab with new commandDtoList, name of test, system and id
         * @param {PrefabDto} prefabDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePrefab(prefabDto: PrefabDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePrefab(prefabDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Predefined-Variables
         * @param {number} id 
         * @param {{ [key: string]: string; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePrefabPredefinedVariables(id: number, requestBody: { [key: string]: string; }, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePrefabPredefinedVariables(id, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PrefabControllerApi - factory interface
 * @export
 */
export const PrefabControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrefabControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Create new Prefab from CommandDtoList, name of test and for which system
         * @param {PrefabDto} prefabDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewPrefab(prefabDto: PrefabDto, options?: any): AxiosPromise<object> {
            return localVarFp.createNewPrefab(prefabDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Prefab by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePrefab(id: number, options?: any): AxiosPromise<string> {
            return localVarFp.deletePrefab(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all Prefabs for the system with Page
         * @param {string} systemName 
         * @param {number} pageSize 
         * @param {number} pageNumber 
         * @param {Array<string>} sortPage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPageablePrefabsBySystem(systemName: string, pageSize: number, pageNumber: number, sortPage: Array<string>, options?: any): AxiosPromise<PagePrefabDto> {
            return localVarFp.getAllPageablePrefabsBySystem(systemName, pageSize, pageNumber, sortPage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all Prefabs for the system
         * @param {string} systemName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPrefabsBySystem(systemName: string, options?: any): AxiosPromise<Array<PrefabDto>> {
            return localVarFp.getAllPrefabsBySystem(systemName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Prefab by Id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrefabById(id: number, options?: any): AxiosPromise<PrefabDto> {
            return localVarFp.getPrefabById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update existing Prefab with new commandDtoList, name of test, system and id
         * @param {PrefabDto} prefabDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrefab(prefabDto: PrefabDto, options?: any): AxiosPromise<string> {
            return localVarFp.updatePrefab(prefabDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Predefined-Variables
         * @param {number} id 
         * @param {{ [key: string]: string; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrefabPredefinedVariables(id: number, requestBody: { [key: string]: string; }, options?: any): AxiosPromise<string> {
            return localVarFp.updatePrefabPredefinedVariables(id, requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PrefabControllerApi - object-oriented interface
 * @export
 * @class PrefabControllerApi
 * @extends {BaseAPI}
 */
export class PrefabControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create new Prefab from CommandDtoList, name of test and for which system
     * @param {PrefabDto} prefabDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrefabControllerApi
     */
    public createNewPrefab(prefabDto: PrefabDto, options?: AxiosRequestConfig) {
        return PrefabControllerApiFp(this.configuration).createNewPrefab(prefabDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Prefab by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrefabControllerApi
     */
    public deletePrefab(id: number, options?: AxiosRequestConfig) {
        return PrefabControllerApiFp(this.configuration).deletePrefab(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all Prefabs for the system with Page
     * @param {string} systemName 
     * @param {number} pageSize 
     * @param {number} pageNumber 
     * @param {Array<string>} sortPage 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrefabControllerApi
     */
    public getAllPageablePrefabsBySystem(systemName: string, pageSize: number, pageNumber: number, sortPage: Array<string>, options?: AxiosRequestConfig) {
        return PrefabControllerApiFp(this.configuration).getAllPageablePrefabsBySystem(systemName, pageSize, pageNumber, sortPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all Prefabs for the system
     * @param {string} systemName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrefabControllerApi
     */
    public getAllPrefabsBySystem(systemName: string, options?: AxiosRequestConfig) {
        return PrefabControllerApiFp(this.configuration).getAllPrefabsBySystem(systemName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Prefab by Id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrefabControllerApi
     */
    public getPrefabById(id: number, options?: AxiosRequestConfig) {
        return PrefabControllerApiFp(this.configuration).getPrefabById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update existing Prefab with new commandDtoList, name of test, system and id
     * @param {PrefabDto} prefabDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrefabControllerApi
     */
    public updatePrefab(prefabDto: PrefabDto, options?: AxiosRequestConfig) {
        return PrefabControllerApiFp(this.configuration).updatePrefab(prefabDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Predefined-Variables
     * @param {number} id 
     * @param {{ [key: string]: string; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrefabControllerApi
     */
    public updatePrefabPredefinedVariables(id: number, requestBody: { [key: string]: string; }, options?: AxiosRequestConfig) {
        return PrefabControllerApiFp(this.configuration).updatePrefabPredefinedVariables(id, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PrefabEntityControllerApi - axios parameter creator
 * @export
 */
export const PrefabEntityControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * delete-prefab
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourcePrefabDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteItemResourcePrefabDelete', 'id', id)
            const localVarPath = `/prefabs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-prefab
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourcePrefabGet1: async (page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/prefabs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-prefab
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourcePrefabGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getItemResourcePrefabGet', 'id', id)
            const localVarPath = `/prefabs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch-prefab
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourcePrefabPatch: async (id: string, persistentEntityResource: PersistentEntityResource, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchItemResourcePrefabPatch', 'id', id)
            // verify required parameter 'persistentEntityResource' is not null or undefined
            assertParamExists('patchItemResourcePrefabPatch', 'persistentEntityResource', persistentEntityResource)
            const localVarPath = `/prefabs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(persistentEntityResource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create-prefab
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourcePrefabPost: async (persistentEntityResource: PersistentEntityResource, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'persistentEntityResource' is not null or undefined
            assertParamExists('postCollectionResourcePrefabPost', 'persistentEntityResource', persistentEntityResource)
            const localVarPath = `/prefabs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(persistentEntityResource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-prefab
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourcePrefabPut: async (id: string, persistentEntityResource: PersistentEntityResource, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putItemResourcePrefabPut', 'id', id)
            // verify required parameter 'persistentEntityResource' is not null or undefined
            assertParamExists('putItemResourcePrefabPut', 'persistentEntityResource', persistentEntityResource)
            const localVarPath = `/prefabs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(persistentEntityResource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrefabEntityControllerApi - functional programming interface
 * @export
 */
export const PrefabEntityControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrefabEntityControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * delete-prefab
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteItemResourcePrefabDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteItemResourcePrefabDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-prefab
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollectionResourcePrefabGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollectionResourcePrefabGet1(page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-prefab
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getItemResourcePrefabGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getItemResourcePrefabGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * patch-prefab
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchItemResourcePrefabPatch(id: string, persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchItemResourcePrefabPatch(id, persistentEntityResource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * create-prefab
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCollectionResourcePrefabPost(persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCollectionResourcePrefabPost(persistentEntityResource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-prefab
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putItemResourcePrefabPut(id: string, persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putItemResourcePrefabPut(id, persistentEntityResource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PrefabEntityControllerApi - factory interface
 * @export
 */
export const PrefabEntityControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrefabEntityControllerApiFp(configuration)
    return {
        /**
         * delete-prefab
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourcePrefabDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteItemResourcePrefabDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-prefab
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourcePrefabGet1(page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.getCollectionResourcePrefabGet1(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * get-prefab
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourcePrefabGet(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.getItemResourcePrefabGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * patch-prefab
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourcePrefabPatch(id: string, persistentEntityResource: PersistentEntityResource, options?: any): AxiosPromise<void> {
            return localVarFp.patchItemResourcePrefabPatch(id, persistentEntityResource, options).then((request) => request(axios, basePath));
        },
        /**
         * create-prefab
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourcePrefabPost(persistentEntityResource: PersistentEntityResource, options?: any): AxiosPromise<void> {
            return localVarFp.postCollectionResourcePrefabPost(persistentEntityResource, options).then((request) => request(axios, basePath));
        },
        /**
         * update-prefab
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourcePrefabPut(id: string, persistentEntityResource: PersistentEntityResource, options?: any): AxiosPromise<void> {
            return localVarFp.putItemResourcePrefabPut(id, persistentEntityResource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PrefabEntityControllerApi - object-oriented interface
 * @export
 * @class PrefabEntityControllerApi
 * @extends {BaseAPI}
 */
export class PrefabEntityControllerApi extends BaseAPI {
    /**
     * delete-prefab
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrefabEntityControllerApi
     */
    public deleteItemResourcePrefabDelete(id: string, options?: AxiosRequestConfig) {
        return PrefabEntityControllerApiFp(this.configuration).deleteItemResourcePrefabDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-prefab
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrefabEntityControllerApi
     */
    public getCollectionResourcePrefabGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return PrefabEntityControllerApiFp(this.configuration).getCollectionResourcePrefabGet1(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-prefab
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrefabEntityControllerApi
     */
    public getItemResourcePrefabGet(id: string, options?: AxiosRequestConfig) {
        return PrefabEntityControllerApiFp(this.configuration).getItemResourcePrefabGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * patch-prefab
     * @param {string} id 
     * @param {PersistentEntityResource} persistentEntityResource 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrefabEntityControllerApi
     */
    public patchItemResourcePrefabPatch(id: string, persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig) {
        return PrefabEntityControllerApiFp(this.configuration).patchItemResourcePrefabPatch(id, persistentEntityResource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create-prefab
     * @param {PersistentEntityResource} persistentEntityResource 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrefabEntityControllerApi
     */
    public postCollectionResourcePrefabPost(persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig) {
        return PrefabEntityControllerApiFp(this.configuration).postCollectionResourcePrefabPost(persistentEntityResource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-prefab
     * @param {string} id 
     * @param {PersistentEntityResource} persistentEntityResource 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrefabEntityControllerApi
     */
    public putItemResourcePrefabPut(id: string, persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig) {
        return PrefabEntityControllerApiFp(this.configuration).putItemResourcePrefabPut(id, persistentEntityResource, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PrefabPropertyReferenceControllerApi - axios parameter creator
 * @export
 */
export const PrefabPropertyReferenceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * patch-abstractcommand-by-prefab-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferencePrefabPatch: async (id: string, collectionModelObject: CollectionModelObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPropertyReferencePrefabPatch', 'id', id)
            // verify required parameter 'collectionModelObject' is not null or undefined
            assertParamExists('createPropertyReferencePrefabPatch', 'collectionModelObject', collectionModelObject)
            const localVarPath = `/prefabs/{id}/abstractCommandList`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionModelObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch-system-by-prefab-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferencePrefabPatch1: async (id: string, collectionModelObject: CollectionModelObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPropertyReferencePrefabPatch1', 'id', id)
            // verify required parameter 'collectionModelObject' is not null or undefined
            assertParamExists('createPropertyReferencePrefabPatch1', 'collectionModelObject', collectionModelObject)
            const localVarPath = `/prefabs/{id}/system`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionModelObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-abstractcommand-by-prefab-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferencePrefabPut: async (id: string, collectionModelObject: CollectionModelObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPropertyReferencePrefabPut', 'id', id)
            // verify required parameter 'collectionModelObject' is not null or undefined
            assertParamExists('createPropertyReferencePrefabPut', 'collectionModelObject', collectionModelObject)
            const localVarPath = `/prefabs/{id}/abstractCommandList`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionModelObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-system-by-prefab-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferencePrefabPut1: async (id: string, collectionModelObject: CollectionModelObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPropertyReferencePrefabPut1', 'id', id)
            // verify required parameter 'collectionModelObject' is not null or undefined
            assertParamExists('createPropertyReferencePrefabPut1', 'collectionModelObject', collectionModelObject)
            const localVarPath = `/prefabs/{id}/system`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionModelObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete-abstractcommand-by-prefab-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceIdPrefabDelete: async (id: string, propertyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePropertyReferenceIdPrefabDelete', 'id', id)
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('deletePropertyReferenceIdPrefabDelete', 'propertyId', propertyId)
            const localVarPath = `/prefabs/{id}/abstractCommandList/{propertyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete-system-by-prefab-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceIdPrefabDelete1: async (id: string, propertyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePropertyReferenceIdPrefabDelete1', 'id', id)
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('deletePropertyReferenceIdPrefabDelete1', 'propertyId', propertyId)
            const localVarPath = `/prefabs/{id}/system/{propertyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete-abstractcommand-by-prefab-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferencePrefabDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePropertyReferencePrefabDelete', 'id', id)
            const localVarPath = `/prefabs/{id}/abstractCommandList`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete-system-by-prefab-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferencePrefabDelete1: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePropertyReferencePrefabDelete1', 'id', id)
            const localVarPath = `/prefabs/{id}/system`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-abstractcommand-by-prefab-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferencePrefabGet: async (id: string, propertyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('followPropertyReferencePrefabGet', 'id', id)
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('followPropertyReferencePrefabGet', 'propertyId', propertyId)
            const localVarPath = `/prefabs/{id}/abstractCommandList/{propertyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-abstractcommand-by-prefab-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferencePrefabGet1: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('followPropertyReferencePrefabGet1', 'id', id)
            const localVarPath = `/prefabs/{id}/abstractCommandList`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-system-by-prefab-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferencePrefabGet2: async (id: string, propertyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('followPropertyReferencePrefabGet2', 'id', id)
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('followPropertyReferencePrefabGet2', 'propertyId', propertyId)
            const localVarPath = `/prefabs/{id}/system/{propertyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-system-by-prefab-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferencePrefabGet21: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('followPropertyReferencePrefabGet21', 'id', id)
            const localVarPath = `/prefabs/{id}/system`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrefabPropertyReferenceControllerApi - functional programming interface
 * @export
 */
export const PrefabPropertyReferenceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrefabPropertyReferenceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * patch-abstractcommand-by-prefab-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReferencePrefabPatch(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReferencePrefabPatch(id, collectionModelObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * patch-system-by-prefab-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReferencePrefabPatch1(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelSystem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReferencePrefabPatch1(id, collectionModelObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-abstractcommand-by-prefab-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReferencePrefabPut(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReferencePrefabPut(id, collectionModelObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-system-by-prefab-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReferencePrefabPut1(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelSystem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReferencePrefabPut1(id, collectionModelObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete-abstractcommand-by-prefab-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePropertyReferenceIdPrefabDelete(id: string, propertyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePropertyReferenceIdPrefabDelete(id, propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete-system-by-prefab-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePropertyReferenceIdPrefabDelete1(id: string, propertyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePropertyReferenceIdPrefabDelete1(id, propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete-abstractcommand-by-prefab-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePropertyReferencePrefabDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePropertyReferencePrefabDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete-system-by-prefab-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePropertyReferencePrefabDelete1(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePropertyReferencePrefabDelete1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-abstractcommand-by-prefab-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followPropertyReferencePrefabGet(id: string, propertyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followPropertyReferencePrefabGet(id, propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-abstractcommand-by-prefab-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followPropertyReferencePrefabGet1(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followPropertyReferencePrefabGet1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-system-by-prefab-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followPropertyReferencePrefabGet2(id: string, propertyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelSystem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followPropertyReferencePrefabGet2(id, propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-system-by-prefab-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followPropertyReferencePrefabGet21(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelSystem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followPropertyReferencePrefabGet21(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PrefabPropertyReferenceControllerApi - factory interface
 * @export
 */
export const PrefabPropertyReferenceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrefabPropertyReferenceControllerApiFp(configuration)
    return {
        /**
         * patch-abstractcommand-by-prefab-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferencePrefabPatch(id: string, collectionModelObject: CollectionModelObject, options?: any): AxiosPromise<void> {
            return localVarFp.createPropertyReferencePrefabPatch(id, collectionModelObject, options).then((request) => request(axios, basePath));
        },
        /**
         * patch-system-by-prefab-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferencePrefabPatch1(id: string, collectionModelObject: CollectionModelObject, options?: any): AxiosPromise<EntityModelSystem> {
            return localVarFp.createPropertyReferencePrefabPatch1(id, collectionModelObject, options).then((request) => request(axios, basePath));
        },
        /**
         * update-abstractcommand-by-prefab-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferencePrefabPut(id: string, collectionModelObject: CollectionModelObject, options?: any): AxiosPromise<void> {
            return localVarFp.createPropertyReferencePrefabPut(id, collectionModelObject, options).then((request) => request(axios, basePath));
        },
        /**
         * update-system-by-prefab-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferencePrefabPut1(id: string, collectionModelObject: CollectionModelObject, options?: any): AxiosPromise<EntityModelSystem> {
            return localVarFp.createPropertyReferencePrefabPut1(id, collectionModelObject, options).then((request) => request(axios, basePath));
        },
        /**
         * delete-abstractcommand-by-prefab-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceIdPrefabDelete(id: string, propertyId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePropertyReferenceIdPrefabDelete(id, propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * delete-system-by-prefab-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceIdPrefabDelete1(id: string, propertyId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePropertyReferenceIdPrefabDelete1(id, propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * delete-abstractcommand-by-prefab-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferencePrefabDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePropertyReferencePrefabDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * delete-system-by-prefab-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferencePrefabDelete1(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePropertyReferencePrefabDelete1(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-abstractcommand-by-prefab-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferencePrefabGet(id: string, propertyId: string, options?: any): AxiosPromise<void> {
            return localVarFp.followPropertyReferencePrefabGet(id, propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * get-abstractcommand-by-prefab-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferencePrefabGet1(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.followPropertyReferencePrefabGet1(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-system-by-prefab-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferencePrefabGet2(id: string, propertyId: string, options?: any): AxiosPromise<EntityModelSystem> {
            return localVarFp.followPropertyReferencePrefabGet2(id, propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * get-system-by-prefab-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferencePrefabGet21(id: string, options?: any): AxiosPromise<EntityModelSystem> {
            return localVarFp.followPropertyReferencePrefabGet21(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PrefabPropertyReferenceControllerApi - object-oriented interface
 * @export
 * @class PrefabPropertyReferenceControllerApi
 * @extends {BaseAPI}
 */
export class PrefabPropertyReferenceControllerApi extends BaseAPI {
    /**
     * patch-abstractcommand-by-prefab-Id
     * @param {string} id 
     * @param {CollectionModelObject} collectionModelObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrefabPropertyReferenceControllerApi
     */
    public createPropertyReferencePrefabPatch(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig) {
        return PrefabPropertyReferenceControllerApiFp(this.configuration).createPropertyReferencePrefabPatch(id, collectionModelObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * patch-system-by-prefab-Id
     * @param {string} id 
     * @param {CollectionModelObject} collectionModelObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrefabPropertyReferenceControllerApi
     */
    public createPropertyReferencePrefabPatch1(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig) {
        return PrefabPropertyReferenceControllerApiFp(this.configuration).createPropertyReferencePrefabPatch1(id, collectionModelObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-abstractcommand-by-prefab-Id
     * @param {string} id 
     * @param {CollectionModelObject} collectionModelObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrefabPropertyReferenceControllerApi
     */
    public createPropertyReferencePrefabPut(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig) {
        return PrefabPropertyReferenceControllerApiFp(this.configuration).createPropertyReferencePrefabPut(id, collectionModelObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-system-by-prefab-Id
     * @param {string} id 
     * @param {CollectionModelObject} collectionModelObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrefabPropertyReferenceControllerApi
     */
    public createPropertyReferencePrefabPut1(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig) {
        return PrefabPropertyReferenceControllerApiFp(this.configuration).createPropertyReferencePrefabPut1(id, collectionModelObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete-abstractcommand-by-prefab-Id
     * @param {string} id 
     * @param {string} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrefabPropertyReferenceControllerApi
     */
    public deletePropertyReferenceIdPrefabDelete(id: string, propertyId: string, options?: AxiosRequestConfig) {
        return PrefabPropertyReferenceControllerApiFp(this.configuration).deletePropertyReferenceIdPrefabDelete(id, propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete-system-by-prefab-Id
     * @param {string} id 
     * @param {string} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrefabPropertyReferenceControllerApi
     */
    public deletePropertyReferenceIdPrefabDelete1(id: string, propertyId: string, options?: AxiosRequestConfig) {
        return PrefabPropertyReferenceControllerApiFp(this.configuration).deletePropertyReferenceIdPrefabDelete1(id, propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete-abstractcommand-by-prefab-Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrefabPropertyReferenceControllerApi
     */
    public deletePropertyReferencePrefabDelete(id: string, options?: AxiosRequestConfig) {
        return PrefabPropertyReferenceControllerApiFp(this.configuration).deletePropertyReferencePrefabDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete-system-by-prefab-Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrefabPropertyReferenceControllerApi
     */
    public deletePropertyReferencePrefabDelete1(id: string, options?: AxiosRequestConfig) {
        return PrefabPropertyReferenceControllerApiFp(this.configuration).deletePropertyReferencePrefabDelete1(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-abstractcommand-by-prefab-Id
     * @param {string} id 
     * @param {string} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrefabPropertyReferenceControllerApi
     */
    public followPropertyReferencePrefabGet(id: string, propertyId: string, options?: AxiosRequestConfig) {
        return PrefabPropertyReferenceControllerApiFp(this.configuration).followPropertyReferencePrefabGet(id, propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-abstractcommand-by-prefab-Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrefabPropertyReferenceControllerApi
     */
    public followPropertyReferencePrefabGet1(id: string, options?: AxiosRequestConfig) {
        return PrefabPropertyReferenceControllerApiFp(this.configuration).followPropertyReferencePrefabGet1(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-system-by-prefab-Id
     * @param {string} id 
     * @param {string} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrefabPropertyReferenceControllerApi
     */
    public followPropertyReferencePrefabGet2(id: string, propertyId: string, options?: AxiosRequestConfig) {
        return PrefabPropertyReferenceControllerApiFp(this.configuration).followPropertyReferencePrefabGet2(id, propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-system-by-prefab-Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrefabPropertyReferenceControllerApi
     */
    public followPropertyReferencePrefabGet21(id: string, options?: AxiosRequestConfig) {
        return PrefabPropertyReferenceControllerApiFp(this.configuration).followPropertyReferencePrefabGet21(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PrefabSearchControllerApi - axios parameter creator
 * @export
 */
export const PrefabSearchControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {System} [system] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchPrefabGet: async (system?: System, page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/prefabs/search/findAllBySystem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (system !== undefined) {
                localVarQueryParameter['system'] = system;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [systemId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchPrefabGet1: async (systemId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/prefabs/search/findAllBySystemWithoutPage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (systemId !== undefined) {
                localVarQueryParameter['systemId'] = systemId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrefabSearchControllerApi - functional programming interface
 * @export
 */
export const PrefabSearchControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrefabSearchControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {System} [system] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSearchPrefabGet(system?: System, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSearchPrefabGet(system, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [systemId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSearchPrefabGet1(systemId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSearchPrefabGet1(systemId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PrefabSearchControllerApi - factory interface
 * @export
 */
export const PrefabSearchControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrefabSearchControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {System} [system] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchPrefabGet(system?: System, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.executeSearchPrefabGet(system, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [systemId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchPrefabGet1(systemId?: number, options?: any): AxiosPromise<void> {
            return localVarFp.executeSearchPrefabGet1(systemId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PrefabSearchControllerApi - object-oriented interface
 * @export
 * @class PrefabSearchControllerApi
 * @extends {BaseAPI}
 */
export class PrefabSearchControllerApi extends BaseAPI {
    /**
     * 
     * @param {System} [system] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrefabSearchControllerApi
     */
    public executeSearchPrefabGet(system?: System, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return PrefabSearchControllerApiFp(this.configuration).executeSearchPrefabGet(system, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [systemId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrefabSearchControllerApi
     */
    public executeSearchPrefabGet1(systemId?: number, options?: AxiosRequestConfig) {
        return PrefabSearchControllerApiFp(this.configuration).executeSearchPrefabGet1(systemId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProfileControllerApi - axios parameter creator
 * @export
 */
export const ProfileControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor111: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/abstractCommands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor1110: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/testPauseDatas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor1111: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/testPlanExecutions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor1112: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/testPlanTests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor1113: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/testPlans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor1114: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/testResults`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor1115: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/tests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor1116: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/traces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor112: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/locates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor113: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/passwords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor114: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/playwrightConfigurations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor115: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/prefabs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor116: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor117: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/scheduledTestPlanTasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor118: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/systems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor119: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/testExecutions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllFormsOfMetadata1: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProfileControllerApi - functional programming interface
 * @export
 */
export const ProfileControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProfileControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async descriptor111(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.descriptor111(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async descriptor1110(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.descriptor1110(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async descriptor1111(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.descriptor1111(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async descriptor1112(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.descriptor1112(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async descriptor1113(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.descriptor1113(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async descriptor1114(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.descriptor1114(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async descriptor1115(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.descriptor1115(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async descriptor1116(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.descriptor1116(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async descriptor112(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.descriptor112(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async descriptor113(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.descriptor113(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async descriptor114(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.descriptor114(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async descriptor115(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.descriptor115(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async descriptor116(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.descriptor116(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async descriptor117(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.descriptor117(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async descriptor118(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.descriptor118(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async descriptor119(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.descriptor119(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAllFormsOfMetadata1(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepresentationModelObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAllFormsOfMetadata1(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProfileControllerApi - factory interface
 * @export
 */
export const ProfileControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProfileControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor111(options?: any): AxiosPromise<string> {
            return localVarFp.descriptor111(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor1110(options?: any): AxiosPromise<string> {
            return localVarFp.descriptor1110(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor1111(options?: any): AxiosPromise<string> {
            return localVarFp.descriptor1111(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor1112(options?: any): AxiosPromise<string> {
            return localVarFp.descriptor1112(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor1113(options?: any): AxiosPromise<string> {
            return localVarFp.descriptor1113(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor1114(options?: any): AxiosPromise<string> {
            return localVarFp.descriptor1114(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor1115(options?: any): AxiosPromise<string> {
            return localVarFp.descriptor1115(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor1116(options?: any): AxiosPromise<string> {
            return localVarFp.descriptor1116(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor112(options?: any): AxiosPromise<string> {
            return localVarFp.descriptor112(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor113(options?: any): AxiosPromise<string> {
            return localVarFp.descriptor113(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor114(options?: any): AxiosPromise<string> {
            return localVarFp.descriptor114(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor115(options?: any): AxiosPromise<string> {
            return localVarFp.descriptor115(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor116(options?: any): AxiosPromise<string> {
            return localVarFp.descriptor116(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor117(options?: any): AxiosPromise<string> {
            return localVarFp.descriptor117(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor118(options?: any): AxiosPromise<string> {
            return localVarFp.descriptor118(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        descriptor119(options?: any): AxiosPromise<string> {
            return localVarFp.descriptor119(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllFormsOfMetadata1(options?: any): AxiosPromise<RepresentationModelObject> {
            return localVarFp.listAllFormsOfMetadata1(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProfileControllerApi - object-oriented interface
 * @export
 * @class ProfileControllerApi
 * @extends {BaseAPI}
 */
export class ProfileControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public descriptor111(options?: AxiosRequestConfig) {
        return ProfileControllerApiFp(this.configuration).descriptor111(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public descriptor1110(options?: AxiosRequestConfig) {
        return ProfileControllerApiFp(this.configuration).descriptor1110(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public descriptor1111(options?: AxiosRequestConfig) {
        return ProfileControllerApiFp(this.configuration).descriptor1111(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public descriptor1112(options?: AxiosRequestConfig) {
        return ProfileControllerApiFp(this.configuration).descriptor1112(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public descriptor1113(options?: AxiosRequestConfig) {
        return ProfileControllerApiFp(this.configuration).descriptor1113(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public descriptor1114(options?: AxiosRequestConfig) {
        return ProfileControllerApiFp(this.configuration).descriptor1114(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public descriptor1115(options?: AxiosRequestConfig) {
        return ProfileControllerApiFp(this.configuration).descriptor1115(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public descriptor1116(options?: AxiosRequestConfig) {
        return ProfileControllerApiFp(this.configuration).descriptor1116(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public descriptor112(options?: AxiosRequestConfig) {
        return ProfileControllerApiFp(this.configuration).descriptor112(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public descriptor113(options?: AxiosRequestConfig) {
        return ProfileControllerApiFp(this.configuration).descriptor113(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public descriptor114(options?: AxiosRequestConfig) {
        return ProfileControllerApiFp(this.configuration).descriptor114(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public descriptor115(options?: AxiosRequestConfig) {
        return ProfileControllerApiFp(this.configuration).descriptor115(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public descriptor116(options?: AxiosRequestConfig) {
        return ProfileControllerApiFp(this.configuration).descriptor116(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public descriptor117(options?: AxiosRequestConfig) {
        return ProfileControllerApiFp(this.configuration).descriptor117(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public descriptor118(options?: AxiosRequestConfig) {
        return ProfileControllerApiFp(this.configuration).descriptor118(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public descriptor119(options?: AxiosRequestConfig) {
        return ProfileControllerApiFp(this.configuration).descriptor119(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public listAllFormsOfMetadata1(options?: AxiosRequestConfig) {
        return ProfileControllerApiFp(this.configuration).listAllFormsOfMetadata1(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RequestControllerApi - axios parameter creator
 * @export
 */
export const RequestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new Request
         * @param {RequestDto} requestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRequest: async (requestDto: RequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestDto' is not null or undefined
            assertParamExists('createRequest', 'requestDto', requestDto)
            const localVarPath = `/api/request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Request by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRequest: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteRequest', 'id', id)
            const localVarPath = `/api/request/delete/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Requests for the system
         * @param {string} systemName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRequestsBySystem: async (systemName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemName' is not null or undefined
            assertParamExists('getAllRequestsBySystem', 'systemName', systemName)
            const localVarPath = `/api/request/system/{systemName}`
                .replace(`{${"systemName"}}`, encodeURIComponent(String(systemName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Request by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequestById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRequestById', 'id', id)
            const localVarPath = `/api/request/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Request
         * @param {RequestDto} requestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRequest: async (requestDto: RequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestDto' is not null or undefined
            assertParamExists('updateRequest', 'requestDto', requestDto)
            const localVarPath = `/api/request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RequestControllerApi - functional programming interface
 * @export
 */
export const RequestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RequestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create new Request
         * @param {RequestDto} requestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRequest(requestDto: RequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRequest(requestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete Request by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRequest(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRequest(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all Requests for the system
         * @param {string} systemName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllRequestsBySystem(systemName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RequestDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllRequestsBySystem(systemName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Request by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRequestById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRequestById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Request
         * @param {RequestDto} requestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRequest(requestDto: RequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRequest(requestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RequestControllerApi - factory interface
 * @export
 */
export const RequestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RequestControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Create new Request
         * @param {RequestDto} requestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRequest(requestDto: RequestDto, options?: any): AxiosPromise<RequestDto> {
            return localVarFp.createRequest(requestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Request by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRequest(id: number, options?: any): AxiosPromise<string> {
            return localVarFp.deleteRequest(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all Requests for the system
         * @param {string} systemName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRequestsBySystem(systemName: string, options?: any): AxiosPromise<Array<RequestDto>> {
            return localVarFp.getAllRequestsBySystem(systemName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Request by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequestById(id: number, options?: any): AxiosPromise<RequestDto> {
            return localVarFp.getRequestById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Request
         * @param {RequestDto} requestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRequest(requestDto: RequestDto, options?: any): AxiosPromise<RequestDto> {
            return localVarFp.updateRequest(requestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RequestControllerApi - object-oriented interface
 * @export
 * @class RequestControllerApi
 * @extends {BaseAPI}
 */
export class RequestControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create new Request
     * @param {RequestDto} requestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestControllerApi
     */
    public createRequest(requestDto: RequestDto, options?: AxiosRequestConfig) {
        return RequestControllerApiFp(this.configuration).createRequest(requestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Request by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestControllerApi
     */
    public deleteRequest(id: number, options?: AxiosRequestConfig) {
        return RequestControllerApiFp(this.configuration).deleteRequest(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all Requests for the system
     * @param {string} systemName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestControllerApi
     */
    public getAllRequestsBySystem(systemName: string, options?: AxiosRequestConfig) {
        return RequestControllerApiFp(this.configuration).getAllRequestsBySystem(systemName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Request by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestControllerApi
     */
    public getRequestById(id: number, options?: AxiosRequestConfig) {
        return RequestControllerApiFp(this.configuration).getRequestById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Request
     * @param {RequestDto} requestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestControllerApi
     */
    public updateRequest(requestDto: RequestDto, options?: AxiosRequestConfig) {
        return RequestControllerApiFp(this.configuration).updateRequest(requestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RequestEntityControllerApi - axios parameter creator
 * @export
 */
export const RequestEntityControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * delete-request
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourceRequestDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteItemResourceRequestDelete', 'id', id)
            const localVarPath = `/requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-request
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourceRequestGet1: async (page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-request
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourceRequestGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getItemResourceRequestGet', 'id', id)
            const localVarPath = `/requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch-request
         * @param {string} id 
         * @param {RequestRequestBody} requestRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourceRequestPatch: async (id: string, requestRequestBody: RequestRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchItemResourceRequestPatch', 'id', id)
            // verify required parameter 'requestRequestBody' is not null or undefined
            assertParamExists('patchItemResourceRequestPatch', 'requestRequestBody', requestRequestBody)
            const localVarPath = `/requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create-request
         * @param {RequestRequestBody} requestRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourceRequestPost: async (requestRequestBody: RequestRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestRequestBody' is not null or undefined
            assertParamExists('postCollectionResourceRequestPost', 'requestRequestBody', requestRequestBody)
            const localVarPath = `/requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-request
         * @param {string} id 
         * @param {RequestRequestBody} requestRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourceRequestPut: async (id: string, requestRequestBody: RequestRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putItemResourceRequestPut', 'id', id)
            // verify required parameter 'requestRequestBody' is not null or undefined
            assertParamExists('putItemResourceRequestPut', 'requestRequestBody', requestRequestBody)
            const localVarPath = `/requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RequestEntityControllerApi - functional programming interface
 * @export
 */
export const RequestEntityControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RequestEntityControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * delete-request
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteItemResourceRequestDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteItemResourceRequestDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-request
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollectionResourceRequestGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedModelEntityModelRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollectionResourceRequestGet1(page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-request
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getItemResourceRequestGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getItemResourceRequestGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * patch-request
         * @param {string} id 
         * @param {RequestRequestBody} requestRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchItemResourceRequestPatch(id: string, requestRequestBody: RequestRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchItemResourceRequestPatch(id, requestRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * create-request
         * @param {RequestRequestBody} requestRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCollectionResourceRequestPost(requestRequestBody: RequestRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCollectionResourceRequestPost(requestRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-request
         * @param {string} id 
         * @param {RequestRequestBody} requestRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putItemResourceRequestPut(id: string, requestRequestBody: RequestRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putItemResourceRequestPut(id, requestRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RequestEntityControllerApi - factory interface
 * @export
 */
export const RequestEntityControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RequestEntityControllerApiFp(configuration)
    return {
        /**
         * delete-request
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourceRequestDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteItemResourceRequestDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-request
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourceRequestGet1(page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PagedModelEntityModelRequest> {
            return localVarFp.getCollectionResourceRequestGet1(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * get-request
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourceRequestGet(id: string, options?: any): AxiosPromise<EntityModelRequest> {
            return localVarFp.getItemResourceRequestGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * patch-request
         * @param {string} id 
         * @param {RequestRequestBody} requestRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourceRequestPatch(id: string, requestRequestBody: RequestRequestBody, options?: any): AxiosPromise<EntityModelRequest> {
            return localVarFp.patchItemResourceRequestPatch(id, requestRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * create-request
         * @param {RequestRequestBody} requestRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourceRequestPost(requestRequestBody: RequestRequestBody, options?: any): AxiosPromise<EntityModelRequest> {
            return localVarFp.postCollectionResourceRequestPost(requestRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * update-request
         * @param {string} id 
         * @param {RequestRequestBody} requestRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourceRequestPut(id: string, requestRequestBody: RequestRequestBody, options?: any): AxiosPromise<EntityModelRequest> {
            return localVarFp.putItemResourceRequestPut(id, requestRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RequestEntityControllerApi - object-oriented interface
 * @export
 * @class RequestEntityControllerApi
 * @extends {BaseAPI}
 */
export class RequestEntityControllerApi extends BaseAPI {
    /**
     * delete-request
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestEntityControllerApi
     */
    public deleteItemResourceRequestDelete(id: string, options?: AxiosRequestConfig) {
        return RequestEntityControllerApiFp(this.configuration).deleteItemResourceRequestDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-request
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestEntityControllerApi
     */
    public getCollectionResourceRequestGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return RequestEntityControllerApiFp(this.configuration).getCollectionResourceRequestGet1(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-request
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestEntityControllerApi
     */
    public getItemResourceRequestGet(id: string, options?: AxiosRequestConfig) {
        return RequestEntityControllerApiFp(this.configuration).getItemResourceRequestGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * patch-request
     * @param {string} id 
     * @param {RequestRequestBody} requestRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestEntityControllerApi
     */
    public patchItemResourceRequestPatch(id: string, requestRequestBody: RequestRequestBody, options?: AxiosRequestConfig) {
        return RequestEntityControllerApiFp(this.configuration).patchItemResourceRequestPatch(id, requestRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create-request
     * @param {RequestRequestBody} requestRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestEntityControllerApi
     */
    public postCollectionResourceRequestPost(requestRequestBody: RequestRequestBody, options?: AxiosRequestConfig) {
        return RequestEntityControllerApiFp(this.configuration).postCollectionResourceRequestPost(requestRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-request
     * @param {string} id 
     * @param {RequestRequestBody} requestRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestEntityControllerApi
     */
    public putItemResourceRequestPut(id: string, requestRequestBody: RequestRequestBody, options?: AxiosRequestConfig) {
        return RequestEntityControllerApiFp(this.configuration).putItemResourceRequestPut(id, requestRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RequestPropertyReferenceControllerApi - axios parameter creator
 * @export
 */
export const RequestPropertyReferenceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * patch-system-by-request-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceRequestPatch: async (id: string, collectionModelObject: CollectionModelObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPropertyReferenceRequestPatch', 'id', id)
            // verify required parameter 'collectionModelObject' is not null or undefined
            assertParamExists('createPropertyReferenceRequestPatch', 'collectionModelObject', collectionModelObject)
            const localVarPath = `/requests/{id}/system`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionModelObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-system-by-request-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceRequestPut: async (id: string, collectionModelObject: CollectionModelObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPropertyReferenceRequestPut', 'id', id)
            // verify required parameter 'collectionModelObject' is not null or undefined
            assertParamExists('createPropertyReferenceRequestPut', 'collectionModelObject', collectionModelObject)
            const localVarPath = `/requests/{id}/system`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionModelObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete-system-by-request-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceIdRequestDelete: async (id: string, propertyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePropertyReferenceIdRequestDelete', 'id', id)
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('deletePropertyReferenceIdRequestDelete', 'propertyId', propertyId)
            const localVarPath = `/requests/{id}/system/{propertyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete-system-by-request-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceRequestDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePropertyReferenceRequestDelete', 'id', id)
            const localVarPath = `/requests/{id}/system`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-system-by-request-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceRequestGet: async (id: string, propertyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('followPropertyReferenceRequestGet', 'id', id)
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('followPropertyReferenceRequestGet', 'propertyId', propertyId)
            const localVarPath = `/requests/{id}/system/{propertyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-system-by-request-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceRequestGet1: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('followPropertyReferenceRequestGet1', 'id', id)
            const localVarPath = `/requests/{id}/system`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RequestPropertyReferenceControllerApi - functional programming interface
 * @export
 */
export const RequestPropertyReferenceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RequestPropertyReferenceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * patch-system-by-request-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReferenceRequestPatch(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelSystem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReferenceRequestPatch(id, collectionModelObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-system-by-request-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReferenceRequestPut(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelSystem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReferenceRequestPut(id, collectionModelObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete-system-by-request-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePropertyReferenceIdRequestDelete(id: string, propertyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePropertyReferenceIdRequestDelete(id, propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete-system-by-request-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePropertyReferenceRequestDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePropertyReferenceRequestDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-system-by-request-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followPropertyReferenceRequestGet(id: string, propertyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelSystem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followPropertyReferenceRequestGet(id, propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-system-by-request-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followPropertyReferenceRequestGet1(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelSystem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followPropertyReferenceRequestGet1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RequestPropertyReferenceControllerApi - factory interface
 * @export
 */
export const RequestPropertyReferenceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RequestPropertyReferenceControllerApiFp(configuration)
    return {
        /**
         * patch-system-by-request-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceRequestPatch(id: string, collectionModelObject: CollectionModelObject, options?: any): AxiosPromise<EntityModelSystem> {
            return localVarFp.createPropertyReferenceRequestPatch(id, collectionModelObject, options).then((request) => request(axios, basePath));
        },
        /**
         * update-system-by-request-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceRequestPut(id: string, collectionModelObject: CollectionModelObject, options?: any): AxiosPromise<EntityModelSystem> {
            return localVarFp.createPropertyReferenceRequestPut(id, collectionModelObject, options).then((request) => request(axios, basePath));
        },
        /**
         * delete-system-by-request-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceIdRequestDelete(id: string, propertyId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePropertyReferenceIdRequestDelete(id, propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * delete-system-by-request-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceRequestDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePropertyReferenceRequestDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-system-by-request-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceRequestGet(id: string, propertyId: string, options?: any): AxiosPromise<EntityModelSystem> {
            return localVarFp.followPropertyReferenceRequestGet(id, propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * get-system-by-request-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceRequestGet1(id: string, options?: any): AxiosPromise<EntityModelSystem> {
            return localVarFp.followPropertyReferenceRequestGet1(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RequestPropertyReferenceControllerApi - object-oriented interface
 * @export
 * @class RequestPropertyReferenceControllerApi
 * @extends {BaseAPI}
 */
export class RequestPropertyReferenceControllerApi extends BaseAPI {
    /**
     * patch-system-by-request-Id
     * @param {string} id 
     * @param {CollectionModelObject} collectionModelObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestPropertyReferenceControllerApi
     */
    public createPropertyReferenceRequestPatch(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig) {
        return RequestPropertyReferenceControllerApiFp(this.configuration).createPropertyReferenceRequestPatch(id, collectionModelObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-system-by-request-Id
     * @param {string} id 
     * @param {CollectionModelObject} collectionModelObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestPropertyReferenceControllerApi
     */
    public createPropertyReferenceRequestPut(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig) {
        return RequestPropertyReferenceControllerApiFp(this.configuration).createPropertyReferenceRequestPut(id, collectionModelObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete-system-by-request-Id
     * @param {string} id 
     * @param {string} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestPropertyReferenceControllerApi
     */
    public deletePropertyReferenceIdRequestDelete(id: string, propertyId: string, options?: AxiosRequestConfig) {
        return RequestPropertyReferenceControllerApiFp(this.configuration).deletePropertyReferenceIdRequestDelete(id, propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete-system-by-request-Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestPropertyReferenceControllerApi
     */
    public deletePropertyReferenceRequestDelete(id: string, options?: AxiosRequestConfig) {
        return RequestPropertyReferenceControllerApiFp(this.configuration).deletePropertyReferenceRequestDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-system-by-request-Id
     * @param {string} id 
     * @param {string} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestPropertyReferenceControllerApi
     */
    public followPropertyReferenceRequestGet(id: string, propertyId: string, options?: AxiosRequestConfig) {
        return RequestPropertyReferenceControllerApiFp(this.configuration).followPropertyReferenceRequestGet(id, propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-system-by-request-Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestPropertyReferenceControllerApi
     */
    public followPropertyReferenceRequestGet1(id: string, options?: AxiosRequestConfig) {
        return RequestPropertyReferenceControllerApiFp(this.configuration).followPropertyReferenceRequestGet1(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RequestSearchControllerApi - axios parameter creator
 * @export
 */
export const RequestSearchControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {System} [system] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchRequestGet: async (system?: System, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/requests/search/findAllBySystem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (system !== undefined) {
                localVarQueryParameter['system'] = system;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RequestSearchControllerApi - functional programming interface
 * @export
 */
export const RequestSearchControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RequestSearchControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {System} [system] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSearchRequestGet(system?: System, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionModelEntityModelRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSearchRequestGet(system, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RequestSearchControllerApi - factory interface
 * @export
 */
export const RequestSearchControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RequestSearchControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {System} [system] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchRequestGet(system?: System, options?: any): AxiosPromise<CollectionModelEntityModelRequest> {
            return localVarFp.executeSearchRequestGet(system, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RequestSearchControllerApi - object-oriented interface
 * @export
 * @class RequestSearchControllerApi
 * @extends {BaseAPI}
 */
export class RequestSearchControllerApi extends BaseAPI {
    /**
     * 
     * @param {System} [system] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestSearchControllerApi
     */
    public executeSearchRequestGet(system?: System, options?: AxiosRequestConfig) {
        return RequestSearchControllerApiFp(this.configuration).executeSearchRequestGet(system, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ScheduledTestPlanTaskEntityControllerApi - axios parameter creator
 * @export
 */
export const ScheduledTestPlanTaskEntityControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * delete-scheduledtestplantask
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourceScheduledtestplantaskDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteItemResourceScheduledtestplantaskDelete', 'id', id)
            const localVarPath = `/scheduledTestPlanTasks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-scheduledtestplantask
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourceScheduledtestplantaskGet1: async (page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/scheduledTestPlanTasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-scheduledtestplantask
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourceScheduledtestplantaskGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getItemResourceScheduledtestplantaskGet', 'id', id)
            const localVarPath = `/scheduledTestPlanTasks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch-scheduledtestplantask
         * @param {string} id 
         * @param {ScheduledTestPlanTaskRequestBody} scheduledTestPlanTaskRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourceScheduledtestplantaskPatch: async (id: string, scheduledTestPlanTaskRequestBody: ScheduledTestPlanTaskRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchItemResourceScheduledtestplantaskPatch', 'id', id)
            // verify required parameter 'scheduledTestPlanTaskRequestBody' is not null or undefined
            assertParamExists('patchItemResourceScheduledtestplantaskPatch', 'scheduledTestPlanTaskRequestBody', scheduledTestPlanTaskRequestBody)
            const localVarPath = `/scheduledTestPlanTasks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(scheduledTestPlanTaskRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create-scheduledtestplantask
         * @param {ScheduledTestPlanTaskRequestBody} scheduledTestPlanTaskRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourceScheduledtestplantaskPost: async (scheduledTestPlanTaskRequestBody: ScheduledTestPlanTaskRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scheduledTestPlanTaskRequestBody' is not null or undefined
            assertParamExists('postCollectionResourceScheduledtestplantaskPost', 'scheduledTestPlanTaskRequestBody', scheduledTestPlanTaskRequestBody)
            const localVarPath = `/scheduledTestPlanTasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(scheduledTestPlanTaskRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-scheduledtestplantask
         * @param {string} id 
         * @param {ScheduledTestPlanTaskRequestBody} scheduledTestPlanTaskRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourceScheduledtestplantaskPut: async (id: string, scheduledTestPlanTaskRequestBody: ScheduledTestPlanTaskRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putItemResourceScheduledtestplantaskPut', 'id', id)
            // verify required parameter 'scheduledTestPlanTaskRequestBody' is not null or undefined
            assertParamExists('putItemResourceScheduledtestplantaskPut', 'scheduledTestPlanTaskRequestBody', scheduledTestPlanTaskRequestBody)
            const localVarPath = `/scheduledTestPlanTasks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(scheduledTestPlanTaskRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScheduledTestPlanTaskEntityControllerApi - functional programming interface
 * @export
 */
export const ScheduledTestPlanTaskEntityControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScheduledTestPlanTaskEntityControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * delete-scheduledtestplantask
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteItemResourceScheduledtestplantaskDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteItemResourceScheduledtestplantaskDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-scheduledtestplantask
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollectionResourceScheduledtestplantaskGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedModelEntityModelScheduledTestPlanTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollectionResourceScheduledtestplantaskGet1(page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-scheduledtestplantask
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getItemResourceScheduledtestplantaskGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelScheduledTestPlanTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getItemResourceScheduledtestplantaskGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * patch-scheduledtestplantask
         * @param {string} id 
         * @param {ScheduledTestPlanTaskRequestBody} scheduledTestPlanTaskRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchItemResourceScheduledtestplantaskPatch(id: string, scheduledTestPlanTaskRequestBody: ScheduledTestPlanTaskRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelScheduledTestPlanTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchItemResourceScheduledtestplantaskPatch(id, scheduledTestPlanTaskRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * create-scheduledtestplantask
         * @param {ScheduledTestPlanTaskRequestBody} scheduledTestPlanTaskRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCollectionResourceScheduledtestplantaskPost(scheduledTestPlanTaskRequestBody: ScheduledTestPlanTaskRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelScheduledTestPlanTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCollectionResourceScheduledtestplantaskPost(scheduledTestPlanTaskRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-scheduledtestplantask
         * @param {string} id 
         * @param {ScheduledTestPlanTaskRequestBody} scheduledTestPlanTaskRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putItemResourceScheduledtestplantaskPut(id: string, scheduledTestPlanTaskRequestBody: ScheduledTestPlanTaskRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelScheduledTestPlanTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putItemResourceScheduledtestplantaskPut(id, scheduledTestPlanTaskRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ScheduledTestPlanTaskEntityControllerApi - factory interface
 * @export
 */
export const ScheduledTestPlanTaskEntityControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScheduledTestPlanTaskEntityControllerApiFp(configuration)
    return {
        /**
         * delete-scheduledtestplantask
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourceScheduledtestplantaskDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteItemResourceScheduledtestplantaskDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-scheduledtestplantask
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourceScheduledtestplantaskGet1(page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PagedModelEntityModelScheduledTestPlanTask> {
            return localVarFp.getCollectionResourceScheduledtestplantaskGet1(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * get-scheduledtestplantask
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourceScheduledtestplantaskGet(id: string, options?: any): AxiosPromise<EntityModelScheduledTestPlanTask> {
            return localVarFp.getItemResourceScheduledtestplantaskGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * patch-scheduledtestplantask
         * @param {string} id 
         * @param {ScheduledTestPlanTaskRequestBody} scheduledTestPlanTaskRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourceScheduledtestplantaskPatch(id: string, scheduledTestPlanTaskRequestBody: ScheduledTestPlanTaskRequestBody, options?: any): AxiosPromise<EntityModelScheduledTestPlanTask> {
            return localVarFp.patchItemResourceScheduledtestplantaskPatch(id, scheduledTestPlanTaskRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * create-scheduledtestplantask
         * @param {ScheduledTestPlanTaskRequestBody} scheduledTestPlanTaskRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourceScheduledtestplantaskPost(scheduledTestPlanTaskRequestBody: ScheduledTestPlanTaskRequestBody, options?: any): AxiosPromise<EntityModelScheduledTestPlanTask> {
            return localVarFp.postCollectionResourceScheduledtestplantaskPost(scheduledTestPlanTaskRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * update-scheduledtestplantask
         * @param {string} id 
         * @param {ScheduledTestPlanTaskRequestBody} scheduledTestPlanTaskRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourceScheduledtestplantaskPut(id: string, scheduledTestPlanTaskRequestBody: ScheduledTestPlanTaskRequestBody, options?: any): AxiosPromise<EntityModelScheduledTestPlanTask> {
            return localVarFp.putItemResourceScheduledtestplantaskPut(id, scheduledTestPlanTaskRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ScheduledTestPlanTaskEntityControllerApi - object-oriented interface
 * @export
 * @class ScheduledTestPlanTaskEntityControllerApi
 * @extends {BaseAPI}
 */
export class ScheduledTestPlanTaskEntityControllerApi extends BaseAPI {
    /**
     * delete-scheduledtestplantask
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledTestPlanTaskEntityControllerApi
     */
    public deleteItemResourceScheduledtestplantaskDelete(id: string, options?: AxiosRequestConfig) {
        return ScheduledTestPlanTaskEntityControllerApiFp(this.configuration).deleteItemResourceScheduledtestplantaskDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-scheduledtestplantask
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledTestPlanTaskEntityControllerApi
     */
    public getCollectionResourceScheduledtestplantaskGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return ScheduledTestPlanTaskEntityControllerApiFp(this.configuration).getCollectionResourceScheduledtestplantaskGet1(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-scheduledtestplantask
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledTestPlanTaskEntityControllerApi
     */
    public getItemResourceScheduledtestplantaskGet(id: string, options?: AxiosRequestConfig) {
        return ScheduledTestPlanTaskEntityControllerApiFp(this.configuration).getItemResourceScheduledtestplantaskGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * patch-scheduledtestplantask
     * @param {string} id 
     * @param {ScheduledTestPlanTaskRequestBody} scheduledTestPlanTaskRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledTestPlanTaskEntityControllerApi
     */
    public patchItemResourceScheduledtestplantaskPatch(id: string, scheduledTestPlanTaskRequestBody: ScheduledTestPlanTaskRequestBody, options?: AxiosRequestConfig) {
        return ScheduledTestPlanTaskEntityControllerApiFp(this.configuration).patchItemResourceScheduledtestplantaskPatch(id, scheduledTestPlanTaskRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create-scheduledtestplantask
     * @param {ScheduledTestPlanTaskRequestBody} scheduledTestPlanTaskRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledTestPlanTaskEntityControllerApi
     */
    public postCollectionResourceScheduledtestplantaskPost(scheduledTestPlanTaskRequestBody: ScheduledTestPlanTaskRequestBody, options?: AxiosRequestConfig) {
        return ScheduledTestPlanTaskEntityControllerApiFp(this.configuration).postCollectionResourceScheduledtestplantaskPost(scheduledTestPlanTaskRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-scheduledtestplantask
     * @param {string} id 
     * @param {ScheduledTestPlanTaskRequestBody} scheduledTestPlanTaskRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledTestPlanTaskEntityControllerApi
     */
    public putItemResourceScheduledtestplantaskPut(id: string, scheduledTestPlanTaskRequestBody: ScheduledTestPlanTaskRequestBody, options?: AxiosRequestConfig) {
        return ScheduledTestPlanTaskEntityControllerApiFp(this.configuration).putItemResourceScheduledtestplantaskPut(id, scheduledTestPlanTaskRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StatisticsControllerApi - axios parameter creator
 * @export
 */
export const StatisticsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} days 
         * @param {number} testplanAmount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestPlanStatistics: async (days: number, testplanAmount: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'days' is not null or undefined
            assertParamExists('getTestPlanStatistics', 'days', days)
            // verify required parameter 'testplanAmount' is not null or undefined
            assertParamExists('getTestPlanStatistics', 'testplanAmount', testplanAmount)
            const localVarPath = `/api/statistics/testplans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }

            if (testplanAmount !== undefined) {
                localVarQueryParameter['testplanAmount'] = testplanAmount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} days 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestRunStatistics: async (days: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'days' is not null or undefined
            assertParamExists('getTestRunStatistics', 'days', days)
            const localVarPath = `/api/statistics/testRuns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatisticsControllerApi - functional programming interface
 * @export
 */
export const StatisticsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatisticsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} days 
         * @param {number} testplanAmount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestPlanStatistics(days: number, testplanAmount: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TestPlanStatistic>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestPlanStatistics(days, testplanAmount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} days 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestRunStatistics(days: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestRunStatistic>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestRunStatistics(days, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StatisticsControllerApi - factory interface
 * @export
 */
export const StatisticsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatisticsControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} days 
         * @param {number} testplanAmount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestPlanStatistics(days: number, testplanAmount: number, options?: any): AxiosPromise<Array<TestPlanStatistic>> {
            return localVarFp.getTestPlanStatistics(days, testplanAmount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} days 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestRunStatistics(days: number, options?: any): AxiosPromise<TestRunStatistic> {
            return localVarFp.getTestRunStatistics(days, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StatisticsControllerApi - object-oriented interface
 * @export
 * @class StatisticsControllerApi
 * @extends {BaseAPI}
 */
export class StatisticsControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} days 
     * @param {number} testplanAmount 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsControllerApi
     */
    public getTestPlanStatistics(days: number, testplanAmount: number, options?: AxiosRequestConfig) {
        return StatisticsControllerApiFp(this.configuration).getTestPlanStatistics(days, testplanAmount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} days 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsControllerApi
     */
    public getTestRunStatistics(days: number, options?: AxiosRequestConfig) {
        return StatisticsControllerApiFp(this.configuration).getTestRunStatistics(days, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SystemControllerApi - axios parameter creator
 * @export
 */
export const SystemControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new System
         * @param {SystemDto} systemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSystem: async (systemDto: SystemDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemDto' is not null or undefined
            assertParamExists('createSystem', 'systemDto', systemDto)
            const localVarPath = `/api/systems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete existing System
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSystem: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSystem', 'id', id)
            const localVarPath = `/api/systems/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Systems
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSystems: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/systems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get System by Id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSystemById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSystemById', 'id', id)
            const localVarPath = `/api/systems/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update existing System
         * @param {number} id 
         * @param {SystemDto} systemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSystem: async (id: number, systemDto: SystemDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSystem', 'id', id)
            // verify required parameter 'systemDto' is not null or undefined
            assertParamExists('updateSystem', 'systemDto', systemDto)
            const localVarPath = `/api/systems/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SystemControllerApi - functional programming interface
 * @export
 */
export const SystemControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SystemControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create new System
         * @param {SystemDto} systemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSystem(systemDto: SystemDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSystem(systemDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete existing System
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSystem(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeletionError>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSystem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all Systems
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSystems(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SystemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSystems(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get System by Id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSystemById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SystemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSystemById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update existing System
         * @param {number} id 
         * @param {SystemDto} systemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSystem(id: number, systemDto: SystemDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSystem(id, systemDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SystemControllerApi - factory interface
 * @export
 */
export const SystemControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SystemControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Create new System
         * @param {SystemDto} systemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSystem(systemDto: SystemDto, options?: any): AxiosPromise<object> {
            return localVarFp.createSystem(systemDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete existing System
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSystem(id: number, options?: any): AxiosPromise<Array<DeletionError>> {
            return localVarFp.deleteSystem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all Systems
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSystems(options?: any): AxiosPromise<Array<SystemDto>> {
            return localVarFp.getAllSystems(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get System by Id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSystemById(id: number, options?: any): AxiosPromise<SystemDto> {
            return localVarFp.getSystemById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update existing System
         * @param {number} id 
         * @param {SystemDto} systemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSystem(id: number, systemDto: SystemDto, options?: any): AxiosPromise<object> {
            return localVarFp.updateSystem(id, systemDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SystemControllerApi - object-oriented interface
 * @export
 * @class SystemControllerApi
 * @extends {BaseAPI}
 */
export class SystemControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create new System
     * @param {SystemDto} systemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemControllerApi
     */
    public createSystem(systemDto: SystemDto, options?: AxiosRequestConfig) {
        return SystemControllerApiFp(this.configuration).createSystem(systemDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete existing System
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemControllerApi
     */
    public deleteSystem(id: number, options?: AxiosRequestConfig) {
        return SystemControllerApiFp(this.configuration).deleteSystem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all Systems
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemControllerApi
     */
    public getAllSystems(options?: AxiosRequestConfig) {
        return SystemControllerApiFp(this.configuration).getAllSystems(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get System by Id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemControllerApi
     */
    public getSystemById(id: number, options?: AxiosRequestConfig) {
        return SystemControllerApiFp(this.configuration).getSystemById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update existing System
     * @param {number} id 
     * @param {SystemDto} systemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemControllerApi
     */
    public updateSystem(id: number, systemDto: SystemDto, options?: AxiosRequestConfig) {
        return SystemControllerApiFp(this.configuration).updateSystem(id, systemDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SystemEntityControllerApi - axios parameter creator
 * @export
 */
export const SystemEntityControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * delete-system
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourceSystemDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteItemResourceSystemDelete', 'id', id)
            const localVarPath = `/systems/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-system
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourceSystemGet1: async (page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/systems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-system
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourceSystemGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getItemResourceSystemGet', 'id', id)
            const localVarPath = `/systems/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch-system
         * @param {string} id 
         * @param {SystemRequestBody} systemRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourceSystemPatch: async (id: string, systemRequestBody: SystemRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchItemResourceSystemPatch', 'id', id)
            // verify required parameter 'systemRequestBody' is not null or undefined
            assertParamExists('patchItemResourceSystemPatch', 'systemRequestBody', systemRequestBody)
            const localVarPath = `/systems/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create-system
         * @param {SystemRequestBody} systemRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourceSystemPost: async (systemRequestBody: SystemRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemRequestBody' is not null or undefined
            assertParamExists('postCollectionResourceSystemPost', 'systemRequestBody', systemRequestBody)
            const localVarPath = `/systems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-system
         * @param {string} id 
         * @param {SystemRequestBody} systemRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourceSystemPut: async (id: string, systemRequestBody: SystemRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putItemResourceSystemPut', 'id', id)
            // verify required parameter 'systemRequestBody' is not null or undefined
            assertParamExists('putItemResourceSystemPut', 'systemRequestBody', systemRequestBody)
            const localVarPath = `/systems/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(systemRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SystemEntityControllerApi - functional programming interface
 * @export
 */
export const SystemEntityControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SystemEntityControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * delete-system
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteItemResourceSystemDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteItemResourceSystemDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-system
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollectionResourceSystemGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedModelEntityModelSystem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollectionResourceSystemGet1(page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-system
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getItemResourceSystemGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelSystem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getItemResourceSystemGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * patch-system
         * @param {string} id 
         * @param {SystemRequestBody} systemRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchItemResourceSystemPatch(id: string, systemRequestBody: SystemRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelSystem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchItemResourceSystemPatch(id, systemRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * create-system
         * @param {SystemRequestBody} systemRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCollectionResourceSystemPost(systemRequestBody: SystemRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelSystem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCollectionResourceSystemPost(systemRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-system
         * @param {string} id 
         * @param {SystemRequestBody} systemRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putItemResourceSystemPut(id: string, systemRequestBody: SystemRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelSystem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putItemResourceSystemPut(id, systemRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SystemEntityControllerApi - factory interface
 * @export
 */
export const SystemEntityControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SystemEntityControllerApiFp(configuration)
    return {
        /**
         * delete-system
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourceSystemDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteItemResourceSystemDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-system
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourceSystemGet1(page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PagedModelEntityModelSystem> {
            return localVarFp.getCollectionResourceSystemGet1(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * get-system
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourceSystemGet(id: string, options?: any): AxiosPromise<EntityModelSystem> {
            return localVarFp.getItemResourceSystemGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * patch-system
         * @param {string} id 
         * @param {SystemRequestBody} systemRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourceSystemPatch(id: string, systemRequestBody: SystemRequestBody, options?: any): AxiosPromise<EntityModelSystem> {
            return localVarFp.patchItemResourceSystemPatch(id, systemRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * create-system
         * @param {SystemRequestBody} systemRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourceSystemPost(systemRequestBody: SystemRequestBody, options?: any): AxiosPromise<EntityModelSystem> {
            return localVarFp.postCollectionResourceSystemPost(systemRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * update-system
         * @param {string} id 
         * @param {SystemRequestBody} systemRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourceSystemPut(id: string, systemRequestBody: SystemRequestBody, options?: any): AxiosPromise<EntityModelSystem> {
            return localVarFp.putItemResourceSystemPut(id, systemRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SystemEntityControllerApi - object-oriented interface
 * @export
 * @class SystemEntityControllerApi
 * @extends {BaseAPI}
 */
export class SystemEntityControllerApi extends BaseAPI {
    /**
     * delete-system
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemEntityControllerApi
     */
    public deleteItemResourceSystemDelete(id: string, options?: AxiosRequestConfig) {
        return SystemEntityControllerApiFp(this.configuration).deleteItemResourceSystemDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-system
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemEntityControllerApi
     */
    public getCollectionResourceSystemGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return SystemEntityControllerApiFp(this.configuration).getCollectionResourceSystemGet1(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-system
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemEntityControllerApi
     */
    public getItemResourceSystemGet(id: string, options?: AxiosRequestConfig) {
        return SystemEntityControllerApiFp(this.configuration).getItemResourceSystemGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * patch-system
     * @param {string} id 
     * @param {SystemRequestBody} systemRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemEntityControllerApi
     */
    public patchItemResourceSystemPatch(id: string, systemRequestBody: SystemRequestBody, options?: AxiosRequestConfig) {
        return SystemEntityControllerApiFp(this.configuration).patchItemResourceSystemPatch(id, systemRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create-system
     * @param {SystemRequestBody} systemRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemEntityControllerApi
     */
    public postCollectionResourceSystemPost(systemRequestBody: SystemRequestBody, options?: AxiosRequestConfig) {
        return SystemEntityControllerApiFp(this.configuration).postCollectionResourceSystemPost(systemRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-system
     * @param {string} id 
     * @param {SystemRequestBody} systemRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemEntityControllerApi
     */
    public putItemResourceSystemPut(id: string, systemRequestBody: SystemRequestBody, options?: AxiosRequestConfig) {
        return SystemEntityControllerApiFp(this.configuration).putItemResourceSystemPut(id, systemRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SystemSearchControllerApi - axios parameter creator
 * @export
 */
export const SystemSearchControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchSystemGet: async (name?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/systems/search/findByName`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SystemSearchControllerApi - functional programming interface
 * @export
 */
export const SystemSearchControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SystemSearchControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSearchSystemGet(name?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelSystem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSearchSystemGet(name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SystemSearchControllerApi - factory interface
 * @export
 */
export const SystemSearchControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SystemSearchControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchSystemGet(name?: string, options?: any): AxiosPromise<EntityModelSystem> {
            return localVarFp.executeSearchSystemGet(name, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SystemSearchControllerApi - object-oriented interface
 * @export
 * @class SystemSearchControllerApi
 * @extends {BaseAPI}
 */
export class SystemSearchControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemSearchControllerApi
     */
    public executeSearchSystemGet(name?: string, options?: AxiosRequestConfig) {
        return SystemSearchControllerApiFp(this.configuration).executeSearchSystemGet(name, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TestControllerApi - axios parameter creator
 * @export
 */
export const TestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new Test from CommandDtoList, name of test and for which system
         * @param {TestDto} testDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewTest: async (testDto: TestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testDto' is not null or undefined
            assertParamExists('createNewTest', 'testDto', testDto)
            const localVarPath = `/api/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Test by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTest: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTest', 'id', id)
            const localVarPath = `/api/test/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Tests for the system with Page
         * @param {string} systemName 
         * @param {number} pageSize 
         * @param {number} pageNumber 
         * @param {Array<string>} sortPage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPageableTestsBySystem: async (systemName: string, pageSize: number, pageNumber: number, sortPage: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemName' is not null or undefined
            assertParamExists('getAllPageableTestsBySystem', 'systemName', systemName)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('getAllPageableTestsBySystem', 'pageSize', pageSize)
            // verify required parameter 'pageNumber' is not null or undefined
            assertParamExists('getAllPageableTestsBySystem', 'pageNumber', pageNumber)
            // verify required parameter 'sortPage' is not null or undefined
            assertParamExists('getAllPageableTestsBySystem', 'sortPage', sortPage)
            const localVarPath = `/api/test/system/{systemName}/pageable`
                .replace(`{${"systemName"}}`, encodeURIComponent(String(systemName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (sortPage) {
                localVarQueryParameter['sortPage'] = sortPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Tests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTests: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/test/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Tests for the system
         * @param {string} systemName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTestsBySystem: async (systemName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemName' is not null or undefined
            assertParamExists('getAllTestsBySystem', 'systemName', systemName)
            const localVarPath = `/api/test/system/{systemName}`
                .replace(`{${"systemName"}}`, encodeURIComponent(String(systemName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all minimal Testinformation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTestsMinimal: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/test/all/minimal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Test by Id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTestById', 'id', id)
            const localVarPath = `/api/test/id/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update existing Test with new commandDtoList, name of test, system and id
         * @param {TestDto} testDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTest: async (testDto: TestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testDto' is not null or undefined
            assertParamExists('updateTest', 'testDto', testDto)
            const localVarPath = `/api/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Predefined-Variables
         * @param {number} id 
         * @param {{ [key: string]: string; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTestPredefinedVariables: async (id: number, requestBody: { [key: string]: string; }, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTestPredefinedVariables', 'id', id)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('updateTestPredefinedVariables', 'requestBody', requestBody)
            const localVarPath = `/api/test/variables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestControllerApi - functional programming interface
 * @export
 */
export const TestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create new Test from CommandDtoList, name of test and for which system
         * @param {TestDto} testDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNewTest(testDto: TestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNewTest(testDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete Test by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTest(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTest(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all Tests for the system with Page
         * @param {string} systemName 
         * @param {number} pageSize 
         * @param {number} pageNumber 
         * @param {Array<string>} sortPage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPageableTestsBySystem(systemName: string, pageSize: number, pageNumber: number, sortPage: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageTestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPageableTestsBySystem(systemName, pageSize, pageNumber, sortPage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all Tests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTests(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TestDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTests(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all Tests for the system
         * @param {string} systemName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTestsBySystem(systemName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TestDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTestsBySystem(systemName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all minimal Testinformation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTestsMinimal(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TestDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTestsMinimal(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Test by Id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update existing Test with new commandDtoList, name of test, system and id
         * @param {TestDto} testDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTest(testDto: TestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTest(testDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Predefined-Variables
         * @param {number} id 
         * @param {{ [key: string]: string; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTestPredefinedVariables(id: number, requestBody: { [key: string]: string; }, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTestPredefinedVariables(id, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestControllerApi - factory interface
 * @export
 */
export const TestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Create new Test from CommandDtoList, name of test and for which system
         * @param {TestDto} testDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewTest(testDto: TestDto, options?: any): AxiosPromise<object> {
            return localVarFp.createNewTest(testDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Test by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTest(id: number, options?: any): AxiosPromise<object> {
            return localVarFp.deleteTest(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all Tests for the system with Page
         * @param {string} systemName 
         * @param {number} pageSize 
         * @param {number} pageNumber 
         * @param {Array<string>} sortPage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPageableTestsBySystem(systemName: string, pageSize: number, pageNumber: number, sortPage: Array<string>, options?: any): AxiosPromise<PageTestDto> {
            return localVarFp.getAllPageableTestsBySystem(systemName, pageSize, pageNumber, sortPage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all Tests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTests(options?: any): AxiosPromise<Array<TestDto>> {
            return localVarFp.getAllTests(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all Tests for the system
         * @param {string} systemName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTestsBySystem(systemName: string, options?: any): AxiosPromise<Array<TestDto>> {
            return localVarFp.getAllTestsBySystem(systemName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all minimal Testinformation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTestsMinimal(options?: any): AxiosPromise<Array<TestDto>> {
            return localVarFp.getAllTestsMinimal(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Test by Id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestById(id: number, options?: any): AxiosPromise<TestDto> {
            return localVarFp.getTestById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update existing Test with new commandDtoList, name of test, system and id
         * @param {TestDto} testDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTest(testDto: TestDto, options?: any): AxiosPromise<string> {
            return localVarFp.updateTest(testDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Predefined-Variables
         * @param {number} id 
         * @param {{ [key: string]: string; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTestPredefinedVariables(id: number, requestBody: { [key: string]: string; }, options?: any): AxiosPromise<string> {
            return localVarFp.updateTestPredefinedVariables(id, requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestControllerApi - object-oriented interface
 * @export
 * @class TestControllerApi
 * @extends {BaseAPI}
 */
export class TestControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create new Test from CommandDtoList, name of test and for which system
     * @param {TestDto} testDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public createNewTest(testDto: TestDto, options?: AxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).createNewTest(testDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Test by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public deleteTest(id: number, options?: AxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).deleteTest(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all Tests for the system with Page
     * @param {string} systemName 
     * @param {number} pageSize 
     * @param {number} pageNumber 
     * @param {Array<string>} sortPage 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public getAllPageableTestsBySystem(systemName: string, pageSize: number, pageNumber: number, sortPage: Array<string>, options?: AxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).getAllPageableTestsBySystem(systemName, pageSize, pageNumber, sortPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all Tests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public getAllTests(options?: AxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).getAllTests(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all Tests for the system
     * @param {string} systemName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public getAllTestsBySystem(systemName: string, options?: AxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).getAllTestsBySystem(systemName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all minimal Testinformation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public getAllTestsMinimal(options?: AxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).getAllTestsMinimal(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Test by Id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public getTestById(id: number, options?: AxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).getTestById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update existing Test with new commandDtoList, name of test, system and id
     * @param {TestDto} testDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public updateTest(testDto: TestDto, options?: AxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).updateTest(testDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Predefined-Variables
     * @param {number} id 
     * @param {{ [key: string]: string; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestControllerApi
     */
    public updateTestPredefinedVariables(id: number, requestBody: { [key: string]: string; }, options?: AxiosRequestConfig) {
        return TestControllerApiFp(this.configuration).updateTestPredefinedVariables(id, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TestEntityControllerApi - axios parameter creator
 * @export
 */
export const TestEntityControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * delete-test
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourceTestDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteItemResourceTestDelete', 'id', id)
            const localVarPath = `/tests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-test
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourceTestGet1: async (page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-test
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourceTestGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getItemResourceTestGet', 'id', id)
            const localVarPath = `/tests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch-test
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourceTestPatch: async (id: string, persistentEntityResource: PersistentEntityResource, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchItemResourceTestPatch', 'id', id)
            // verify required parameter 'persistentEntityResource' is not null or undefined
            assertParamExists('patchItemResourceTestPatch', 'persistentEntityResource', persistentEntityResource)
            const localVarPath = `/tests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(persistentEntityResource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create-test
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourceTestPost: async (persistentEntityResource: PersistentEntityResource, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'persistentEntityResource' is not null or undefined
            assertParamExists('postCollectionResourceTestPost', 'persistentEntityResource', persistentEntityResource)
            const localVarPath = `/tests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(persistentEntityResource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-test
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourceTestPut: async (id: string, persistentEntityResource: PersistentEntityResource, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putItemResourceTestPut', 'id', id)
            // verify required parameter 'persistentEntityResource' is not null or undefined
            assertParamExists('putItemResourceTestPut', 'persistentEntityResource', persistentEntityResource)
            const localVarPath = `/tests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(persistentEntityResource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestEntityControllerApi - functional programming interface
 * @export
 */
export const TestEntityControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestEntityControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * delete-test
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteItemResourceTestDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteItemResourceTestDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-test
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollectionResourceTestGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollectionResourceTestGet1(page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-test
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getItemResourceTestGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getItemResourceTestGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * patch-test
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchItemResourceTestPatch(id: string, persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchItemResourceTestPatch(id, persistentEntityResource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * create-test
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCollectionResourceTestPost(persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCollectionResourceTestPost(persistentEntityResource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-test
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putItemResourceTestPut(id: string, persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putItemResourceTestPut(id, persistentEntityResource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestEntityControllerApi - factory interface
 * @export
 */
export const TestEntityControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestEntityControllerApiFp(configuration)
    return {
        /**
         * delete-test
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourceTestDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteItemResourceTestDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-test
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourceTestGet1(page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.getCollectionResourceTestGet1(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * get-test
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourceTestGet(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.getItemResourceTestGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * patch-test
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourceTestPatch(id: string, persistentEntityResource: PersistentEntityResource, options?: any): AxiosPromise<void> {
            return localVarFp.patchItemResourceTestPatch(id, persistentEntityResource, options).then((request) => request(axios, basePath));
        },
        /**
         * create-test
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourceTestPost(persistentEntityResource: PersistentEntityResource, options?: any): AxiosPromise<void> {
            return localVarFp.postCollectionResourceTestPost(persistentEntityResource, options).then((request) => request(axios, basePath));
        },
        /**
         * update-test
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourceTestPut(id: string, persistentEntityResource: PersistentEntityResource, options?: any): AxiosPromise<void> {
            return localVarFp.putItemResourceTestPut(id, persistentEntityResource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestEntityControllerApi - object-oriented interface
 * @export
 * @class TestEntityControllerApi
 * @extends {BaseAPI}
 */
export class TestEntityControllerApi extends BaseAPI {
    /**
     * delete-test
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestEntityControllerApi
     */
    public deleteItemResourceTestDelete(id: string, options?: AxiosRequestConfig) {
        return TestEntityControllerApiFp(this.configuration).deleteItemResourceTestDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-test
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestEntityControllerApi
     */
    public getCollectionResourceTestGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return TestEntityControllerApiFp(this.configuration).getCollectionResourceTestGet1(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-test
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestEntityControllerApi
     */
    public getItemResourceTestGet(id: string, options?: AxiosRequestConfig) {
        return TestEntityControllerApiFp(this.configuration).getItemResourceTestGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * patch-test
     * @param {string} id 
     * @param {PersistentEntityResource} persistentEntityResource 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestEntityControllerApi
     */
    public patchItemResourceTestPatch(id: string, persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig) {
        return TestEntityControllerApiFp(this.configuration).patchItemResourceTestPatch(id, persistentEntityResource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create-test
     * @param {PersistentEntityResource} persistentEntityResource 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestEntityControllerApi
     */
    public postCollectionResourceTestPost(persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig) {
        return TestEntityControllerApiFp(this.configuration).postCollectionResourceTestPost(persistentEntityResource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-test
     * @param {string} id 
     * @param {PersistentEntityResource} persistentEntityResource 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestEntityControllerApi
     */
    public putItemResourceTestPut(id: string, persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig) {
        return TestEntityControllerApiFp(this.configuration).putItemResourceTestPut(id, persistentEntityResource, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TestExecutionControllerApi - axios parameter creator
 * @export
 */
export const TestExecutionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Execute Test
         * @param {number} id 
         * @param {ExecuteTestRequest} executeTestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeTest: async (id: number, executeTestRequest: ExecuteTestRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('executeTest', 'id', id)
            // verify required parameter 'executeTestRequest' is not null or undefined
            assertParamExists('executeTest', 'executeTestRequest', executeTestRequest)
            const localVarPath = `/api/test/execution/execute/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(executeTestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all TestRuns
         * @param {Pageable} pageable 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTestRuns: async (pageable: Pageable, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageable' is not null or undefined
            assertParamExists('getAllTestRuns', 'pageable', pageable)
            const localVarPath = `/api/test/execution/runs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageable !== undefined) {
                localVarQueryParameter['pageable'] = pageable;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get latest Run by TestId
         * @param {number} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestTestRunById: async (testId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('getLatestTestRunById', 'testId', testId)
            const localVarPath = `/api/test/execution/latestRunByTestId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (testId !== undefined) {
                localVarQueryParameter['testId'] = testId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get TestRuns by TestId
         * @param {number} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestRunsByTestId: async (testId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('getTestRunsByTestId', 'testId', testId)
            const localVarPath = `/api/test/execution/runsByTestId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (testId !== undefined) {
                localVarQueryParameter['testId'] = testId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get TestRuns by TestId and Date Without Teststeps
         * @param {number} pageSize 
         * @param {number} pageNumber 
         * @param {Array<string>} sortPage 
         * @param {number} [testId] 
         * @param {string} [from] 
         * @param {string} [till] 
         * @param {boolean} [isUsed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestRunsWithCriteria: async (pageSize: number, pageNumber: number, sortPage: Array<string>, testId?: number, from?: string, till?: string, isUsed?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('getTestRunsWithCriteria', 'pageSize', pageSize)
            // verify required parameter 'pageNumber' is not null or undefined
            assertParamExists('getTestRunsWithCriteria', 'pageNumber', pageNumber)
            // verify required parameter 'sortPage' is not null or undefined
            assertParamExists('getTestRunsWithCriteria', 'sortPage', sortPage)
            const localVarPath = `/api/test/execution/runsWithCriteria`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (testId !== undefined) {
                localVarQueryParameter['testId'] = testId;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substr(0,10) :
                    from;
            }

            if (till !== undefined) {
                localVarQueryParameter['till'] = (till as any instanceof Date) ?
                    (till as any).toISOString().substr(0,10) :
                    till;
            }

            if (isUsed !== undefined) {
                localVarQueryParameter['isUsed'] = isUsed;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (sortPage) {
                localVarQueryParameter['sortPage'] = sortPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestExecutionControllerApi - functional programming interface
 * @export
 */
export const TestExecutionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestExecutionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Execute Test
         * @param {number} id 
         * @param {ExecuteTestRequest} executeTestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeTest(id: number, executeTestRequest: ExecuteTestRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestExecutionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeTest(id, executeTestRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all TestRuns
         * @param {Pageable} pageable 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTestRuns(pageable: Pageable, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageTestExecutionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTestRuns(pageable, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get latest Run by TestId
         * @param {number} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestTestRunById(testId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestExecutionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestTestRunById(testId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get TestRuns by TestId
         * @param {number} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestRunsByTestId(testId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TestExecutionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestRunsByTestId(testId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get TestRuns by TestId and Date Without Teststeps
         * @param {number} pageSize 
         * @param {number} pageNumber 
         * @param {Array<string>} sortPage 
         * @param {number} [testId] 
         * @param {string} [from] 
         * @param {string} [till] 
         * @param {boolean} [isUsed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestRunsWithCriteria(pageSize: number, pageNumber: number, sortPage: Array<string>, testId?: number, from?: string, till?: string, isUsed?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageTestExecutionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestRunsWithCriteria(pageSize, pageNumber, sortPage, testId, from, till, isUsed, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestExecutionControllerApi - factory interface
 * @export
 */
export const TestExecutionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestExecutionControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Execute Test
         * @param {number} id 
         * @param {ExecuteTestRequest} executeTestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeTest(id: number, executeTestRequest: ExecuteTestRequest, options?: any): AxiosPromise<TestExecutionDto> {
            return localVarFp.executeTest(id, executeTestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all TestRuns
         * @param {Pageable} pageable 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTestRuns(pageable: Pageable, options?: any): AxiosPromise<PageTestExecutionDto> {
            return localVarFp.getAllTestRuns(pageable, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get latest Run by TestId
         * @param {number} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestTestRunById(testId: number, options?: any): AxiosPromise<TestExecutionDto> {
            return localVarFp.getLatestTestRunById(testId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get TestRuns by TestId
         * @param {number} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestRunsByTestId(testId: number, options?: any): AxiosPromise<Array<TestExecutionDto>> {
            return localVarFp.getTestRunsByTestId(testId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get TestRuns by TestId and Date Without Teststeps
         * @param {number} pageSize 
         * @param {number} pageNumber 
         * @param {Array<string>} sortPage 
         * @param {number} [testId] 
         * @param {string} [from] 
         * @param {string} [till] 
         * @param {boolean} [isUsed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestRunsWithCriteria(pageSize: number, pageNumber: number, sortPage: Array<string>, testId?: number, from?: string, till?: string, isUsed?: boolean, options?: any): AxiosPromise<PageTestExecutionDto> {
            return localVarFp.getTestRunsWithCriteria(pageSize, pageNumber, sortPage, testId, from, till, isUsed, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestExecutionControllerApi - object-oriented interface
 * @export
 * @class TestExecutionControllerApi
 * @extends {BaseAPI}
 */
export class TestExecutionControllerApi extends BaseAPI {
    /**
     * 
     * @summary Execute Test
     * @param {number} id 
     * @param {ExecuteTestRequest} executeTestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionControllerApi
     */
    public executeTest(id: number, executeTestRequest: ExecuteTestRequest, options?: AxiosRequestConfig) {
        return TestExecutionControllerApiFp(this.configuration).executeTest(id, executeTestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all TestRuns
     * @param {Pageable} pageable 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionControllerApi
     */
    public getAllTestRuns(pageable: Pageable, options?: AxiosRequestConfig) {
        return TestExecutionControllerApiFp(this.configuration).getAllTestRuns(pageable, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get latest Run by TestId
     * @param {number} testId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionControllerApi
     */
    public getLatestTestRunById(testId: number, options?: AxiosRequestConfig) {
        return TestExecutionControllerApiFp(this.configuration).getLatestTestRunById(testId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get TestRuns by TestId
     * @param {number} testId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionControllerApi
     */
    public getTestRunsByTestId(testId: number, options?: AxiosRequestConfig) {
        return TestExecutionControllerApiFp(this.configuration).getTestRunsByTestId(testId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get TestRuns by TestId and Date Without Teststeps
     * @param {number} pageSize 
     * @param {number} pageNumber 
     * @param {Array<string>} sortPage 
     * @param {number} [testId] 
     * @param {string} [from] 
     * @param {string} [till] 
     * @param {boolean} [isUsed] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionControllerApi
     */
    public getTestRunsWithCriteria(pageSize: number, pageNumber: number, sortPage: Array<string>, testId?: number, from?: string, till?: string, isUsed?: boolean, options?: AxiosRequestConfig) {
        return TestExecutionControllerApiFp(this.configuration).getTestRunsWithCriteria(pageSize, pageNumber, sortPage, testId, from, till, isUsed, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TestExecutionControllerExternalApi - axios parameter creator
 * @export
 */
export const TestExecutionControllerExternalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTest: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTest', 'id', id)
            const localVarPath = `/api/external/test/test/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestExecutionControllerExternalApi - functional programming interface
 * @export
 */
export const TestExecutionControllerExternalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestExecutionControllerExternalApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTest(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTest(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestExecutionControllerExternalApi - factory interface
 * @export
 */
export const TestExecutionControllerExternalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestExecutionControllerExternalApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTest(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.getTest(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestExecutionControllerExternalApi - object-oriented interface
 * @export
 * @class TestExecutionControllerExternalApi
 * @extends {BaseAPI}
 */
export class TestExecutionControllerExternalApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionControllerExternalApi
     */
    public getTest(id: number, options?: AxiosRequestConfig) {
        return TestExecutionControllerExternalApiFp(this.configuration).getTest(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TestExecutionEntityControllerApi - axios parameter creator
 * @export
 */
export const TestExecutionEntityControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * delete-testexecution
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourceTestexecutionDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteItemResourceTestexecutionDelete', 'id', id)
            const localVarPath = `/testExecutions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-testexecution
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourceTestexecutionGet1: async (page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/testExecutions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-testexecution
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourceTestexecutionGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getItemResourceTestexecutionGet', 'id', id)
            const localVarPath = `/testExecutions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch-testexecution
         * @param {string} id 
         * @param {TestExecutionRequestBody} testExecutionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourceTestexecutionPatch: async (id: string, testExecutionRequestBody: TestExecutionRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchItemResourceTestexecutionPatch', 'id', id)
            // verify required parameter 'testExecutionRequestBody' is not null or undefined
            assertParamExists('patchItemResourceTestexecutionPatch', 'testExecutionRequestBody', testExecutionRequestBody)
            const localVarPath = `/testExecutions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testExecutionRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create-testexecution
         * @param {TestExecutionRequestBody} testExecutionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourceTestexecutionPost: async (testExecutionRequestBody: TestExecutionRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testExecutionRequestBody' is not null or undefined
            assertParamExists('postCollectionResourceTestexecutionPost', 'testExecutionRequestBody', testExecutionRequestBody)
            const localVarPath = `/testExecutions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testExecutionRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-testexecution
         * @param {string} id 
         * @param {TestExecutionRequestBody} testExecutionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourceTestexecutionPut: async (id: string, testExecutionRequestBody: TestExecutionRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putItemResourceTestexecutionPut', 'id', id)
            // verify required parameter 'testExecutionRequestBody' is not null or undefined
            assertParamExists('putItemResourceTestexecutionPut', 'testExecutionRequestBody', testExecutionRequestBody)
            const localVarPath = `/testExecutions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testExecutionRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestExecutionEntityControllerApi - functional programming interface
 * @export
 */
export const TestExecutionEntityControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestExecutionEntityControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * delete-testexecution
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteItemResourceTestexecutionDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteItemResourceTestexecutionDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-testexecution
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollectionResourceTestexecutionGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedModelEntityModelTestExecution>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollectionResourceTestexecutionGet1(page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-testexecution
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getItemResourceTestexecutionGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelTestExecution>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getItemResourceTestexecutionGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * patch-testexecution
         * @param {string} id 
         * @param {TestExecutionRequestBody} testExecutionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchItemResourceTestexecutionPatch(id: string, testExecutionRequestBody: TestExecutionRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelTestExecution>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchItemResourceTestexecutionPatch(id, testExecutionRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * create-testexecution
         * @param {TestExecutionRequestBody} testExecutionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCollectionResourceTestexecutionPost(testExecutionRequestBody: TestExecutionRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelTestExecution>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCollectionResourceTestexecutionPost(testExecutionRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-testexecution
         * @param {string} id 
         * @param {TestExecutionRequestBody} testExecutionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putItemResourceTestexecutionPut(id: string, testExecutionRequestBody: TestExecutionRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelTestExecution>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putItemResourceTestexecutionPut(id, testExecutionRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestExecutionEntityControllerApi - factory interface
 * @export
 */
export const TestExecutionEntityControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestExecutionEntityControllerApiFp(configuration)
    return {
        /**
         * delete-testexecution
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourceTestexecutionDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteItemResourceTestexecutionDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-testexecution
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourceTestexecutionGet1(page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PagedModelEntityModelTestExecution> {
            return localVarFp.getCollectionResourceTestexecutionGet1(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * get-testexecution
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourceTestexecutionGet(id: string, options?: any): AxiosPromise<EntityModelTestExecution> {
            return localVarFp.getItemResourceTestexecutionGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * patch-testexecution
         * @param {string} id 
         * @param {TestExecutionRequestBody} testExecutionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourceTestexecutionPatch(id: string, testExecutionRequestBody: TestExecutionRequestBody, options?: any): AxiosPromise<EntityModelTestExecution> {
            return localVarFp.patchItemResourceTestexecutionPatch(id, testExecutionRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * create-testexecution
         * @param {TestExecutionRequestBody} testExecutionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourceTestexecutionPost(testExecutionRequestBody: TestExecutionRequestBody, options?: any): AxiosPromise<EntityModelTestExecution> {
            return localVarFp.postCollectionResourceTestexecutionPost(testExecutionRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * update-testexecution
         * @param {string} id 
         * @param {TestExecutionRequestBody} testExecutionRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourceTestexecutionPut(id: string, testExecutionRequestBody: TestExecutionRequestBody, options?: any): AxiosPromise<EntityModelTestExecution> {
            return localVarFp.putItemResourceTestexecutionPut(id, testExecutionRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestExecutionEntityControllerApi - object-oriented interface
 * @export
 * @class TestExecutionEntityControllerApi
 * @extends {BaseAPI}
 */
export class TestExecutionEntityControllerApi extends BaseAPI {
    /**
     * delete-testexecution
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionEntityControllerApi
     */
    public deleteItemResourceTestexecutionDelete(id: string, options?: AxiosRequestConfig) {
        return TestExecutionEntityControllerApiFp(this.configuration).deleteItemResourceTestexecutionDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-testexecution
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionEntityControllerApi
     */
    public getCollectionResourceTestexecutionGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return TestExecutionEntityControllerApiFp(this.configuration).getCollectionResourceTestexecutionGet1(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-testexecution
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionEntityControllerApi
     */
    public getItemResourceTestexecutionGet(id: string, options?: AxiosRequestConfig) {
        return TestExecutionEntityControllerApiFp(this.configuration).getItemResourceTestexecutionGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * patch-testexecution
     * @param {string} id 
     * @param {TestExecutionRequestBody} testExecutionRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionEntityControllerApi
     */
    public patchItemResourceTestexecutionPatch(id: string, testExecutionRequestBody: TestExecutionRequestBody, options?: AxiosRequestConfig) {
        return TestExecutionEntityControllerApiFp(this.configuration).patchItemResourceTestexecutionPatch(id, testExecutionRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create-testexecution
     * @param {TestExecutionRequestBody} testExecutionRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionEntityControllerApi
     */
    public postCollectionResourceTestexecutionPost(testExecutionRequestBody: TestExecutionRequestBody, options?: AxiosRequestConfig) {
        return TestExecutionEntityControllerApiFp(this.configuration).postCollectionResourceTestexecutionPost(testExecutionRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-testexecution
     * @param {string} id 
     * @param {TestExecutionRequestBody} testExecutionRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionEntityControllerApi
     */
    public putItemResourceTestexecutionPut(id: string, testExecutionRequestBody: TestExecutionRequestBody, options?: AxiosRequestConfig) {
        return TestExecutionEntityControllerApiFp(this.configuration).putItemResourceTestexecutionPut(id, testExecutionRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TestExecutionPropertyReferenceControllerApi - axios parameter creator
 * @export
 */
export const TestExecutionPropertyReferenceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * patch-testresult-by-testexecution-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestexecutionPatch: async (id: string, collectionModelObject: CollectionModelObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPropertyReferenceTestexecutionPatch', 'id', id)
            // verify required parameter 'collectionModelObject' is not null or undefined
            assertParamExists('createPropertyReferenceTestexecutionPatch', 'collectionModelObject', collectionModelObject)
            const localVarPath = `/testExecutions/{id}/testResult`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionModelObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-testresult-by-testexecution-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestexecutionPut: async (id: string, collectionModelObject: CollectionModelObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPropertyReferenceTestexecutionPut', 'id', id)
            // verify required parameter 'collectionModelObject' is not null or undefined
            assertParamExists('createPropertyReferenceTestexecutionPut', 'collectionModelObject', collectionModelObject)
            const localVarPath = `/testExecutions/{id}/testResult`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionModelObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete-testresult-by-testexecution-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceIdTestexecutionDelete: async (id: string, propertyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePropertyReferenceIdTestexecutionDelete', 'id', id)
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('deletePropertyReferenceIdTestexecutionDelete', 'propertyId', propertyId)
            const localVarPath = `/testExecutions/{id}/testResult/{propertyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete-testresult-by-testexecution-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceTestexecutionDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePropertyReferenceTestexecutionDelete', 'id', id)
            const localVarPath = `/testExecutions/{id}/testResult`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-testresult-by-testexecution-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestexecutionGet: async (id: string, propertyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('followPropertyReferenceTestexecutionGet', 'id', id)
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('followPropertyReferenceTestexecutionGet', 'propertyId', propertyId)
            const localVarPath = `/testExecutions/{id}/testResult/{propertyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-testresult-by-testexecution-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestexecutionGet1: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('followPropertyReferenceTestexecutionGet1', 'id', id)
            const localVarPath = `/testExecutions/{id}/testResult`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestExecutionPropertyReferenceControllerApi - functional programming interface
 * @export
 */
export const TestExecutionPropertyReferenceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestExecutionPropertyReferenceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * patch-testresult-by-testexecution-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReferenceTestexecutionPatch(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelTestResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReferenceTestexecutionPatch(id, collectionModelObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-testresult-by-testexecution-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReferenceTestexecutionPut(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelTestResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReferenceTestexecutionPut(id, collectionModelObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete-testresult-by-testexecution-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePropertyReferenceIdTestexecutionDelete(id: string, propertyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePropertyReferenceIdTestexecutionDelete(id, propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete-testresult-by-testexecution-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePropertyReferenceTestexecutionDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePropertyReferenceTestexecutionDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-testresult-by-testexecution-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followPropertyReferenceTestexecutionGet(id: string, propertyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelTestResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followPropertyReferenceTestexecutionGet(id, propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-testresult-by-testexecution-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followPropertyReferenceTestexecutionGet1(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelTestResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followPropertyReferenceTestexecutionGet1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestExecutionPropertyReferenceControllerApi - factory interface
 * @export
 */
export const TestExecutionPropertyReferenceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestExecutionPropertyReferenceControllerApiFp(configuration)
    return {
        /**
         * patch-testresult-by-testexecution-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestexecutionPatch(id: string, collectionModelObject: CollectionModelObject, options?: any): AxiosPromise<EntityModelTestResult> {
            return localVarFp.createPropertyReferenceTestexecutionPatch(id, collectionModelObject, options).then((request) => request(axios, basePath));
        },
        /**
         * update-testresult-by-testexecution-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestexecutionPut(id: string, collectionModelObject: CollectionModelObject, options?: any): AxiosPromise<EntityModelTestResult> {
            return localVarFp.createPropertyReferenceTestexecutionPut(id, collectionModelObject, options).then((request) => request(axios, basePath));
        },
        /**
         * delete-testresult-by-testexecution-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceIdTestexecutionDelete(id: string, propertyId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePropertyReferenceIdTestexecutionDelete(id, propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * delete-testresult-by-testexecution-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceTestexecutionDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePropertyReferenceTestexecutionDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-testresult-by-testexecution-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestexecutionGet(id: string, propertyId: string, options?: any): AxiosPromise<EntityModelTestResult> {
            return localVarFp.followPropertyReferenceTestexecutionGet(id, propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * get-testresult-by-testexecution-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestexecutionGet1(id: string, options?: any): AxiosPromise<EntityModelTestResult> {
            return localVarFp.followPropertyReferenceTestexecutionGet1(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestExecutionPropertyReferenceControllerApi - object-oriented interface
 * @export
 * @class TestExecutionPropertyReferenceControllerApi
 * @extends {BaseAPI}
 */
export class TestExecutionPropertyReferenceControllerApi extends BaseAPI {
    /**
     * patch-testresult-by-testexecution-Id
     * @param {string} id 
     * @param {CollectionModelObject} collectionModelObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionPropertyReferenceControllerApi
     */
    public createPropertyReferenceTestexecutionPatch(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig) {
        return TestExecutionPropertyReferenceControllerApiFp(this.configuration).createPropertyReferenceTestexecutionPatch(id, collectionModelObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-testresult-by-testexecution-Id
     * @param {string} id 
     * @param {CollectionModelObject} collectionModelObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionPropertyReferenceControllerApi
     */
    public createPropertyReferenceTestexecutionPut(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig) {
        return TestExecutionPropertyReferenceControllerApiFp(this.configuration).createPropertyReferenceTestexecutionPut(id, collectionModelObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete-testresult-by-testexecution-Id
     * @param {string} id 
     * @param {string} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionPropertyReferenceControllerApi
     */
    public deletePropertyReferenceIdTestexecutionDelete(id: string, propertyId: string, options?: AxiosRequestConfig) {
        return TestExecutionPropertyReferenceControllerApiFp(this.configuration).deletePropertyReferenceIdTestexecutionDelete(id, propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete-testresult-by-testexecution-Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionPropertyReferenceControllerApi
     */
    public deletePropertyReferenceTestexecutionDelete(id: string, options?: AxiosRequestConfig) {
        return TestExecutionPropertyReferenceControllerApiFp(this.configuration).deletePropertyReferenceTestexecutionDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-testresult-by-testexecution-Id
     * @param {string} id 
     * @param {string} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionPropertyReferenceControllerApi
     */
    public followPropertyReferenceTestexecutionGet(id: string, propertyId: string, options?: AxiosRequestConfig) {
        return TestExecutionPropertyReferenceControllerApiFp(this.configuration).followPropertyReferenceTestexecutionGet(id, propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-testresult-by-testexecution-Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionPropertyReferenceControllerApi
     */
    public followPropertyReferenceTestexecutionGet1(id: string, options?: AxiosRequestConfig) {
        return TestExecutionPropertyReferenceControllerApiFp(this.configuration).followPropertyReferenceTestexecutionGet1(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TestExecutionSearchControllerApi - axios parameter creator
 * @export
 */
export const TestExecutionSearchControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [startTs] 
         * @param {string} [endTs] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestexecutionGet: async (startTs?: string, endTs?: string, page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/testExecutions/search/findByDateBetweenStartAndEndTs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startTs !== undefined) {
                localVarQueryParameter['startTs'] = (startTs as any instanceof Date) ?
                    (startTs as any).toISOString() :
                    startTs;
            }

            if (endTs !== undefined) {
                localVarQueryParameter['endTs'] = (endTs as any instanceof Date) ?
                    (endTs as any).toISOString() :
                    endTs;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [testId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestexecutionGet1: async (testId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/testExecutions/search/findByTestId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (testId !== undefined) {
                localVarQueryParameter['testId'] = testId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [testId] 
         * @param {string} [startTs] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestexecutionGet2: async (testId?: number, startTs?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/testExecutions/search/findByTestIdAndDateAfterStartTs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (testId !== undefined) {
                localVarQueryParameter['testId'] = testId;
            }

            if (startTs !== undefined) {
                localVarQueryParameter['startTs'] = (startTs as any instanceof Date) ?
                    (startTs as any).toISOString() :
                    startTs;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [testId] 
         * @param {string} [startTs] 
         * @param {string} [endTs] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestexecutionGet3: async (testId?: number, startTs?: string, endTs?: string, page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/testExecutions/search/findByTestIdAndDateBetweenStartAndEndDate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (testId !== undefined) {
                localVarQueryParameter['testId'] = testId;
            }

            if (startTs !== undefined) {
                localVarQueryParameter['startTs'] = (startTs as any instanceof Date) ?
                    (startTs as any).toISOString() :
                    startTs;
            }

            if (endTs !== undefined) {
                localVarQueryParameter['endTs'] = (endTs as any instanceof Date) ?
                    (endTs as any).toISOString() :
                    endTs;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [testId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestexecutionGet4: async (testId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/testExecutions/search/findByTestOrderByStartTs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (testId !== undefined) {
                localVarQueryParameter['testId'] = testId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endTs] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestexecutionGet5: async (endTs?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/testExecutions/search/findTestExecutionByEndTsAfter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (endTs !== undefined) {
                localVarQueryParameter['endTs'] = (endTs as any instanceof Date) ?
                    (endTs as any).toISOString() :
                    endTs;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [testId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestexecutionGet6: async (testId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/testExecutions/search/findTestExecutionsByTestIdOrderByStartTsDesc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (testId !== undefined) {
                localVarQueryParameter['testId'] = testId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [testId] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestexecutionGet7: async (testId?: number, page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/testExecutions/search/findTestOrderByStartTs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (testId !== undefined) {
                localVarQueryParameter['testId'] = testId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestExecutionSearchControllerApi - functional programming interface
 * @export
 */
export const TestExecutionSearchControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestExecutionSearchControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [startTs] 
         * @param {string} [endTs] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSearchTestexecutionGet(startTs?: string, endTs?: string, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedModelEntityModelTestExecution>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSearchTestexecutionGet(startTs, endTs, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [testId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSearchTestexecutionGet1(testId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionModelEntityModelTestExecution>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSearchTestexecutionGet1(testId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [testId] 
         * @param {string} [startTs] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSearchTestexecutionGet2(testId?: number, startTs?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionModelEntityModelTestExecution>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSearchTestexecutionGet2(testId, startTs, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [testId] 
         * @param {string} [startTs] 
         * @param {string} [endTs] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSearchTestexecutionGet3(testId?: number, startTs?: string, endTs?: string, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedModelEntityModelTestExecution>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSearchTestexecutionGet3(testId, startTs, endTs, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [testId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSearchTestexecutionGet4(testId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionModelEntityModelTestExecution>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSearchTestexecutionGet4(testId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [endTs] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSearchTestexecutionGet5(endTs?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionModelEntityModelTestExecution>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSearchTestexecutionGet5(endTs, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [testId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSearchTestexecutionGet6(testId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionModelEntityModelTestExecution>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSearchTestexecutionGet6(testId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [testId] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSearchTestexecutionGet7(testId?: number, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedModelEntityModelTestExecution>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSearchTestexecutionGet7(testId, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestExecutionSearchControllerApi - factory interface
 * @export
 */
export const TestExecutionSearchControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestExecutionSearchControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [startTs] 
         * @param {string} [endTs] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestexecutionGet(startTs?: string, endTs?: string, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PagedModelEntityModelTestExecution> {
            return localVarFp.executeSearchTestexecutionGet(startTs, endTs, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [testId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestexecutionGet1(testId?: number, options?: any): AxiosPromise<CollectionModelEntityModelTestExecution> {
            return localVarFp.executeSearchTestexecutionGet1(testId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [testId] 
         * @param {string} [startTs] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestexecutionGet2(testId?: number, startTs?: string, options?: any): AxiosPromise<CollectionModelEntityModelTestExecution> {
            return localVarFp.executeSearchTestexecutionGet2(testId, startTs, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [testId] 
         * @param {string} [startTs] 
         * @param {string} [endTs] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestexecutionGet3(testId?: number, startTs?: string, endTs?: string, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PagedModelEntityModelTestExecution> {
            return localVarFp.executeSearchTestexecutionGet3(testId, startTs, endTs, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [testId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestexecutionGet4(testId?: number, options?: any): AxiosPromise<CollectionModelEntityModelTestExecution> {
            return localVarFp.executeSearchTestexecutionGet4(testId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [endTs] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestexecutionGet5(endTs?: string, options?: any): AxiosPromise<CollectionModelEntityModelTestExecution> {
            return localVarFp.executeSearchTestexecutionGet5(endTs, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [testId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestexecutionGet6(testId?: number, options?: any): AxiosPromise<CollectionModelEntityModelTestExecution> {
            return localVarFp.executeSearchTestexecutionGet6(testId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [testId] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestexecutionGet7(testId?: number, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PagedModelEntityModelTestExecution> {
            return localVarFp.executeSearchTestexecutionGet7(testId, page, size, sort, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestExecutionSearchControllerApi - object-oriented interface
 * @export
 * @class TestExecutionSearchControllerApi
 * @extends {BaseAPI}
 */
export class TestExecutionSearchControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} [startTs] 
     * @param {string} [endTs] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionSearchControllerApi
     */
    public executeSearchTestexecutionGet(startTs?: string, endTs?: string, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return TestExecutionSearchControllerApiFp(this.configuration).executeSearchTestexecutionGet(startTs, endTs, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [testId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionSearchControllerApi
     */
    public executeSearchTestexecutionGet1(testId?: number, options?: AxiosRequestConfig) {
        return TestExecutionSearchControllerApiFp(this.configuration).executeSearchTestexecutionGet1(testId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [testId] 
     * @param {string} [startTs] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionSearchControllerApi
     */
    public executeSearchTestexecutionGet2(testId?: number, startTs?: string, options?: AxiosRequestConfig) {
        return TestExecutionSearchControllerApiFp(this.configuration).executeSearchTestexecutionGet2(testId, startTs, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [testId] 
     * @param {string} [startTs] 
     * @param {string} [endTs] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionSearchControllerApi
     */
    public executeSearchTestexecutionGet3(testId?: number, startTs?: string, endTs?: string, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return TestExecutionSearchControllerApiFp(this.configuration).executeSearchTestexecutionGet3(testId, startTs, endTs, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [testId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionSearchControllerApi
     */
    public executeSearchTestexecutionGet4(testId?: number, options?: AxiosRequestConfig) {
        return TestExecutionSearchControllerApiFp(this.configuration).executeSearchTestexecutionGet4(testId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [endTs] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionSearchControllerApi
     */
    public executeSearchTestexecutionGet5(endTs?: string, options?: AxiosRequestConfig) {
        return TestExecutionSearchControllerApiFp(this.configuration).executeSearchTestexecutionGet5(endTs, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [testId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionSearchControllerApi
     */
    public executeSearchTestexecutionGet6(testId?: number, options?: AxiosRequestConfig) {
        return TestExecutionSearchControllerApiFp(this.configuration).executeSearchTestexecutionGet6(testId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [testId] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionSearchControllerApi
     */
    public executeSearchTestexecutionGet7(testId?: number, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return TestExecutionSearchControllerApiFp(this.configuration).executeSearchTestexecutionGet7(testId, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TestPauseDataEntityControllerApi - axios parameter creator
 * @export
 */
export const TestPauseDataEntityControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * delete-testpausedata
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourceTestpausedataDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteItemResourceTestpausedataDelete', 'id', id)
            const localVarPath = `/testPauseDatas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-testpausedata
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourceTestpausedataGet1: async (page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/testPauseDatas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-testpausedata
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourceTestpausedataGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getItemResourceTestpausedataGet', 'id', id)
            const localVarPath = `/testPauseDatas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch-testpausedata
         * @param {string} id 
         * @param {TestPauseDataRequestBody} testPauseDataRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourceTestpausedataPatch: async (id: string, testPauseDataRequestBody: TestPauseDataRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchItemResourceTestpausedataPatch', 'id', id)
            // verify required parameter 'testPauseDataRequestBody' is not null or undefined
            assertParamExists('patchItemResourceTestpausedataPatch', 'testPauseDataRequestBody', testPauseDataRequestBody)
            const localVarPath = `/testPauseDatas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testPauseDataRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create-testpausedata
         * @param {TestPauseDataRequestBody} testPauseDataRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourceTestpausedataPost: async (testPauseDataRequestBody: TestPauseDataRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testPauseDataRequestBody' is not null or undefined
            assertParamExists('postCollectionResourceTestpausedataPost', 'testPauseDataRequestBody', testPauseDataRequestBody)
            const localVarPath = `/testPauseDatas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testPauseDataRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-testpausedata
         * @param {string} id 
         * @param {TestPauseDataRequestBody} testPauseDataRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourceTestpausedataPut: async (id: string, testPauseDataRequestBody: TestPauseDataRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putItemResourceTestpausedataPut', 'id', id)
            // verify required parameter 'testPauseDataRequestBody' is not null or undefined
            assertParamExists('putItemResourceTestpausedataPut', 'testPauseDataRequestBody', testPauseDataRequestBody)
            const localVarPath = `/testPauseDatas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testPauseDataRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestPauseDataEntityControllerApi - functional programming interface
 * @export
 */
export const TestPauseDataEntityControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestPauseDataEntityControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * delete-testpausedata
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteItemResourceTestpausedataDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteItemResourceTestpausedataDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-testpausedata
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollectionResourceTestpausedataGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedModelEntityModelTestPauseData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollectionResourceTestpausedataGet1(page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-testpausedata
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getItemResourceTestpausedataGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelTestPauseData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getItemResourceTestpausedataGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * patch-testpausedata
         * @param {string} id 
         * @param {TestPauseDataRequestBody} testPauseDataRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchItemResourceTestpausedataPatch(id: string, testPauseDataRequestBody: TestPauseDataRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelTestPauseData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchItemResourceTestpausedataPatch(id, testPauseDataRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * create-testpausedata
         * @param {TestPauseDataRequestBody} testPauseDataRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCollectionResourceTestpausedataPost(testPauseDataRequestBody: TestPauseDataRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelTestPauseData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCollectionResourceTestpausedataPost(testPauseDataRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-testpausedata
         * @param {string} id 
         * @param {TestPauseDataRequestBody} testPauseDataRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putItemResourceTestpausedataPut(id: string, testPauseDataRequestBody: TestPauseDataRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelTestPauseData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putItemResourceTestpausedataPut(id, testPauseDataRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestPauseDataEntityControllerApi - factory interface
 * @export
 */
export const TestPauseDataEntityControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestPauseDataEntityControllerApiFp(configuration)
    return {
        /**
         * delete-testpausedata
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourceTestpausedataDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteItemResourceTestpausedataDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-testpausedata
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourceTestpausedataGet1(page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PagedModelEntityModelTestPauseData> {
            return localVarFp.getCollectionResourceTestpausedataGet1(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * get-testpausedata
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourceTestpausedataGet(id: string, options?: any): AxiosPromise<EntityModelTestPauseData> {
            return localVarFp.getItemResourceTestpausedataGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * patch-testpausedata
         * @param {string} id 
         * @param {TestPauseDataRequestBody} testPauseDataRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourceTestpausedataPatch(id: string, testPauseDataRequestBody: TestPauseDataRequestBody, options?: any): AxiosPromise<EntityModelTestPauseData> {
            return localVarFp.patchItemResourceTestpausedataPatch(id, testPauseDataRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * create-testpausedata
         * @param {TestPauseDataRequestBody} testPauseDataRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourceTestpausedataPost(testPauseDataRequestBody: TestPauseDataRequestBody, options?: any): AxiosPromise<EntityModelTestPauseData> {
            return localVarFp.postCollectionResourceTestpausedataPost(testPauseDataRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * update-testpausedata
         * @param {string} id 
         * @param {TestPauseDataRequestBody} testPauseDataRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourceTestpausedataPut(id: string, testPauseDataRequestBody: TestPauseDataRequestBody, options?: any): AxiosPromise<EntityModelTestPauseData> {
            return localVarFp.putItemResourceTestpausedataPut(id, testPauseDataRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestPauseDataEntityControllerApi - object-oriented interface
 * @export
 * @class TestPauseDataEntityControllerApi
 * @extends {BaseAPI}
 */
export class TestPauseDataEntityControllerApi extends BaseAPI {
    /**
     * delete-testpausedata
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPauseDataEntityControllerApi
     */
    public deleteItemResourceTestpausedataDelete(id: string, options?: AxiosRequestConfig) {
        return TestPauseDataEntityControllerApiFp(this.configuration).deleteItemResourceTestpausedataDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-testpausedata
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPauseDataEntityControllerApi
     */
    public getCollectionResourceTestpausedataGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return TestPauseDataEntityControllerApiFp(this.configuration).getCollectionResourceTestpausedataGet1(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-testpausedata
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPauseDataEntityControllerApi
     */
    public getItemResourceTestpausedataGet(id: string, options?: AxiosRequestConfig) {
        return TestPauseDataEntityControllerApiFp(this.configuration).getItemResourceTestpausedataGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * patch-testpausedata
     * @param {string} id 
     * @param {TestPauseDataRequestBody} testPauseDataRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPauseDataEntityControllerApi
     */
    public patchItemResourceTestpausedataPatch(id: string, testPauseDataRequestBody: TestPauseDataRequestBody, options?: AxiosRequestConfig) {
        return TestPauseDataEntityControllerApiFp(this.configuration).patchItemResourceTestpausedataPatch(id, testPauseDataRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create-testpausedata
     * @param {TestPauseDataRequestBody} testPauseDataRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPauseDataEntityControllerApi
     */
    public postCollectionResourceTestpausedataPost(testPauseDataRequestBody: TestPauseDataRequestBody, options?: AxiosRequestConfig) {
        return TestPauseDataEntityControllerApiFp(this.configuration).postCollectionResourceTestpausedataPost(testPauseDataRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-testpausedata
     * @param {string} id 
     * @param {TestPauseDataRequestBody} testPauseDataRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPauseDataEntityControllerApi
     */
    public putItemResourceTestpausedataPut(id: string, testPauseDataRequestBody: TestPauseDataRequestBody, options?: AxiosRequestConfig) {
        return TestPauseDataEntityControllerApiFp(this.configuration).putItemResourceTestpausedataPut(id, testPauseDataRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TestPauseDataSearchControllerApi - axios parameter creator
 * @export
 */
export const TestPauseDataSearchControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [localDateTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestpausedataGet: async (localDateTime?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/testPauseDatas/search/findAllToSchedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (localDateTime !== undefined) {
                localVarQueryParameter['localDateTime'] = (localDateTime as any instanceof Date) ?
                    (localDateTime as any).toISOString() :
                    localDateTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestPauseDataSearchControllerApi - functional programming interface
 * @export
 */
export const TestPauseDataSearchControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestPauseDataSearchControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [localDateTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSearchTestpausedataGet(localDateTime?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionModelEntityModelTestPauseData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSearchTestpausedataGet(localDateTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestPauseDataSearchControllerApi - factory interface
 * @export
 */
export const TestPauseDataSearchControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestPauseDataSearchControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [localDateTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestpausedataGet(localDateTime?: string, options?: any): AxiosPromise<CollectionModelEntityModelTestPauseData> {
            return localVarFp.executeSearchTestpausedataGet(localDateTime, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestPauseDataSearchControllerApi - object-oriented interface
 * @export
 * @class TestPauseDataSearchControllerApi
 * @extends {BaseAPI}
 */
export class TestPauseDataSearchControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} [localDateTime] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPauseDataSearchControllerApi
     */
    public executeSearchTestpausedataGet(localDateTime?: string, options?: AxiosRequestConfig) {
        return TestPauseDataSearchControllerApiFp(this.configuration).executeSearchTestpausedataGet(localDateTime, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TestPlanControllerApi - axios parameter creator
 * @export
 */
export const TestPlanControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add Tests to Testplan
         * @param {number} id 
         * @param {Array<TestPlanTestDto>} testPlanTestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTestsToTestplan: async (id: number, testPlanTestDto: Array<TestPlanTestDto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addTestsToTestplan', 'id', id)
            // verify required parameter 'testPlanTestDto' is not null or undefined
            assertParamExists('addTestsToTestplan', 'testPlanTestDto', testPlanTestDto)
            const localVarPath = `/api/testplan/add/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testPlanTestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new TestPlan
         * @param {TestPlanDto} testPlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestPlan: async (testPlanDto: TestPlanDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testPlanDto' is not null or undefined
            assertParamExists('createTestPlan', 'testPlanDto', testPlanDto)
            const localVarPath = `/api/testplan/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testPlanDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Testplan
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTestPlan: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTestPlan', 'id', id)
            const localVarPath = `/api/testplan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Execute Testplan
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeTestPlan: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('executeTestPlan', 'id', id)
            const localVarPath = `/api/testplan/run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all TestPlanExecutions for TestPlan
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTestPlanExecutionsForTestPlan: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAllTestPlanExecutionsForTestPlan', 'id', id)
            const localVarPath = `/api/testplan/executions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Testplans
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTestPlans: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/testplan/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Testplans with Page and Searchparameter
         * @param {Pageable} pageable 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTestPlansWithPageAnSearch: async (pageable: Pageable, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageable' is not null or undefined
            assertParamExists('getAllTestPlansWithPageAnSearch', 'pageable', pageable)
            const localVarPath = `/api/testplan/all/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (pageable !== undefined) {
                localVarQueryParameter['pageable'] = pageable;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get latest TestPlanExecution
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestTestPlanExecution: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLatestTestPlanExecution', 'id', id)
            const localVarPath = `/api/testplan/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Percentage-Status of latest TestPlanExecution
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestTestPlanExecutionStatus: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLatestTestPlanExecutionStatus', 'id', id)
            const localVarPath = `/api/testplan/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetTestPlanExecution for TestPlanExecutionId
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestPlanExecutionForTestPlanExecutionId: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTestPlanExecutionForTestPlanExecutionId', 'id', id)
            const localVarPath = `/api/testplan/execution`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove Tests from Testplan
         * @param {number} id 
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTestsFromTestplan: async (id: number, requestBody: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeTestsFromTestplan', 'id', id)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('removeTestsFromTestplan', 'requestBody', requestBody)
            const localVarPath = `/api/testplan/remove/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing TestPlan
         * @param {TestPlanDto} testPlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTestPlan: async (testPlanDto: TestPlanDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testPlanDto' is not null or undefined
            assertParamExists('updateTestPlan', 'testPlanDto', testPlanDto)
            const localVarPath = `/api/testplan/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testPlanDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestPlanControllerApi - functional programming interface
 * @export
 */
export const TestPlanControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestPlanControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add Tests to Testplan
         * @param {number} id 
         * @param {Array<TestPlanTestDto>} testPlanTestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTestsToTestplan(id: number, testPlanTestDto: Array<TestPlanTestDto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTestsToTestplan(id, testPlanTestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new TestPlan
         * @param {TestPlanDto} testPlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTestPlan(testPlanDto: TestPlanDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTestPlan(testPlanDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete Testplan
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTestPlan(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTestPlan(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Execute Testplan
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeTestPlan(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeTestPlan(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all TestPlanExecutions for TestPlan
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTestPlanExecutionsForTestPlan(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TestPlanExecutionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTestPlanExecutionsForTestPlan(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all Testplans
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTestPlans(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TestPlanDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTestPlans(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all Testplans with Page and Searchparameter
         * @param {Pageable} pageable 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTestPlansWithPageAnSearch(pageable: Pageable, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageTestPlanDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTestPlansWithPageAnSearch(pageable, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get latest TestPlanExecution
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestTestPlanExecution(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestPlanExecutionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestTestPlanExecution(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Percentage-Status of latest TestPlanExecution
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestTestPlanExecutionStatus(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestTestPlanExecutionStatus(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary GetTestPlanExecution for TestPlanExecutionId
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestPlanExecutionForTestPlanExecutionId(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestPlanExecutionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestPlanExecutionForTestPlanExecutionId(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove Tests from Testplan
         * @param {number} id 
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeTestsFromTestplan(id: number, requestBody: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeTestsFromTestplan(id, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update an existing TestPlan
         * @param {TestPlanDto} testPlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTestPlan(testPlanDto: TestPlanDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTestPlan(testPlanDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestPlanControllerApi - factory interface
 * @export
 */
export const TestPlanControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestPlanControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Add Tests to Testplan
         * @param {number} id 
         * @param {Array<TestPlanTestDto>} testPlanTestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTestsToTestplan(id: number, testPlanTestDto: Array<TestPlanTestDto>, options?: any): AxiosPromise<object> {
            return localVarFp.addTestsToTestplan(id, testPlanTestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new TestPlan
         * @param {TestPlanDto} testPlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestPlan(testPlanDto: TestPlanDto, options?: any): AxiosPromise<object> {
            return localVarFp.createTestPlan(testPlanDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Testplan
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTestPlan(id: number, options?: any): AxiosPromise<string> {
            return localVarFp.deleteTestPlan(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Execute Testplan
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeTestPlan(id: number, options?: any): AxiosPromise<string> {
            return localVarFp.executeTestPlan(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all TestPlanExecutions for TestPlan
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTestPlanExecutionsForTestPlan(id: number, options?: any): AxiosPromise<Array<TestPlanExecutionDto>> {
            return localVarFp.getAllTestPlanExecutionsForTestPlan(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all Testplans
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTestPlans(options?: any): AxiosPromise<Array<TestPlanDto>> {
            return localVarFp.getAllTestPlans(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all Testplans with Page and Searchparameter
         * @param {Pageable} pageable 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTestPlansWithPageAnSearch(pageable: Pageable, search?: string, options?: any): AxiosPromise<PageTestPlanDto> {
            return localVarFp.getAllTestPlansWithPageAnSearch(pageable, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get latest TestPlanExecution
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestTestPlanExecution(id: number, options?: any): AxiosPromise<TestPlanExecutionDto> {
            return localVarFp.getLatestTestPlanExecution(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Percentage-Status of latest TestPlanExecution
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestTestPlanExecutionStatus(id: number, options?: any): AxiosPromise<number> {
            return localVarFp.getLatestTestPlanExecutionStatus(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GetTestPlanExecution for TestPlanExecutionId
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestPlanExecutionForTestPlanExecutionId(id: number, options?: any): AxiosPromise<TestPlanExecutionDto> {
            return localVarFp.getTestPlanExecutionForTestPlanExecutionId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove Tests from Testplan
         * @param {number} id 
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTestsFromTestplan(id: number, requestBody: Array<number>, options?: any): AxiosPromise<string> {
            return localVarFp.removeTestsFromTestplan(id, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing TestPlan
         * @param {TestPlanDto} testPlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTestPlan(testPlanDto: TestPlanDto, options?: any): AxiosPromise<object> {
            return localVarFp.updateTestPlan(testPlanDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestPlanControllerApi - object-oriented interface
 * @export
 * @class TestPlanControllerApi
 * @extends {BaseAPI}
 */
export class TestPlanControllerApi extends BaseAPI {
    /**
     * 
     * @summary Add Tests to Testplan
     * @param {number} id 
     * @param {Array<TestPlanTestDto>} testPlanTestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanControllerApi
     */
    public addTestsToTestplan(id: number, testPlanTestDto: Array<TestPlanTestDto>, options?: AxiosRequestConfig) {
        return TestPlanControllerApiFp(this.configuration).addTestsToTestplan(id, testPlanTestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new TestPlan
     * @param {TestPlanDto} testPlanDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanControllerApi
     */
    public createTestPlan(testPlanDto: TestPlanDto, options?: AxiosRequestConfig) {
        return TestPlanControllerApiFp(this.configuration).createTestPlan(testPlanDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Testplan
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanControllerApi
     */
    public deleteTestPlan(id: number, options?: AxiosRequestConfig) {
        return TestPlanControllerApiFp(this.configuration).deleteTestPlan(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Execute Testplan
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanControllerApi
     */
    public executeTestPlan(id: number, options?: AxiosRequestConfig) {
        return TestPlanControllerApiFp(this.configuration).executeTestPlan(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all TestPlanExecutions for TestPlan
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanControllerApi
     */
    public getAllTestPlanExecutionsForTestPlan(id: number, options?: AxiosRequestConfig) {
        return TestPlanControllerApiFp(this.configuration).getAllTestPlanExecutionsForTestPlan(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all Testplans
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanControllerApi
     */
    public getAllTestPlans(options?: AxiosRequestConfig) {
        return TestPlanControllerApiFp(this.configuration).getAllTestPlans(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all Testplans with Page and Searchparameter
     * @param {Pageable} pageable 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanControllerApi
     */
    public getAllTestPlansWithPageAnSearch(pageable: Pageable, search?: string, options?: AxiosRequestConfig) {
        return TestPlanControllerApiFp(this.configuration).getAllTestPlansWithPageAnSearch(pageable, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get latest TestPlanExecution
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanControllerApi
     */
    public getLatestTestPlanExecution(id: number, options?: AxiosRequestConfig) {
        return TestPlanControllerApiFp(this.configuration).getLatestTestPlanExecution(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Percentage-Status of latest TestPlanExecution
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanControllerApi
     */
    public getLatestTestPlanExecutionStatus(id: number, options?: AxiosRequestConfig) {
        return TestPlanControllerApiFp(this.configuration).getLatestTestPlanExecutionStatus(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GetTestPlanExecution for TestPlanExecutionId
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanControllerApi
     */
    public getTestPlanExecutionForTestPlanExecutionId(id: number, options?: AxiosRequestConfig) {
        return TestPlanControllerApiFp(this.configuration).getTestPlanExecutionForTestPlanExecutionId(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove Tests from Testplan
     * @param {number} id 
     * @param {Array<number>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanControllerApi
     */
    public removeTestsFromTestplan(id: number, requestBody: Array<number>, options?: AxiosRequestConfig) {
        return TestPlanControllerApiFp(this.configuration).removeTestsFromTestplan(id, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing TestPlan
     * @param {TestPlanDto} testPlanDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanControllerApi
     */
    public updateTestPlan(testPlanDto: TestPlanDto, options?: AxiosRequestConfig) {
        return TestPlanControllerApiFp(this.configuration).updateTestPlan(testPlanDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TestPlanEntityControllerApi - axios parameter creator
 * @export
 */
export const TestPlanEntityControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * delete-testplan
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourceTestplanDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteItemResourceTestplanDelete', 'id', id)
            const localVarPath = `/testPlans/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-testplan
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourceTestplanGet1: async (page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/testPlans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-testplan
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourceTestplanGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getItemResourceTestplanGet', 'id', id)
            const localVarPath = `/testPlans/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch-testplan
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourceTestplanPatch: async (id: string, persistentEntityResource: PersistentEntityResource, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchItemResourceTestplanPatch', 'id', id)
            // verify required parameter 'persistentEntityResource' is not null or undefined
            assertParamExists('patchItemResourceTestplanPatch', 'persistentEntityResource', persistentEntityResource)
            const localVarPath = `/testPlans/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(persistentEntityResource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create-testplan
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourceTestplanPost: async (persistentEntityResource: PersistentEntityResource, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'persistentEntityResource' is not null or undefined
            assertParamExists('postCollectionResourceTestplanPost', 'persistentEntityResource', persistentEntityResource)
            const localVarPath = `/testPlans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(persistentEntityResource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-testplan
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourceTestplanPut: async (id: string, persistentEntityResource: PersistentEntityResource, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putItemResourceTestplanPut', 'id', id)
            // verify required parameter 'persistentEntityResource' is not null or undefined
            assertParamExists('putItemResourceTestplanPut', 'persistentEntityResource', persistentEntityResource)
            const localVarPath = `/testPlans/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(persistentEntityResource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestPlanEntityControllerApi - functional programming interface
 * @export
 */
export const TestPlanEntityControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestPlanEntityControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * delete-testplan
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteItemResourceTestplanDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteItemResourceTestplanDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-testplan
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollectionResourceTestplanGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollectionResourceTestplanGet1(page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-testplan
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getItemResourceTestplanGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getItemResourceTestplanGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * patch-testplan
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchItemResourceTestplanPatch(id: string, persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchItemResourceTestplanPatch(id, persistentEntityResource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * create-testplan
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCollectionResourceTestplanPost(persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCollectionResourceTestplanPost(persistentEntityResource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-testplan
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putItemResourceTestplanPut(id: string, persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putItemResourceTestplanPut(id, persistentEntityResource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestPlanEntityControllerApi - factory interface
 * @export
 */
export const TestPlanEntityControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestPlanEntityControllerApiFp(configuration)
    return {
        /**
         * delete-testplan
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourceTestplanDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteItemResourceTestplanDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-testplan
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourceTestplanGet1(page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.getCollectionResourceTestplanGet1(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * get-testplan
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourceTestplanGet(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.getItemResourceTestplanGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * patch-testplan
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourceTestplanPatch(id: string, persistentEntityResource: PersistentEntityResource, options?: any): AxiosPromise<void> {
            return localVarFp.patchItemResourceTestplanPatch(id, persistentEntityResource, options).then((request) => request(axios, basePath));
        },
        /**
         * create-testplan
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourceTestplanPost(persistentEntityResource: PersistentEntityResource, options?: any): AxiosPromise<void> {
            return localVarFp.postCollectionResourceTestplanPost(persistentEntityResource, options).then((request) => request(axios, basePath));
        },
        /**
         * update-testplan
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourceTestplanPut(id: string, persistentEntityResource: PersistentEntityResource, options?: any): AxiosPromise<void> {
            return localVarFp.putItemResourceTestplanPut(id, persistentEntityResource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestPlanEntityControllerApi - object-oriented interface
 * @export
 * @class TestPlanEntityControllerApi
 * @extends {BaseAPI}
 */
export class TestPlanEntityControllerApi extends BaseAPI {
    /**
     * delete-testplan
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanEntityControllerApi
     */
    public deleteItemResourceTestplanDelete(id: string, options?: AxiosRequestConfig) {
        return TestPlanEntityControllerApiFp(this.configuration).deleteItemResourceTestplanDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-testplan
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanEntityControllerApi
     */
    public getCollectionResourceTestplanGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return TestPlanEntityControllerApiFp(this.configuration).getCollectionResourceTestplanGet1(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-testplan
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanEntityControllerApi
     */
    public getItemResourceTestplanGet(id: string, options?: AxiosRequestConfig) {
        return TestPlanEntityControllerApiFp(this.configuration).getItemResourceTestplanGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * patch-testplan
     * @param {string} id 
     * @param {PersistentEntityResource} persistentEntityResource 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanEntityControllerApi
     */
    public patchItemResourceTestplanPatch(id: string, persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig) {
        return TestPlanEntityControllerApiFp(this.configuration).patchItemResourceTestplanPatch(id, persistentEntityResource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create-testplan
     * @param {PersistentEntityResource} persistentEntityResource 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanEntityControllerApi
     */
    public postCollectionResourceTestplanPost(persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig) {
        return TestPlanEntityControllerApiFp(this.configuration).postCollectionResourceTestplanPost(persistentEntityResource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-testplan
     * @param {string} id 
     * @param {PersistentEntityResource} persistentEntityResource 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanEntityControllerApi
     */
    public putItemResourceTestplanPut(id: string, persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig) {
        return TestPlanEntityControllerApiFp(this.configuration).putItemResourceTestplanPut(id, persistentEntityResource, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TestPlanExecutionEntityControllerApi - axios parameter creator
 * @export
 */
export const TestPlanExecutionEntityControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * delete-testplanexecution
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourceTestplanexecutionDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteItemResourceTestplanexecutionDelete', 'id', id)
            const localVarPath = `/testPlanExecutions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-testplanexecution
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourceTestplanexecutionGet1: async (page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/testPlanExecutions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-testplanexecution
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourceTestplanexecutionGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getItemResourceTestplanexecutionGet', 'id', id)
            const localVarPath = `/testPlanExecutions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch-testplanexecution
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourceTestplanexecutionPatch: async (id: string, persistentEntityResource: PersistentEntityResource, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchItemResourceTestplanexecutionPatch', 'id', id)
            // verify required parameter 'persistentEntityResource' is not null or undefined
            assertParamExists('patchItemResourceTestplanexecutionPatch', 'persistentEntityResource', persistentEntityResource)
            const localVarPath = `/testPlanExecutions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(persistentEntityResource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create-testplanexecution
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourceTestplanexecutionPost: async (persistentEntityResource: PersistentEntityResource, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'persistentEntityResource' is not null or undefined
            assertParamExists('postCollectionResourceTestplanexecutionPost', 'persistentEntityResource', persistentEntityResource)
            const localVarPath = `/testPlanExecutions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(persistentEntityResource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-testplanexecution
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourceTestplanexecutionPut: async (id: string, persistentEntityResource: PersistentEntityResource, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putItemResourceTestplanexecutionPut', 'id', id)
            // verify required parameter 'persistentEntityResource' is not null or undefined
            assertParamExists('putItemResourceTestplanexecutionPut', 'persistentEntityResource', persistentEntityResource)
            const localVarPath = `/testPlanExecutions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(persistentEntityResource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestPlanExecutionEntityControllerApi - functional programming interface
 * @export
 */
export const TestPlanExecutionEntityControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestPlanExecutionEntityControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * delete-testplanexecution
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteItemResourceTestplanexecutionDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteItemResourceTestplanexecutionDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-testplanexecution
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollectionResourceTestplanexecutionGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollectionResourceTestplanexecutionGet1(page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-testplanexecution
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getItemResourceTestplanexecutionGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getItemResourceTestplanexecutionGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * patch-testplanexecution
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchItemResourceTestplanexecutionPatch(id: string, persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchItemResourceTestplanexecutionPatch(id, persistentEntityResource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * create-testplanexecution
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCollectionResourceTestplanexecutionPost(persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCollectionResourceTestplanexecutionPost(persistentEntityResource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-testplanexecution
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putItemResourceTestplanexecutionPut(id: string, persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putItemResourceTestplanexecutionPut(id, persistentEntityResource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestPlanExecutionEntityControllerApi - factory interface
 * @export
 */
export const TestPlanExecutionEntityControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestPlanExecutionEntityControllerApiFp(configuration)
    return {
        /**
         * delete-testplanexecution
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourceTestplanexecutionDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteItemResourceTestplanexecutionDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-testplanexecution
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourceTestplanexecutionGet1(page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.getCollectionResourceTestplanexecutionGet1(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * get-testplanexecution
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourceTestplanexecutionGet(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.getItemResourceTestplanexecutionGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * patch-testplanexecution
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourceTestplanexecutionPatch(id: string, persistentEntityResource: PersistentEntityResource, options?: any): AxiosPromise<void> {
            return localVarFp.patchItemResourceTestplanexecutionPatch(id, persistentEntityResource, options).then((request) => request(axios, basePath));
        },
        /**
         * create-testplanexecution
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourceTestplanexecutionPost(persistentEntityResource: PersistentEntityResource, options?: any): AxiosPromise<void> {
            return localVarFp.postCollectionResourceTestplanexecutionPost(persistentEntityResource, options).then((request) => request(axios, basePath));
        },
        /**
         * update-testplanexecution
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourceTestplanexecutionPut(id: string, persistentEntityResource: PersistentEntityResource, options?: any): AxiosPromise<void> {
            return localVarFp.putItemResourceTestplanexecutionPut(id, persistentEntityResource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestPlanExecutionEntityControllerApi - object-oriented interface
 * @export
 * @class TestPlanExecutionEntityControllerApi
 * @extends {BaseAPI}
 */
export class TestPlanExecutionEntityControllerApi extends BaseAPI {
    /**
     * delete-testplanexecution
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanExecutionEntityControllerApi
     */
    public deleteItemResourceTestplanexecutionDelete(id: string, options?: AxiosRequestConfig) {
        return TestPlanExecutionEntityControllerApiFp(this.configuration).deleteItemResourceTestplanexecutionDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-testplanexecution
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanExecutionEntityControllerApi
     */
    public getCollectionResourceTestplanexecutionGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return TestPlanExecutionEntityControllerApiFp(this.configuration).getCollectionResourceTestplanexecutionGet1(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-testplanexecution
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanExecutionEntityControllerApi
     */
    public getItemResourceTestplanexecutionGet(id: string, options?: AxiosRequestConfig) {
        return TestPlanExecutionEntityControllerApiFp(this.configuration).getItemResourceTestplanexecutionGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * patch-testplanexecution
     * @param {string} id 
     * @param {PersistentEntityResource} persistentEntityResource 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanExecutionEntityControllerApi
     */
    public patchItemResourceTestplanexecutionPatch(id: string, persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig) {
        return TestPlanExecutionEntityControllerApiFp(this.configuration).patchItemResourceTestplanexecutionPatch(id, persistentEntityResource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create-testplanexecution
     * @param {PersistentEntityResource} persistentEntityResource 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanExecutionEntityControllerApi
     */
    public postCollectionResourceTestplanexecutionPost(persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig) {
        return TestPlanExecutionEntityControllerApiFp(this.configuration).postCollectionResourceTestplanexecutionPost(persistentEntityResource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-testplanexecution
     * @param {string} id 
     * @param {PersistentEntityResource} persistentEntityResource 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanExecutionEntityControllerApi
     */
    public putItemResourceTestplanexecutionPut(id: string, persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig) {
        return TestPlanExecutionEntityControllerApiFp(this.configuration).putItemResourceTestplanexecutionPut(id, persistentEntityResource, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TestPlanExecutionPropertyReferenceControllerApi - axios parameter creator
 * @export
 */
export const TestPlanExecutionPropertyReferenceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * patch-testexecution-by-testplanexecution-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestplanexecutionPatch: async (id: string, collectionModelObject: CollectionModelObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPropertyReferenceTestplanexecutionPatch', 'id', id)
            // verify required parameter 'collectionModelObject' is not null or undefined
            assertParamExists('createPropertyReferenceTestplanexecutionPatch', 'collectionModelObject', collectionModelObject)
            const localVarPath = `/testPlanExecutions/{id}/testExecutions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionModelObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch-testplan-by-testplanexecution-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestplanexecutionPatch1: async (id: string, collectionModelObject: CollectionModelObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPropertyReferenceTestplanexecutionPatch1', 'id', id)
            // verify required parameter 'collectionModelObject' is not null or undefined
            assertParamExists('createPropertyReferenceTestplanexecutionPatch1', 'collectionModelObject', collectionModelObject)
            const localVarPath = `/testPlanExecutions/{id}/testPlan`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionModelObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-testexecution-by-testplanexecution-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestplanexecutionPut: async (id: string, collectionModelObject: CollectionModelObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPropertyReferenceTestplanexecutionPut', 'id', id)
            // verify required parameter 'collectionModelObject' is not null or undefined
            assertParamExists('createPropertyReferenceTestplanexecutionPut', 'collectionModelObject', collectionModelObject)
            const localVarPath = `/testPlanExecutions/{id}/testExecutions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionModelObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-testplan-by-testplanexecution-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestplanexecutionPut1: async (id: string, collectionModelObject: CollectionModelObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPropertyReferenceTestplanexecutionPut1', 'id', id)
            // verify required parameter 'collectionModelObject' is not null or undefined
            assertParamExists('createPropertyReferenceTestplanexecutionPut1', 'collectionModelObject', collectionModelObject)
            const localVarPath = `/testPlanExecutions/{id}/testPlan`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionModelObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete-testexecution-by-testplanexecution-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceIdTestplanexecutionDelete: async (id: string, propertyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePropertyReferenceIdTestplanexecutionDelete', 'id', id)
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('deletePropertyReferenceIdTestplanexecutionDelete', 'propertyId', propertyId)
            const localVarPath = `/testPlanExecutions/{id}/testExecutions/{propertyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete-testplan-by-testplanexecution-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceIdTestplanexecutionDelete1: async (id: string, propertyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePropertyReferenceIdTestplanexecutionDelete1', 'id', id)
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('deletePropertyReferenceIdTestplanexecutionDelete1', 'propertyId', propertyId)
            const localVarPath = `/testPlanExecutions/{id}/testPlan/{propertyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete-testexecution-by-testplanexecution-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceTestplanexecutionDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePropertyReferenceTestplanexecutionDelete', 'id', id)
            const localVarPath = `/testPlanExecutions/{id}/testExecutions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete-testplan-by-testplanexecution-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceTestplanexecutionDelete1: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePropertyReferenceTestplanexecutionDelete1', 'id', id)
            const localVarPath = `/testPlanExecutions/{id}/testPlan`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-testexecution-by-testplanexecution-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestplanexecutionGet: async (id: string, propertyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('followPropertyReferenceTestplanexecutionGet', 'id', id)
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('followPropertyReferenceTestplanexecutionGet', 'propertyId', propertyId)
            const localVarPath = `/testPlanExecutions/{id}/testExecutions/{propertyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-testexecution-by-testplanexecution-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestplanexecutionGet1: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('followPropertyReferenceTestplanexecutionGet1', 'id', id)
            const localVarPath = `/testPlanExecutions/{id}/testExecutions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-testplan-by-testplanexecution-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestplanexecutionGet2: async (id: string, propertyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('followPropertyReferenceTestplanexecutionGet2', 'id', id)
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('followPropertyReferenceTestplanexecutionGet2', 'propertyId', propertyId)
            const localVarPath = `/testPlanExecutions/{id}/testPlan/{propertyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-testplan-by-testplanexecution-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestplanexecutionGet21: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('followPropertyReferenceTestplanexecutionGet21', 'id', id)
            const localVarPath = `/testPlanExecutions/{id}/testPlan`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestPlanExecutionPropertyReferenceControllerApi - functional programming interface
 * @export
 */
export const TestPlanExecutionPropertyReferenceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestPlanExecutionPropertyReferenceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * patch-testexecution-by-testplanexecution-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReferenceTestplanexecutionPatch(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionModelTestExecution>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReferenceTestplanexecutionPatch(id, collectionModelObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * patch-testplan-by-testplanexecution-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReferenceTestplanexecutionPatch1(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReferenceTestplanexecutionPatch1(id, collectionModelObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-testexecution-by-testplanexecution-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReferenceTestplanexecutionPut(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionModelTestExecution>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReferenceTestplanexecutionPut(id, collectionModelObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-testplan-by-testplanexecution-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReferenceTestplanexecutionPut1(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReferenceTestplanexecutionPut1(id, collectionModelObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete-testexecution-by-testplanexecution-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePropertyReferenceIdTestplanexecutionDelete(id: string, propertyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePropertyReferenceIdTestplanexecutionDelete(id, propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete-testplan-by-testplanexecution-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePropertyReferenceIdTestplanexecutionDelete1(id: string, propertyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePropertyReferenceIdTestplanexecutionDelete1(id, propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete-testexecution-by-testplanexecution-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePropertyReferenceTestplanexecutionDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePropertyReferenceTestplanexecutionDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete-testplan-by-testplanexecution-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePropertyReferenceTestplanexecutionDelete1(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePropertyReferenceTestplanexecutionDelete1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-testexecution-by-testplanexecution-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followPropertyReferenceTestplanexecutionGet(id: string, propertyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionModelTestExecution>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followPropertyReferenceTestplanexecutionGet(id, propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-testexecution-by-testplanexecution-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followPropertyReferenceTestplanexecutionGet1(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionModelTestExecution>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followPropertyReferenceTestplanexecutionGet1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-testplan-by-testplanexecution-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followPropertyReferenceTestplanexecutionGet2(id: string, propertyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followPropertyReferenceTestplanexecutionGet2(id, propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-testplan-by-testplanexecution-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followPropertyReferenceTestplanexecutionGet21(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followPropertyReferenceTestplanexecutionGet21(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestPlanExecutionPropertyReferenceControllerApi - factory interface
 * @export
 */
export const TestPlanExecutionPropertyReferenceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestPlanExecutionPropertyReferenceControllerApiFp(configuration)
    return {
        /**
         * patch-testexecution-by-testplanexecution-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestplanexecutionPatch(id: string, collectionModelObject: CollectionModelObject, options?: any): AxiosPromise<CollectionModelTestExecution> {
            return localVarFp.createPropertyReferenceTestplanexecutionPatch(id, collectionModelObject, options).then((request) => request(axios, basePath));
        },
        /**
         * patch-testplan-by-testplanexecution-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestplanexecutionPatch1(id: string, collectionModelObject: CollectionModelObject, options?: any): AxiosPromise<void> {
            return localVarFp.createPropertyReferenceTestplanexecutionPatch1(id, collectionModelObject, options).then((request) => request(axios, basePath));
        },
        /**
         * update-testexecution-by-testplanexecution-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestplanexecutionPut(id: string, collectionModelObject: CollectionModelObject, options?: any): AxiosPromise<CollectionModelTestExecution> {
            return localVarFp.createPropertyReferenceTestplanexecutionPut(id, collectionModelObject, options).then((request) => request(axios, basePath));
        },
        /**
         * update-testplan-by-testplanexecution-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestplanexecutionPut1(id: string, collectionModelObject: CollectionModelObject, options?: any): AxiosPromise<void> {
            return localVarFp.createPropertyReferenceTestplanexecutionPut1(id, collectionModelObject, options).then((request) => request(axios, basePath));
        },
        /**
         * delete-testexecution-by-testplanexecution-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceIdTestplanexecutionDelete(id: string, propertyId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePropertyReferenceIdTestplanexecutionDelete(id, propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * delete-testplan-by-testplanexecution-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceIdTestplanexecutionDelete1(id: string, propertyId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePropertyReferenceIdTestplanexecutionDelete1(id, propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * delete-testexecution-by-testplanexecution-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceTestplanexecutionDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePropertyReferenceTestplanexecutionDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * delete-testplan-by-testplanexecution-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceTestplanexecutionDelete1(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePropertyReferenceTestplanexecutionDelete1(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-testexecution-by-testplanexecution-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestplanexecutionGet(id: string, propertyId: string, options?: any): AxiosPromise<CollectionModelTestExecution> {
            return localVarFp.followPropertyReferenceTestplanexecutionGet(id, propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * get-testexecution-by-testplanexecution-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestplanexecutionGet1(id: string, options?: any): AxiosPromise<CollectionModelTestExecution> {
            return localVarFp.followPropertyReferenceTestplanexecutionGet1(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-testplan-by-testplanexecution-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestplanexecutionGet2(id: string, propertyId: string, options?: any): AxiosPromise<void> {
            return localVarFp.followPropertyReferenceTestplanexecutionGet2(id, propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * get-testplan-by-testplanexecution-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestplanexecutionGet21(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.followPropertyReferenceTestplanexecutionGet21(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestPlanExecutionPropertyReferenceControllerApi - object-oriented interface
 * @export
 * @class TestPlanExecutionPropertyReferenceControllerApi
 * @extends {BaseAPI}
 */
export class TestPlanExecutionPropertyReferenceControllerApi extends BaseAPI {
    /**
     * patch-testexecution-by-testplanexecution-Id
     * @param {string} id 
     * @param {CollectionModelObject} collectionModelObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanExecutionPropertyReferenceControllerApi
     */
    public createPropertyReferenceTestplanexecutionPatch(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig) {
        return TestPlanExecutionPropertyReferenceControllerApiFp(this.configuration).createPropertyReferenceTestplanexecutionPatch(id, collectionModelObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * patch-testplan-by-testplanexecution-Id
     * @param {string} id 
     * @param {CollectionModelObject} collectionModelObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanExecutionPropertyReferenceControllerApi
     */
    public createPropertyReferenceTestplanexecutionPatch1(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig) {
        return TestPlanExecutionPropertyReferenceControllerApiFp(this.configuration).createPropertyReferenceTestplanexecutionPatch1(id, collectionModelObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-testexecution-by-testplanexecution-Id
     * @param {string} id 
     * @param {CollectionModelObject} collectionModelObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanExecutionPropertyReferenceControllerApi
     */
    public createPropertyReferenceTestplanexecutionPut(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig) {
        return TestPlanExecutionPropertyReferenceControllerApiFp(this.configuration).createPropertyReferenceTestplanexecutionPut(id, collectionModelObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-testplan-by-testplanexecution-Id
     * @param {string} id 
     * @param {CollectionModelObject} collectionModelObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanExecutionPropertyReferenceControllerApi
     */
    public createPropertyReferenceTestplanexecutionPut1(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig) {
        return TestPlanExecutionPropertyReferenceControllerApiFp(this.configuration).createPropertyReferenceTestplanexecutionPut1(id, collectionModelObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete-testexecution-by-testplanexecution-Id
     * @param {string} id 
     * @param {string} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanExecutionPropertyReferenceControllerApi
     */
    public deletePropertyReferenceIdTestplanexecutionDelete(id: string, propertyId: string, options?: AxiosRequestConfig) {
        return TestPlanExecutionPropertyReferenceControllerApiFp(this.configuration).deletePropertyReferenceIdTestplanexecutionDelete(id, propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete-testplan-by-testplanexecution-Id
     * @param {string} id 
     * @param {string} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanExecutionPropertyReferenceControllerApi
     */
    public deletePropertyReferenceIdTestplanexecutionDelete1(id: string, propertyId: string, options?: AxiosRequestConfig) {
        return TestPlanExecutionPropertyReferenceControllerApiFp(this.configuration).deletePropertyReferenceIdTestplanexecutionDelete1(id, propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete-testexecution-by-testplanexecution-Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanExecutionPropertyReferenceControllerApi
     */
    public deletePropertyReferenceTestplanexecutionDelete(id: string, options?: AxiosRequestConfig) {
        return TestPlanExecutionPropertyReferenceControllerApiFp(this.configuration).deletePropertyReferenceTestplanexecutionDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete-testplan-by-testplanexecution-Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanExecutionPropertyReferenceControllerApi
     */
    public deletePropertyReferenceTestplanexecutionDelete1(id: string, options?: AxiosRequestConfig) {
        return TestPlanExecutionPropertyReferenceControllerApiFp(this.configuration).deletePropertyReferenceTestplanexecutionDelete1(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-testexecution-by-testplanexecution-Id
     * @param {string} id 
     * @param {string} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanExecutionPropertyReferenceControllerApi
     */
    public followPropertyReferenceTestplanexecutionGet(id: string, propertyId: string, options?: AxiosRequestConfig) {
        return TestPlanExecutionPropertyReferenceControllerApiFp(this.configuration).followPropertyReferenceTestplanexecutionGet(id, propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-testexecution-by-testplanexecution-Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanExecutionPropertyReferenceControllerApi
     */
    public followPropertyReferenceTestplanexecutionGet1(id: string, options?: AxiosRequestConfig) {
        return TestPlanExecutionPropertyReferenceControllerApiFp(this.configuration).followPropertyReferenceTestplanexecutionGet1(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-testplan-by-testplanexecution-Id
     * @param {string} id 
     * @param {string} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanExecutionPropertyReferenceControllerApi
     */
    public followPropertyReferenceTestplanexecutionGet2(id: string, propertyId: string, options?: AxiosRequestConfig) {
        return TestPlanExecutionPropertyReferenceControllerApiFp(this.configuration).followPropertyReferenceTestplanexecutionGet2(id, propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-testplan-by-testplanexecution-Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanExecutionPropertyReferenceControllerApi
     */
    public followPropertyReferenceTestplanexecutionGet21(id: string, options?: AxiosRequestConfig) {
        return TestPlanExecutionPropertyReferenceControllerApiFp(this.configuration).followPropertyReferenceTestplanexecutionGet21(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TestPlanExecutionSearchControllerApi - axios parameter creator
 * @export
 */
export const TestPlanExecutionSearchControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [testPlan] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestplanexecutionGet: async (testPlan?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/testPlanExecutions/search/findAllByTestPlanOrderByExecutionTimeDesc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (testPlan !== undefined) {
                localVarQueryParameter['testPlan'] = testPlan;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [testPlan] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestplanexecutionGet1: async (testPlan?: string, page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/testPlanExecutions/search/findByTestPlanOrderByExecutionTimeDesc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (testPlan !== undefined) {
                localVarQueryParameter['testPlan'] = testPlan;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [targetTs] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestplanexecutionGet2: async (targetTs?: string, page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/testPlanExecutions/search/findTestFinishedTestExecutionsAfterTs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (targetTs !== undefined) {
                localVarQueryParameter['targetTs'] = (targetTs as any instanceof Date) ?
                    (targetTs as any).toISOString() :
                    targetTs;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestPlanExecutionSearchControllerApi - functional programming interface
 * @export
 */
export const TestPlanExecutionSearchControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestPlanExecutionSearchControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [testPlan] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSearchTestplanexecutionGet(testPlan?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSearchTestplanexecutionGet(testPlan, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [testPlan] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSearchTestplanexecutionGet1(testPlan?: string, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSearchTestplanexecutionGet1(testPlan, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [targetTs] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSearchTestplanexecutionGet2(targetTs?: string, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSearchTestplanexecutionGet2(targetTs, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestPlanExecutionSearchControllerApi - factory interface
 * @export
 */
export const TestPlanExecutionSearchControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestPlanExecutionSearchControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [testPlan] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestplanexecutionGet(testPlan?: string, options?: any): AxiosPromise<void> {
            return localVarFp.executeSearchTestplanexecutionGet(testPlan, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [testPlan] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestplanexecutionGet1(testPlan?: string, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.executeSearchTestplanexecutionGet1(testPlan, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [targetTs] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestplanexecutionGet2(targetTs?: string, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.executeSearchTestplanexecutionGet2(targetTs, page, size, sort, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestPlanExecutionSearchControllerApi - object-oriented interface
 * @export
 * @class TestPlanExecutionSearchControllerApi
 * @extends {BaseAPI}
 */
export class TestPlanExecutionSearchControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} [testPlan] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanExecutionSearchControllerApi
     */
    public executeSearchTestplanexecutionGet(testPlan?: string, options?: AxiosRequestConfig) {
        return TestPlanExecutionSearchControllerApiFp(this.configuration).executeSearchTestplanexecutionGet(testPlan, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [testPlan] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanExecutionSearchControllerApi
     */
    public executeSearchTestplanexecutionGet1(testPlan?: string, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return TestPlanExecutionSearchControllerApiFp(this.configuration).executeSearchTestplanexecutionGet1(testPlan, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [targetTs] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanExecutionSearchControllerApi
     */
    public executeSearchTestplanexecutionGet2(targetTs?: string, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return TestPlanExecutionSearchControllerApiFp(this.configuration).executeSearchTestplanexecutionGet2(targetTs, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TestPlanPropertyReferenceControllerApi - axios parameter creator
 * @export
 */
export const TestPlanPropertyReferenceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * patch-testplantest-by-testplan-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestplanPatch: async (id: string, collectionModelObject: CollectionModelObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPropertyReferenceTestplanPatch', 'id', id)
            // verify required parameter 'collectionModelObject' is not null or undefined
            assertParamExists('createPropertyReferenceTestplanPatch', 'collectionModelObject', collectionModelObject)
            const localVarPath = `/testPlans/{id}/testPlanTests`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionModelObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-testplantest-by-testplan-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestplanPut: async (id: string, collectionModelObject: CollectionModelObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPropertyReferenceTestplanPut', 'id', id)
            // verify required parameter 'collectionModelObject' is not null or undefined
            assertParamExists('createPropertyReferenceTestplanPut', 'collectionModelObject', collectionModelObject)
            const localVarPath = `/testPlans/{id}/testPlanTests`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionModelObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete-testplantest-by-testplan-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceIdTestplanDelete: async (id: string, propertyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePropertyReferenceIdTestplanDelete', 'id', id)
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('deletePropertyReferenceIdTestplanDelete', 'propertyId', propertyId)
            const localVarPath = `/testPlans/{id}/testPlanTests/{propertyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete-testplantest-by-testplan-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceTestplanDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePropertyReferenceTestplanDelete', 'id', id)
            const localVarPath = `/testPlans/{id}/testPlanTests`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-testplantest-by-testplan-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestplanGet: async (id: string, propertyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('followPropertyReferenceTestplanGet', 'id', id)
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('followPropertyReferenceTestplanGet', 'propertyId', propertyId)
            const localVarPath = `/testPlans/{id}/testPlanTests/{propertyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-testplantest-by-testplan-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestplanGet1: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('followPropertyReferenceTestplanGet1', 'id', id)
            const localVarPath = `/testPlans/{id}/testPlanTests`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestPlanPropertyReferenceControllerApi - functional programming interface
 * @export
 */
export const TestPlanPropertyReferenceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestPlanPropertyReferenceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * patch-testplantest-by-testplan-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReferenceTestplanPatch(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReferenceTestplanPatch(id, collectionModelObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-testplantest-by-testplan-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReferenceTestplanPut(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReferenceTestplanPut(id, collectionModelObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete-testplantest-by-testplan-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePropertyReferenceIdTestplanDelete(id: string, propertyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePropertyReferenceIdTestplanDelete(id, propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete-testplantest-by-testplan-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePropertyReferenceTestplanDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePropertyReferenceTestplanDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-testplantest-by-testplan-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followPropertyReferenceTestplanGet(id: string, propertyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followPropertyReferenceTestplanGet(id, propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-testplantest-by-testplan-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followPropertyReferenceTestplanGet1(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followPropertyReferenceTestplanGet1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestPlanPropertyReferenceControllerApi - factory interface
 * @export
 */
export const TestPlanPropertyReferenceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestPlanPropertyReferenceControllerApiFp(configuration)
    return {
        /**
         * patch-testplantest-by-testplan-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestplanPatch(id: string, collectionModelObject: CollectionModelObject, options?: any): AxiosPromise<void> {
            return localVarFp.createPropertyReferenceTestplanPatch(id, collectionModelObject, options).then((request) => request(axios, basePath));
        },
        /**
         * update-testplantest-by-testplan-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestplanPut(id: string, collectionModelObject: CollectionModelObject, options?: any): AxiosPromise<void> {
            return localVarFp.createPropertyReferenceTestplanPut(id, collectionModelObject, options).then((request) => request(axios, basePath));
        },
        /**
         * delete-testplantest-by-testplan-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceIdTestplanDelete(id: string, propertyId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePropertyReferenceIdTestplanDelete(id, propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * delete-testplantest-by-testplan-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceTestplanDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePropertyReferenceTestplanDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-testplantest-by-testplan-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestplanGet(id: string, propertyId: string, options?: any): AxiosPromise<void> {
            return localVarFp.followPropertyReferenceTestplanGet(id, propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * get-testplantest-by-testplan-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestplanGet1(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.followPropertyReferenceTestplanGet1(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestPlanPropertyReferenceControllerApi - object-oriented interface
 * @export
 * @class TestPlanPropertyReferenceControllerApi
 * @extends {BaseAPI}
 */
export class TestPlanPropertyReferenceControllerApi extends BaseAPI {
    /**
     * patch-testplantest-by-testplan-Id
     * @param {string} id 
     * @param {CollectionModelObject} collectionModelObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanPropertyReferenceControllerApi
     */
    public createPropertyReferenceTestplanPatch(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig) {
        return TestPlanPropertyReferenceControllerApiFp(this.configuration).createPropertyReferenceTestplanPatch(id, collectionModelObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-testplantest-by-testplan-Id
     * @param {string} id 
     * @param {CollectionModelObject} collectionModelObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanPropertyReferenceControllerApi
     */
    public createPropertyReferenceTestplanPut(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig) {
        return TestPlanPropertyReferenceControllerApiFp(this.configuration).createPropertyReferenceTestplanPut(id, collectionModelObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete-testplantest-by-testplan-Id
     * @param {string} id 
     * @param {string} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanPropertyReferenceControllerApi
     */
    public deletePropertyReferenceIdTestplanDelete(id: string, propertyId: string, options?: AxiosRequestConfig) {
        return TestPlanPropertyReferenceControllerApiFp(this.configuration).deletePropertyReferenceIdTestplanDelete(id, propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete-testplantest-by-testplan-Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanPropertyReferenceControllerApi
     */
    public deletePropertyReferenceTestplanDelete(id: string, options?: AxiosRequestConfig) {
        return TestPlanPropertyReferenceControllerApiFp(this.configuration).deletePropertyReferenceTestplanDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-testplantest-by-testplan-Id
     * @param {string} id 
     * @param {string} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanPropertyReferenceControllerApi
     */
    public followPropertyReferenceTestplanGet(id: string, propertyId: string, options?: AxiosRequestConfig) {
        return TestPlanPropertyReferenceControllerApiFp(this.configuration).followPropertyReferenceTestplanGet(id, propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-testplantest-by-testplan-Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanPropertyReferenceControllerApi
     */
    public followPropertyReferenceTestplanGet1(id: string, options?: AxiosRequestConfig) {
        return TestPlanPropertyReferenceControllerApiFp(this.configuration).followPropertyReferenceTestplanGet1(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TestPlanSchedulerControllerApi - axios parameter creator
 * @export
 */
export const TestPlanSchedulerControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScheduledTask: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteScheduledTask', 'id', id)
            const localVarPath = `/api/testplan/scheduler/schedule/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Pageable} pageable 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledTasks: async (pageable: Pageable, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageable' is not null or undefined
            assertParamExists('getScheduledTasks', 'pageable', pageable)
            const localVarPath = `/api/testplan/scheduler/schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageable !== undefined) {
                localVarQueryParameter['pageable'] = pageable;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} testPlanId 
         * @param {string} cronExpression 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleTask: async (testPlanId: number, cronExpression: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testPlanId' is not null or undefined
            assertParamExists('scheduleTask', 'testPlanId', testPlanId)
            // verify required parameter 'cronExpression' is not null or undefined
            assertParamExists('scheduleTask', 'cronExpression', cronExpression)
            const localVarPath = `/api/testplan/scheduler/schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (testPlanId !== undefined) {
                localVarQueryParameter['testPlanId'] = testPlanId;
            }

            if (cronExpression !== undefined) {
                localVarQueryParameter['cronExpression'] = cronExpression;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestPlanSchedulerControllerApi - functional programming interface
 * @export
 */
export const TestPlanSchedulerControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestPlanSchedulerControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteScheduledTask(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteScheduledTask(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Pageable} pageable 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScheduledTasks(pageable: Pageable, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageTestPlanTaskResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScheduledTasks(pageable, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} testPlanId 
         * @param {string} cronExpression 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduleTask(testPlanId: number, cronExpression: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduledTestPlanTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduleTask(testPlanId, cronExpression, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestPlanSchedulerControllerApi - factory interface
 * @export
 */
export const TestPlanSchedulerControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestPlanSchedulerControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScheduledTask(id: number, options?: any): AxiosPromise<string> {
            return localVarFp.deleteScheduledTask(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Pageable} pageable 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduledTasks(pageable: Pageable, options?: any): AxiosPromise<PageTestPlanTaskResponse> {
            return localVarFp.getScheduledTasks(pageable, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} testPlanId 
         * @param {string} cronExpression 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleTask(testPlanId: number, cronExpression: string, options?: any): AxiosPromise<ScheduledTestPlanTask> {
            return localVarFp.scheduleTask(testPlanId, cronExpression, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestPlanSchedulerControllerApi - object-oriented interface
 * @export
 * @class TestPlanSchedulerControllerApi
 * @extends {BaseAPI}
 */
export class TestPlanSchedulerControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanSchedulerControllerApi
     */
    public deleteScheduledTask(id: number, options?: AxiosRequestConfig) {
        return TestPlanSchedulerControllerApiFp(this.configuration).deleteScheduledTask(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Pageable} pageable 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanSchedulerControllerApi
     */
    public getScheduledTasks(pageable: Pageable, options?: AxiosRequestConfig) {
        return TestPlanSchedulerControllerApiFp(this.configuration).getScheduledTasks(pageable, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} testPlanId 
     * @param {string} cronExpression 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanSchedulerControllerApi
     */
    public scheduleTask(testPlanId: number, cronExpression: string, options?: AxiosRequestConfig) {
        return TestPlanSchedulerControllerApiFp(this.configuration).scheduleTask(testPlanId, cronExpression, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TestPlanSearchControllerApi - axios parameter creator
 * @export
 */
export const TestPlanSearchControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestplanGet: async (search?: string, page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/testPlans/search/findBySearchCriteria`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [testId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestplanGet1: async (testId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/testPlans/search/findByTestId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (testId !== undefined) {
                localVarQueryParameter['testId'] = testId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestPlanSearchControllerApi - functional programming interface
 * @export
 */
export const TestPlanSearchControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestPlanSearchControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSearchTestplanGet(search?: string, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSearchTestplanGet(search, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [testId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSearchTestplanGet1(testId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSearchTestplanGet1(testId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestPlanSearchControllerApi - factory interface
 * @export
 */
export const TestPlanSearchControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestPlanSearchControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [search] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestplanGet(search?: string, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.executeSearchTestplanGet(search, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [testId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestplanGet1(testId?: number, options?: any): AxiosPromise<void> {
            return localVarFp.executeSearchTestplanGet1(testId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestPlanSearchControllerApi - object-oriented interface
 * @export
 * @class TestPlanSearchControllerApi
 * @extends {BaseAPI}
 */
export class TestPlanSearchControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} [search] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanSearchControllerApi
     */
    public executeSearchTestplanGet(search?: string, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return TestPlanSearchControllerApiFp(this.configuration).executeSearchTestplanGet(search, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [testId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanSearchControllerApi
     */
    public executeSearchTestplanGet1(testId?: number, options?: AxiosRequestConfig) {
        return TestPlanSearchControllerApiFp(this.configuration).executeSearchTestplanGet1(testId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TestPlanTestEntityControllerApi - axios parameter creator
 * @export
 */
export const TestPlanTestEntityControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * delete-testplantest
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourceTestplantestDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteItemResourceTestplantestDelete', 'id', id)
            const localVarPath = `/testPlanTests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-testplantest
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourceTestplantestGet1: async (page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/testPlanTests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-testplantest
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourceTestplantestGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getItemResourceTestplantestGet', 'id', id)
            const localVarPath = `/testPlanTests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch-testplantest
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourceTestplantestPatch: async (id: string, persistentEntityResource: PersistentEntityResource, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchItemResourceTestplantestPatch', 'id', id)
            // verify required parameter 'persistentEntityResource' is not null or undefined
            assertParamExists('patchItemResourceTestplantestPatch', 'persistentEntityResource', persistentEntityResource)
            const localVarPath = `/testPlanTests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(persistentEntityResource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create-testplantest
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourceTestplantestPost: async (persistentEntityResource: PersistentEntityResource, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'persistentEntityResource' is not null or undefined
            assertParamExists('postCollectionResourceTestplantestPost', 'persistentEntityResource', persistentEntityResource)
            const localVarPath = `/testPlanTests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(persistentEntityResource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-testplantest
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourceTestplantestPut: async (id: string, persistentEntityResource: PersistentEntityResource, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putItemResourceTestplantestPut', 'id', id)
            // verify required parameter 'persistentEntityResource' is not null or undefined
            assertParamExists('putItemResourceTestplantestPut', 'persistentEntityResource', persistentEntityResource)
            const localVarPath = `/testPlanTests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(persistentEntityResource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestPlanTestEntityControllerApi - functional programming interface
 * @export
 */
export const TestPlanTestEntityControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestPlanTestEntityControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * delete-testplantest
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteItemResourceTestplantestDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteItemResourceTestplantestDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-testplantest
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollectionResourceTestplantestGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollectionResourceTestplantestGet1(page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-testplantest
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getItemResourceTestplantestGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getItemResourceTestplantestGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * patch-testplantest
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchItemResourceTestplantestPatch(id: string, persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchItemResourceTestplantestPatch(id, persistentEntityResource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * create-testplantest
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCollectionResourceTestplantestPost(persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCollectionResourceTestplantestPost(persistentEntityResource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-testplantest
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putItemResourceTestplantestPut(id: string, persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putItemResourceTestplantestPut(id, persistentEntityResource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestPlanTestEntityControllerApi - factory interface
 * @export
 */
export const TestPlanTestEntityControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestPlanTestEntityControllerApiFp(configuration)
    return {
        /**
         * delete-testplantest
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourceTestplantestDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteItemResourceTestplantestDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-testplantest
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourceTestplantestGet1(page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.getCollectionResourceTestplantestGet1(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * get-testplantest
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourceTestplantestGet(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.getItemResourceTestplantestGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * patch-testplantest
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourceTestplantestPatch(id: string, persistentEntityResource: PersistentEntityResource, options?: any): AxiosPromise<void> {
            return localVarFp.patchItemResourceTestplantestPatch(id, persistentEntityResource, options).then((request) => request(axios, basePath));
        },
        /**
         * create-testplantest
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourceTestplantestPost(persistentEntityResource: PersistentEntityResource, options?: any): AxiosPromise<void> {
            return localVarFp.postCollectionResourceTestplantestPost(persistentEntityResource, options).then((request) => request(axios, basePath));
        },
        /**
         * update-testplantest
         * @param {string} id 
         * @param {PersistentEntityResource} persistentEntityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourceTestplantestPut(id: string, persistentEntityResource: PersistentEntityResource, options?: any): AxiosPromise<void> {
            return localVarFp.putItemResourceTestplantestPut(id, persistentEntityResource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestPlanTestEntityControllerApi - object-oriented interface
 * @export
 * @class TestPlanTestEntityControllerApi
 * @extends {BaseAPI}
 */
export class TestPlanTestEntityControllerApi extends BaseAPI {
    /**
     * delete-testplantest
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanTestEntityControllerApi
     */
    public deleteItemResourceTestplantestDelete(id: string, options?: AxiosRequestConfig) {
        return TestPlanTestEntityControllerApiFp(this.configuration).deleteItemResourceTestplantestDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-testplantest
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanTestEntityControllerApi
     */
    public getCollectionResourceTestplantestGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return TestPlanTestEntityControllerApiFp(this.configuration).getCollectionResourceTestplantestGet1(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-testplantest
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanTestEntityControllerApi
     */
    public getItemResourceTestplantestGet(id: string, options?: AxiosRequestConfig) {
        return TestPlanTestEntityControllerApiFp(this.configuration).getItemResourceTestplantestGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * patch-testplantest
     * @param {string} id 
     * @param {PersistentEntityResource} persistentEntityResource 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanTestEntityControllerApi
     */
    public patchItemResourceTestplantestPatch(id: string, persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig) {
        return TestPlanTestEntityControllerApiFp(this.configuration).patchItemResourceTestplantestPatch(id, persistentEntityResource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create-testplantest
     * @param {PersistentEntityResource} persistentEntityResource 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanTestEntityControllerApi
     */
    public postCollectionResourceTestplantestPost(persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig) {
        return TestPlanTestEntityControllerApiFp(this.configuration).postCollectionResourceTestplantestPost(persistentEntityResource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-testplantest
     * @param {string} id 
     * @param {PersistentEntityResource} persistentEntityResource 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanTestEntityControllerApi
     */
    public putItemResourceTestplantestPut(id: string, persistentEntityResource: PersistentEntityResource, options?: AxiosRequestConfig) {
        return TestPlanTestEntityControllerApiFp(this.configuration).putItemResourceTestplantestPut(id, persistentEntityResource, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TestPlanTestPropertyReferenceControllerApi - axios parameter creator
 * @export
 */
export const TestPlanTestPropertyReferenceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * patch-test-by-testplantest-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestplantestPatch: async (id: string, collectionModelObject: CollectionModelObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPropertyReferenceTestplantestPatch', 'id', id)
            // verify required parameter 'collectionModelObject' is not null or undefined
            assertParamExists('createPropertyReferenceTestplantestPatch', 'collectionModelObject', collectionModelObject)
            const localVarPath = `/testPlanTests/{id}/test`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionModelObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch-testplan-by-testplantest-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestplantestPatch1: async (id: string, collectionModelObject: CollectionModelObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPropertyReferenceTestplantestPatch1', 'id', id)
            // verify required parameter 'collectionModelObject' is not null or undefined
            assertParamExists('createPropertyReferenceTestplantestPatch1', 'collectionModelObject', collectionModelObject)
            const localVarPath = `/testPlanTests/{id}/testPlan`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionModelObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-test-by-testplantest-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestplantestPut: async (id: string, collectionModelObject: CollectionModelObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPropertyReferenceTestplantestPut', 'id', id)
            // verify required parameter 'collectionModelObject' is not null or undefined
            assertParamExists('createPropertyReferenceTestplantestPut', 'collectionModelObject', collectionModelObject)
            const localVarPath = `/testPlanTests/{id}/test`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionModelObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-testplan-by-testplantest-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestplantestPut1: async (id: string, collectionModelObject: CollectionModelObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPropertyReferenceTestplantestPut1', 'id', id)
            // verify required parameter 'collectionModelObject' is not null or undefined
            assertParamExists('createPropertyReferenceTestplantestPut1', 'collectionModelObject', collectionModelObject)
            const localVarPath = `/testPlanTests/{id}/testPlan`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionModelObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete-test-by-testplantest-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceIdTestplantestDelete: async (id: string, propertyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePropertyReferenceIdTestplantestDelete', 'id', id)
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('deletePropertyReferenceIdTestplantestDelete', 'propertyId', propertyId)
            const localVarPath = `/testPlanTests/{id}/test/{propertyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete-testplan-by-testplantest-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceIdTestplantestDelete1: async (id: string, propertyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePropertyReferenceIdTestplantestDelete1', 'id', id)
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('deletePropertyReferenceIdTestplantestDelete1', 'propertyId', propertyId)
            const localVarPath = `/testPlanTests/{id}/testPlan/{propertyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete-test-by-testplantest-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceTestplantestDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePropertyReferenceTestplantestDelete', 'id', id)
            const localVarPath = `/testPlanTests/{id}/test`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete-testplan-by-testplantest-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceTestplantestDelete1: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePropertyReferenceTestplantestDelete1', 'id', id)
            const localVarPath = `/testPlanTests/{id}/testPlan`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-test-by-testplantest-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestplantestGet: async (id: string, propertyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('followPropertyReferenceTestplantestGet', 'id', id)
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('followPropertyReferenceTestplantestGet', 'propertyId', propertyId)
            const localVarPath = `/testPlanTests/{id}/test/{propertyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-test-by-testplantest-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestplantestGet1: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('followPropertyReferenceTestplantestGet1', 'id', id)
            const localVarPath = `/testPlanTests/{id}/test`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-testplan-by-testplantest-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestplantestGet2: async (id: string, propertyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('followPropertyReferenceTestplantestGet2', 'id', id)
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('followPropertyReferenceTestplantestGet2', 'propertyId', propertyId)
            const localVarPath = `/testPlanTests/{id}/testPlan/{propertyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-testplan-by-testplantest-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestplantestGet21: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('followPropertyReferenceTestplantestGet21', 'id', id)
            const localVarPath = `/testPlanTests/{id}/testPlan`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestPlanTestPropertyReferenceControllerApi - functional programming interface
 * @export
 */
export const TestPlanTestPropertyReferenceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestPlanTestPropertyReferenceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * patch-test-by-testplantest-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReferenceTestplantestPatch(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReferenceTestplantestPatch(id, collectionModelObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * patch-testplan-by-testplantest-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReferenceTestplantestPatch1(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReferenceTestplantestPatch1(id, collectionModelObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-test-by-testplantest-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReferenceTestplantestPut(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReferenceTestplantestPut(id, collectionModelObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-testplan-by-testplantest-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReferenceTestplantestPut1(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReferenceTestplantestPut1(id, collectionModelObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete-test-by-testplantest-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePropertyReferenceIdTestplantestDelete(id: string, propertyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePropertyReferenceIdTestplantestDelete(id, propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete-testplan-by-testplantest-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePropertyReferenceIdTestplantestDelete1(id: string, propertyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePropertyReferenceIdTestplantestDelete1(id, propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete-test-by-testplantest-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePropertyReferenceTestplantestDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePropertyReferenceTestplantestDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete-testplan-by-testplantest-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePropertyReferenceTestplantestDelete1(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePropertyReferenceTestplantestDelete1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-test-by-testplantest-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followPropertyReferenceTestplantestGet(id: string, propertyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followPropertyReferenceTestplantestGet(id, propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-test-by-testplantest-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followPropertyReferenceTestplantestGet1(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followPropertyReferenceTestplantestGet1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-testplan-by-testplantest-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followPropertyReferenceTestplantestGet2(id: string, propertyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followPropertyReferenceTestplantestGet2(id, propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-testplan-by-testplantest-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followPropertyReferenceTestplantestGet21(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followPropertyReferenceTestplantestGet21(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestPlanTestPropertyReferenceControllerApi - factory interface
 * @export
 */
export const TestPlanTestPropertyReferenceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestPlanTestPropertyReferenceControllerApiFp(configuration)
    return {
        /**
         * patch-test-by-testplantest-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestplantestPatch(id: string, collectionModelObject: CollectionModelObject, options?: any): AxiosPromise<void> {
            return localVarFp.createPropertyReferenceTestplantestPatch(id, collectionModelObject, options).then((request) => request(axios, basePath));
        },
        /**
         * patch-testplan-by-testplantest-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestplantestPatch1(id: string, collectionModelObject: CollectionModelObject, options?: any): AxiosPromise<void> {
            return localVarFp.createPropertyReferenceTestplantestPatch1(id, collectionModelObject, options).then((request) => request(axios, basePath));
        },
        /**
         * update-test-by-testplantest-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestplantestPut(id: string, collectionModelObject: CollectionModelObject, options?: any): AxiosPromise<void> {
            return localVarFp.createPropertyReferenceTestplantestPut(id, collectionModelObject, options).then((request) => request(axios, basePath));
        },
        /**
         * update-testplan-by-testplantest-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestplantestPut1(id: string, collectionModelObject: CollectionModelObject, options?: any): AxiosPromise<void> {
            return localVarFp.createPropertyReferenceTestplantestPut1(id, collectionModelObject, options).then((request) => request(axios, basePath));
        },
        /**
         * delete-test-by-testplantest-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceIdTestplantestDelete(id: string, propertyId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePropertyReferenceIdTestplantestDelete(id, propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * delete-testplan-by-testplantest-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceIdTestplantestDelete1(id: string, propertyId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePropertyReferenceIdTestplantestDelete1(id, propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * delete-test-by-testplantest-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceTestplantestDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePropertyReferenceTestplantestDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * delete-testplan-by-testplantest-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceTestplantestDelete1(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePropertyReferenceTestplantestDelete1(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-test-by-testplantest-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestplantestGet(id: string, propertyId: string, options?: any): AxiosPromise<void> {
            return localVarFp.followPropertyReferenceTestplantestGet(id, propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * get-test-by-testplantest-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestplantestGet1(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.followPropertyReferenceTestplantestGet1(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-testplan-by-testplantest-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestplantestGet2(id: string, propertyId: string, options?: any): AxiosPromise<void> {
            return localVarFp.followPropertyReferenceTestplantestGet2(id, propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * get-testplan-by-testplantest-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestplantestGet21(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.followPropertyReferenceTestplantestGet21(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestPlanTestPropertyReferenceControllerApi - object-oriented interface
 * @export
 * @class TestPlanTestPropertyReferenceControllerApi
 * @extends {BaseAPI}
 */
export class TestPlanTestPropertyReferenceControllerApi extends BaseAPI {
    /**
     * patch-test-by-testplantest-Id
     * @param {string} id 
     * @param {CollectionModelObject} collectionModelObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanTestPropertyReferenceControllerApi
     */
    public createPropertyReferenceTestplantestPatch(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig) {
        return TestPlanTestPropertyReferenceControllerApiFp(this.configuration).createPropertyReferenceTestplantestPatch(id, collectionModelObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * patch-testplan-by-testplantest-Id
     * @param {string} id 
     * @param {CollectionModelObject} collectionModelObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanTestPropertyReferenceControllerApi
     */
    public createPropertyReferenceTestplantestPatch1(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig) {
        return TestPlanTestPropertyReferenceControllerApiFp(this.configuration).createPropertyReferenceTestplantestPatch1(id, collectionModelObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-test-by-testplantest-Id
     * @param {string} id 
     * @param {CollectionModelObject} collectionModelObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanTestPropertyReferenceControllerApi
     */
    public createPropertyReferenceTestplantestPut(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig) {
        return TestPlanTestPropertyReferenceControllerApiFp(this.configuration).createPropertyReferenceTestplantestPut(id, collectionModelObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-testplan-by-testplantest-Id
     * @param {string} id 
     * @param {CollectionModelObject} collectionModelObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanTestPropertyReferenceControllerApi
     */
    public createPropertyReferenceTestplantestPut1(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig) {
        return TestPlanTestPropertyReferenceControllerApiFp(this.configuration).createPropertyReferenceTestplantestPut1(id, collectionModelObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete-test-by-testplantest-Id
     * @param {string} id 
     * @param {string} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanTestPropertyReferenceControllerApi
     */
    public deletePropertyReferenceIdTestplantestDelete(id: string, propertyId: string, options?: AxiosRequestConfig) {
        return TestPlanTestPropertyReferenceControllerApiFp(this.configuration).deletePropertyReferenceIdTestplantestDelete(id, propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete-testplan-by-testplantest-Id
     * @param {string} id 
     * @param {string} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanTestPropertyReferenceControllerApi
     */
    public deletePropertyReferenceIdTestplantestDelete1(id: string, propertyId: string, options?: AxiosRequestConfig) {
        return TestPlanTestPropertyReferenceControllerApiFp(this.configuration).deletePropertyReferenceIdTestplantestDelete1(id, propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete-test-by-testplantest-Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanTestPropertyReferenceControllerApi
     */
    public deletePropertyReferenceTestplantestDelete(id: string, options?: AxiosRequestConfig) {
        return TestPlanTestPropertyReferenceControllerApiFp(this.configuration).deletePropertyReferenceTestplantestDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete-testplan-by-testplantest-Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanTestPropertyReferenceControllerApi
     */
    public deletePropertyReferenceTestplantestDelete1(id: string, options?: AxiosRequestConfig) {
        return TestPlanTestPropertyReferenceControllerApiFp(this.configuration).deletePropertyReferenceTestplantestDelete1(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-test-by-testplantest-Id
     * @param {string} id 
     * @param {string} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanTestPropertyReferenceControllerApi
     */
    public followPropertyReferenceTestplantestGet(id: string, propertyId: string, options?: AxiosRequestConfig) {
        return TestPlanTestPropertyReferenceControllerApiFp(this.configuration).followPropertyReferenceTestplantestGet(id, propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-test-by-testplantest-Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanTestPropertyReferenceControllerApi
     */
    public followPropertyReferenceTestplantestGet1(id: string, options?: AxiosRequestConfig) {
        return TestPlanTestPropertyReferenceControllerApiFp(this.configuration).followPropertyReferenceTestplantestGet1(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-testplan-by-testplantest-Id
     * @param {string} id 
     * @param {string} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanTestPropertyReferenceControllerApi
     */
    public followPropertyReferenceTestplantestGet2(id: string, propertyId: string, options?: AxiosRequestConfig) {
        return TestPlanTestPropertyReferenceControllerApiFp(this.configuration).followPropertyReferenceTestplantestGet2(id, propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-testplan-by-testplantest-Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPlanTestPropertyReferenceControllerApi
     */
    public followPropertyReferenceTestplantestGet21(id: string, options?: AxiosRequestConfig) {
        return TestPlanTestPropertyReferenceControllerApiFp(this.configuration).followPropertyReferenceTestplantestGet21(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TestPropertyReferenceControllerApi - axios parameter creator
 * @export
 */
export const TestPropertyReferenceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * patch-abstractcommand-by-test-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestPatch: async (id: string, collectionModelObject: CollectionModelObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPropertyReferenceTestPatch', 'id', id)
            // verify required parameter 'collectionModelObject' is not null or undefined
            assertParamExists('createPropertyReferenceTestPatch', 'collectionModelObject', collectionModelObject)
            const localVarPath = `/tests/{id}/abstractCommandList`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionModelObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch-system-by-test-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestPatch1: async (id: string, collectionModelObject: CollectionModelObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPropertyReferenceTestPatch1', 'id', id)
            // verify required parameter 'collectionModelObject' is not null or undefined
            assertParamExists('createPropertyReferenceTestPatch1', 'collectionModelObject', collectionModelObject)
            const localVarPath = `/tests/{id}/system`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionModelObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-abstractcommand-by-test-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestPut: async (id: string, collectionModelObject: CollectionModelObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPropertyReferenceTestPut', 'id', id)
            // verify required parameter 'collectionModelObject' is not null or undefined
            assertParamExists('createPropertyReferenceTestPut', 'collectionModelObject', collectionModelObject)
            const localVarPath = `/tests/{id}/abstractCommandList`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionModelObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-system-by-test-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestPut1: async (id: string, collectionModelObject: CollectionModelObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPropertyReferenceTestPut1', 'id', id)
            // verify required parameter 'collectionModelObject' is not null or undefined
            assertParamExists('createPropertyReferenceTestPut1', 'collectionModelObject', collectionModelObject)
            const localVarPath = `/tests/{id}/system`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionModelObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete-abstractcommand-by-test-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceIdTestDelete: async (id: string, propertyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePropertyReferenceIdTestDelete', 'id', id)
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('deletePropertyReferenceIdTestDelete', 'propertyId', propertyId)
            const localVarPath = `/tests/{id}/abstractCommandList/{propertyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete-system-by-test-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceIdTestDelete1: async (id: string, propertyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePropertyReferenceIdTestDelete1', 'id', id)
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('deletePropertyReferenceIdTestDelete1', 'propertyId', propertyId)
            const localVarPath = `/tests/{id}/system/{propertyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete-abstractcommand-by-test-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceTestDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePropertyReferenceTestDelete', 'id', id)
            const localVarPath = `/tests/{id}/abstractCommandList`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete-system-by-test-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceTestDelete1: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePropertyReferenceTestDelete1', 'id', id)
            const localVarPath = `/tests/{id}/system`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-abstractcommand-by-test-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestGet: async (id: string, propertyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('followPropertyReferenceTestGet', 'id', id)
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('followPropertyReferenceTestGet', 'propertyId', propertyId)
            const localVarPath = `/tests/{id}/abstractCommandList/{propertyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-abstractcommand-by-test-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestGet1: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('followPropertyReferenceTestGet1', 'id', id)
            const localVarPath = `/tests/{id}/abstractCommandList`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-system-by-test-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestGet2: async (id: string, propertyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('followPropertyReferenceTestGet2', 'id', id)
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('followPropertyReferenceTestGet2', 'propertyId', propertyId)
            const localVarPath = `/tests/{id}/system/{propertyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-system-by-test-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestGet21: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('followPropertyReferenceTestGet21', 'id', id)
            const localVarPath = `/tests/{id}/system`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestPropertyReferenceControllerApi - functional programming interface
 * @export
 */
export const TestPropertyReferenceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestPropertyReferenceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * patch-abstractcommand-by-test-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReferenceTestPatch(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReferenceTestPatch(id, collectionModelObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * patch-system-by-test-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReferenceTestPatch1(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelSystem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReferenceTestPatch1(id, collectionModelObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-abstractcommand-by-test-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReferenceTestPut(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReferenceTestPut(id, collectionModelObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-system-by-test-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReferenceTestPut1(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelSystem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReferenceTestPut1(id, collectionModelObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete-abstractcommand-by-test-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePropertyReferenceIdTestDelete(id: string, propertyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePropertyReferenceIdTestDelete(id, propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete-system-by-test-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePropertyReferenceIdTestDelete1(id: string, propertyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePropertyReferenceIdTestDelete1(id, propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete-abstractcommand-by-test-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePropertyReferenceTestDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePropertyReferenceTestDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete-system-by-test-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePropertyReferenceTestDelete1(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePropertyReferenceTestDelete1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-abstractcommand-by-test-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followPropertyReferenceTestGet(id: string, propertyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followPropertyReferenceTestGet(id, propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-abstractcommand-by-test-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followPropertyReferenceTestGet1(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followPropertyReferenceTestGet1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-system-by-test-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followPropertyReferenceTestGet2(id: string, propertyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelSystem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followPropertyReferenceTestGet2(id, propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-system-by-test-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followPropertyReferenceTestGet21(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelSystem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followPropertyReferenceTestGet21(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestPropertyReferenceControllerApi - factory interface
 * @export
 */
export const TestPropertyReferenceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestPropertyReferenceControllerApiFp(configuration)
    return {
        /**
         * patch-abstractcommand-by-test-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestPatch(id: string, collectionModelObject: CollectionModelObject, options?: any): AxiosPromise<void> {
            return localVarFp.createPropertyReferenceTestPatch(id, collectionModelObject, options).then((request) => request(axios, basePath));
        },
        /**
         * patch-system-by-test-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestPatch1(id: string, collectionModelObject: CollectionModelObject, options?: any): AxiosPromise<EntityModelSystem> {
            return localVarFp.createPropertyReferenceTestPatch1(id, collectionModelObject, options).then((request) => request(axios, basePath));
        },
        /**
         * update-abstractcommand-by-test-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestPut(id: string, collectionModelObject: CollectionModelObject, options?: any): AxiosPromise<void> {
            return localVarFp.createPropertyReferenceTestPut(id, collectionModelObject, options).then((request) => request(axios, basePath));
        },
        /**
         * update-system-by-test-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestPut1(id: string, collectionModelObject: CollectionModelObject, options?: any): AxiosPromise<EntityModelSystem> {
            return localVarFp.createPropertyReferenceTestPut1(id, collectionModelObject, options).then((request) => request(axios, basePath));
        },
        /**
         * delete-abstractcommand-by-test-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceIdTestDelete(id: string, propertyId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePropertyReferenceIdTestDelete(id, propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * delete-system-by-test-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceIdTestDelete1(id: string, propertyId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePropertyReferenceIdTestDelete1(id, propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * delete-abstractcommand-by-test-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceTestDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePropertyReferenceTestDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * delete-system-by-test-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceTestDelete1(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePropertyReferenceTestDelete1(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-abstractcommand-by-test-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestGet(id: string, propertyId: string, options?: any): AxiosPromise<void> {
            return localVarFp.followPropertyReferenceTestGet(id, propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * get-abstractcommand-by-test-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestGet1(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.followPropertyReferenceTestGet1(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-system-by-test-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestGet2(id: string, propertyId: string, options?: any): AxiosPromise<EntityModelSystem> {
            return localVarFp.followPropertyReferenceTestGet2(id, propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * get-system-by-test-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestGet21(id: string, options?: any): AxiosPromise<EntityModelSystem> {
            return localVarFp.followPropertyReferenceTestGet21(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestPropertyReferenceControllerApi - object-oriented interface
 * @export
 * @class TestPropertyReferenceControllerApi
 * @extends {BaseAPI}
 */
export class TestPropertyReferenceControllerApi extends BaseAPI {
    /**
     * patch-abstractcommand-by-test-Id
     * @param {string} id 
     * @param {CollectionModelObject} collectionModelObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPropertyReferenceControllerApi
     */
    public createPropertyReferenceTestPatch(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig) {
        return TestPropertyReferenceControllerApiFp(this.configuration).createPropertyReferenceTestPatch(id, collectionModelObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * patch-system-by-test-Id
     * @param {string} id 
     * @param {CollectionModelObject} collectionModelObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPropertyReferenceControllerApi
     */
    public createPropertyReferenceTestPatch1(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig) {
        return TestPropertyReferenceControllerApiFp(this.configuration).createPropertyReferenceTestPatch1(id, collectionModelObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-abstractcommand-by-test-Id
     * @param {string} id 
     * @param {CollectionModelObject} collectionModelObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPropertyReferenceControllerApi
     */
    public createPropertyReferenceTestPut(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig) {
        return TestPropertyReferenceControllerApiFp(this.configuration).createPropertyReferenceTestPut(id, collectionModelObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-system-by-test-Id
     * @param {string} id 
     * @param {CollectionModelObject} collectionModelObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPropertyReferenceControllerApi
     */
    public createPropertyReferenceTestPut1(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig) {
        return TestPropertyReferenceControllerApiFp(this.configuration).createPropertyReferenceTestPut1(id, collectionModelObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete-abstractcommand-by-test-Id
     * @param {string} id 
     * @param {string} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPropertyReferenceControllerApi
     */
    public deletePropertyReferenceIdTestDelete(id: string, propertyId: string, options?: AxiosRequestConfig) {
        return TestPropertyReferenceControllerApiFp(this.configuration).deletePropertyReferenceIdTestDelete(id, propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete-system-by-test-Id
     * @param {string} id 
     * @param {string} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPropertyReferenceControllerApi
     */
    public deletePropertyReferenceIdTestDelete1(id: string, propertyId: string, options?: AxiosRequestConfig) {
        return TestPropertyReferenceControllerApiFp(this.configuration).deletePropertyReferenceIdTestDelete1(id, propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete-abstractcommand-by-test-Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPropertyReferenceControllerApi
     */
    public deletePropertyReferenceTestDelete(id: string, options?: AxiosRequestConfig) {
        return TestPropertyReferenceControllerApiFp(this.configuration).deletePropertyReferenceTestDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete-system-by-test-Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPropertyReferenceControllerApi
     */
    public deletePropertyReferenceTestDelete1(id: string, options?: AxiosRequestConfig) {
        return TestPropertyReferenceControllerApiFp(this.configuration).deletePropertyReferenceTestDelete1(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-abstractcommand-by-test-Id
     * @param {string} id 
     * @param {string} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPropertyReferenceControllerApi
     */
    public followPropertyReferenceTestGet(id: string, propertyId: string, options?: AxiosRequestConfig) {
        return TestPropertyReferenceControllerApiFp(this.configuration).followPropertyReferenceTestGet(id, propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-abstractcommand-by-test-Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPropertyReferenceControllerApi
     */
    public followPropertyReferenceTestGet1(id: string, options?: AxiosRequestConfig) {
        return TestPropertyReferenceControllerApiFp(this.configuration).followPropertyReferenceTestGet1(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-system-by-test-Id
     * @param {string} id 
     * @param {string} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPropertyReferenceControllerApi
     */
    public followPropertyReferenceTestGet2(id: string, propertyId: string, options?: AxiosRequestConfig) {
        return TestPropertyReferenceControllerApiFp(this.configuration).followPropertyReferenceTestGet2(id, propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-system-by-test-Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPropertyReferenceControllerApi
     */
    public followPropertyReferenceTestGet21(id: string, options?: AxiosRequestConfig) {
        return TestPropertyReferenceControllerApiFp(this.configuration).followPropertyReferenceTestGet21(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TestResultControllerApi - axios parameter creator
 * @export
 */
export const TestResultControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Testresult by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getById', 'id', id)
            const localVarPath = `/api/test/result`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestResultControllerApi - functional programming interface
 * @export
 */
export const TestResultControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestResultControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Testresult by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestResultControllerApi - factory interface
 * @export
 */
export const TestResultControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestResultControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Testresult by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id: number, options?: any): AxiosPromise<TestResultDto> {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestResultControllerApi - object-oriented interface
 * @export
 * @class TestResultControllerApi
 * @extends {BaseAPI}
 */
export class TestResultControllerApi extends BaseAPI {
    /**
     * 
     * @summary Get Testresult by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestResultControllerApi
     */
    public getById(id: number, options?: AxiosRequestConfig) {
        return TestResultControllerApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TestResultEntityControllerApi - axios parameter creator
 * @export
 */
export const TestResultEntityControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * delete-testresult
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourceTestresultDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteItemResourceTestresultDelete', 'id', id)
            const localVarPath = `/testResults/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-testresult
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourceTestresultGet1: async (page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/testResults`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-testresult
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourceTestresultGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getItemResourceTestresultGet', 'id', id)
            const localVarPath = `/testResults/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch-testresult
         * @param {string} id 
         * @param {TestResultRequestBody} testResultRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourceTestresultPatch: async (id: string, testResultRequestBody: TestResultRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchItemResourceTestresultPatch', 'id', id)
            // verify required parameter 'testResultRequestBody' is not null or undefined
            assertParamExists('patchItemResourceTestresultPatch', 'testResultRequestBody', testResultRequestBody)
            const localVarPath = `/testResults/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testResultRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create-testresult
         * @param {TestResultRequestBody} testResultRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourceTestresultPost: async (testResultRequestBody: TestResultRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testResultRequestBody' is not null or undefined
            assertParamExists('postCollectionResourceTestresultPost', 'testResultRequestBody', testResultRequestBody)
            const localVarPath = `/testResults`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testResultRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-testresult
         * @param {string} id 
         * @param {TestResultRequestBody} testResultRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourceTestresultPut: async (id: string, testResultRequestBody: TestResultRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putItemResourceTestresultPut', 'id', id)
            // verify required parameter 'testResultRequestBody' is not null or undefined
            assertParamExists('putItemResourceTestresultPut', 'testResultRequestBody', testResultRequestBody)
            const localVarPath = `/testResults/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testResultRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestResultEntityControllerApi - functional programming interface
 * @export
 */
export const TestResultEntityControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestResultEntityControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * delete-testresult
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteItemResourceTestresultDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteItemResourceTestresultDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-testresult
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollectionResourceTestresultGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedModelEntityModelTestResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollectionResourceTestresultGet1(page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-testresult
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getItemResourceTestresultGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelTestResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getItemResourceTestresultGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * patch-testresult
         * @param {string} id 
         * @param {TestResultRequestBody} testResultRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchItemResourceTestresultPatch(id: string, testResultRequestBody: TestResultRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelTestResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchItemResourceTestresultPatch(id, testResultRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * create-testresult
         * @param {TestResultRequestBody} testResultRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCollectionResourceTestresultPost(testResultRequestBody: TestResultRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelTestResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCollectionResourceTestresultPost(testResultRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-testresult
         * @param {string} id 
         * @param {TestResultRequestBody} testResultRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putItemResourceTestresultPut(id: string, testResultRequestBody: TestResultRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelTestResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putItemResourceTestresultPut(id, testResultRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestResultEntityControllerApi - factory interface
 * @export
 */
export const TestResultEntityControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestResultEntityControllerApiFp(configuration)
    return {
        /**
         * delete-testresult
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourceTestresultDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteItemResourceTestresultDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-testresult
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourceTestresultGet1(page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PagedModelEntityModelTestResult> {
            return localVarFp.getCollectionResourceTestresultGet1(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * get-testresult
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourceTestresultGet(id: string, options?: any): AxiosPromise<EntityModelTestResult> {
            return localVarFp.getItemResourceTestresultGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * patch-testresult
         * @param {string} id 
         * @param {TestResultRequestBody} testResultRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourceTestresultPatch(id: string, testResultRequestBody: TestResultRequestBody, options?: any): AxiosPromise<EntityModelTestResult> {
            return localVarFp.patchItemResourceTestresultPatch(id, testResultRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * create-testresult
         * @param {TestResultRequestBody} testResultRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourceTestresultPost(testResultRequestBody: TestResultRequestBody, options?: any): AxiosPromise<EntityModelTestResult> {
            return localVarFp.postCollectionResourceTestresultPost(testResultRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * update-testresult
         * @param {string} id 
         * @param {TestResultRequestBody} testResultRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourceTestresultPut(id: string, testResultRequestBody: TestResultRequestBody, options?: any): AxiosPromise<EntityModelTestResult> {
            return localVarFp.putItemResourceTestresultPut(id, testResultRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestResultEntityControllerApi - object-oriented interface
 * @export
 * @class TestResultEntityControllerApi
 * @extends {BaseAPI}
 */
export class TestResultEntityControllerApi extends BaseAPI {
    /**
     * delete-testresult
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestResultEntityControllerApi
     */
    public deleteItemResourceTestresultDelete(id: string, options?: AxiosRequestConfig) {
        return TestResultEntityControllerApiFp(this.configuration).deleteItemResourceTestresultDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-testresult
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestResultEntityControllerApi
     */
    public getCollectionResourceTestresultGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return TestResultEntityControllerApiFp(this.configuration).getCollectionResourceTestresultGet1(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-testresult
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestResultEntityControllerApi
     */
    public getItemResourceTestresultGet(id: string, options?: AxiosRequestConfig) {
        return TestResultEntityControllerApiFp(this.configuration).getItemResourceTestresultGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * patch-testresult
     * @param {string} id 
     * @param {TestResultRequestBody} testResultRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestResultEntityControllerApi
     */
    public patchItemResourceTestresultPatch(id: string, testResultRequestBody: TestResultRequestBody, options?: AxiosRequestConfig) {
        return TestResultEntityControllerApiFp(this.configuration).patchItemResourceTestresultPatch(id, testResultRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create-testresult
     * @param {TestResultRequestBody} testResultRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestResultEntityControllerApi
     */
    public postCollectionResourceTestresultPost(testResultRequestBody: TestResultRequestBody, options?: AxiosRequestConfig) {
        return TestResultEntityControllerApiFp(this.configuration).postCollectionResourceTestresultPost(testResultRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-testresult
     * @param {string} id 
     * @param {TestResultRequestBody} testResultRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestResultEntityControllerApi
     */
    public putItemResourceTestresultPut(id: string, testResultRequestBody: TestResultRequestBody, options?: AxiosRequestConfig) {
        return TestResultEntityControllerApiFp(this.configuration).putItemResourceTestresultPut(id, testResultRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TestResultPropertyReferenceControllerApi - axios parameter creator
 * @export
 */
export const TestResultPropertyReferenceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * patch-system-by-testresult-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestresultPatch: async (id: string, collectionModelObject: CollectionModelObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPropertyReferenceTestresultPatch', 'id', id)
            // verify required parameter 'collectionModelObject' is not null or undefined
            assertParamExists('createPropertyReferenceTestresultPatch', 'collectionModelObject', collectionModelObject)
            const localVarPath = `/testResults/{id}/system`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionModelObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-system-by-testresult-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestresultPut: async (id: string, collectionModelObject: CollectionModelObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPropertyReferenceTestresultPut', 'id', id)
            // verify required parameter 'collectionModelObject' is not null or undefined
            assertParamExists('createPropertyReferenceTestresultPut', 'collectionModelObject', collectionModelObject)
            const localVarPath = `/testResults/{id}/system`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(collectionModelObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete-system-by-testresult-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceIdTestresultDelete: async (id: string, propertyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePropertyReferenceIdTestresultDelete', 'id', id)
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('deletePropertyReferenceIdTestresultDelete', 'propertyId', propertyId)
            const localVarPath = `/testResults/{id}/system/{propertyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete-system-by-testresult-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceTestresultDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePropertyReferenceTestresultDelete', 'id', id)
            const localVarPath = `/testResults/{id}/system`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-system-by-testresult-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestresultGet: async (id: string, propertyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('followPropertyReferenceTestresultGet', 'id', id)
            // verify required parameter 'propertyId' is not null or undefined
            assertParamExists('followPropertyReferenceTestresultGet', 'propertyId', propertyId)
            const localVarPath = `/testResults/{id}/system/{propertyId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"propertyId"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-system-by-testresult-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestresultGet1: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('followPropertyReferenceTestresultGet1', 'id', id)
            const localVarPath = `/testResults/{id}/system`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestResultPropertyReferenceControllerApi - functional programming interface
 * @export
 */
export const TestResultPropertyReferenceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestResultPropertyReferenceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * patch-system-by-testresult-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReferenceTestresultPatch(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelSystem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReferenceTestresultPatch(id, collectionModelObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-system-by-testresult-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPropertyReferenceTestresultPut(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelSystem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPropertyReferenceTestresultPut(id, collectionModelObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete-system-by-testresult-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePropertyReferenceIdTestresultDelete(id: string, propertyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePropertyReferenceIdTestresultDelete(id, propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * delete-system-by-testresult-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePropertyReferenceTestresultDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePropertyReferenceTestresultDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-system-by-testresult-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followPropertyReferenceTestresultGet(id: string, propertyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelSystem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followPropertyReferenceTestresultGet(id, propertyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-system-by-testresult-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followPropertyReferenceTestresultGet1(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelSystem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followPropertyReferenceTestresultGet1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestResultPropertyReferenceControllerApi - factory interface
 * @export
 */
export const TestResultPropertyReferenceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestResultPropertyReferenceControllerApiFp(configuration)
    return {
        /**
         * patch-system-by-testresult-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestresultPatch(id: string, collectionModelObject: CollectionModelObject, options?: any): AxiosPromise<EntityModelSystem> {
            return localVarFp.createPropertyReferenceTestresultPatch(id, collectionModelObject, options).then((request) => request(axios, basePath));
        },
        /**
         * update-system-by-testresult-Id
         * @param {string} id 
         * @param {CollectionModelObject} collectionModelObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPropertyReferenceTestresultPut(id: string, collectionModelObject: CollectionModelObject, options?: any): AxiosPromise<EntityModelSystem> {
            return localVarFp.createPropertyReferenceTestresultPut(id, collectionModelObject, options).then((request) => request(axios, basePath));
        },
        /**
         * delete-system-by-testresult-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceIdTestresultDelete(id: string, propertyId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePropertyReferenceIdTestresultDelete(id, propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * delete-system-by-testresult-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePropertyReferenceTestresultDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePropertyReferenceTestresultDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-system-by-testresult-Id
         * @param {string} id 
         * @param {string} propertyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestresultGet(id: string, propertyId: string, options?: any): AxiosPromise<EntityModelSystem> {
            return localVarFp.followPropertyReferenceTestresultGet(id, propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * get-system-by-testresult-Id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followPropertyReferenceTestresultGet1(id: string, options?: any): AxiosPromise<EntityModelSystem> {
            return localVarFp.followPropertyReferenceTestresultGet1(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestResultPropertyReferenceControllerApi - object-oriented interface
 * @export
 * @class TestResultPropertyReferenceControllerApi
 * @extends {BaseAPI}
 */
export class TestResultPropertyReferenceControllerApi extends BaseAPI {
    /**
     * patch-system-by-testresult-Id
     * @param {string} id 
     * @param {CollectionModelObject} collectionModelObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestResultPropertyReferenceControllerApi
     */
    public createPropertyReferenceTestresultPatch(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig) {
        return TestResultPropertyReferenceControllerApiFp(this.configuration).createPropertyReferenceTestresultPatch(id, collectionModelObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-system-by-testresult-Id
     * @param {string} id 
     * @param {CollectionModelObject} collectionModelObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestResultPropertyReferenceControllerApi
     */
    public createPropertyReferenceTestresultPut(id: string, collectionModelObject: CollectionModelObject, options?: AxiosRequestConfig) {
        return TestResultPropertyReferenceControllerApiFp(this.configuration).createPropertyReferenceTestresultPut(id, collectionModelObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete-system-by-testresult-Id
     * @param {string} id 
     * @param {string} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestResultPropertyReferenceControllerApi
     */
    public deletePropertyReferenceIdTestresultDelete(id: string, propertyId: string, options?: AxiosRequestConfig) {
        return TestResultPropertyReferenceControllerApiFp(this.configuration).deletePropertyReferenceIdTestresultDelete(id, propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete-system-by-testresult-Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestResultPropertyReferenceControllerApi
     */
    public deletePropertyReferenceTestresultDelete(id: string, options?: AxiosRequestConfig) {
        return TestResultPropertyReferenceControllerApiFp(this.configuration).deletePropertyReferenceTestresultDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-system-by-testresult-Id
     * @param {string} id 
     * @param {string} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestResultPropertyReferenceControllerApi
     */
    public followPropertyReferenceTestresultGet(id: string, propertyId: string, options?: AxiosRequestConfig) {
        return TestResultPropertyReferenceControllerApiFp(this.configuration).followPropertyReferenceTestresultGet(id, propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-system-by-testresult-Id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestResultPropertyReferenceControllerApi
     */
    public followPropertyReferenceTestresultGet1(id: string, options?: AxiosRequestConfig) {
        return TestResultPropertyReferenceControllerApiFp(this.configuration).followPropertyReferenceTestresultGet1(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TestSearchControllerApi - axios parameter creator
 * @export
 */
export const TestSearchControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {System} [system] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestGet: async (system?: System, page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tests/search/findAllBySystem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (system !== undefined) {
                localVarQueryParameter['system'] = system;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [systemId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestGet1: async (systemId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tests/search/findAllBySystemWithoutPageable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (systemId !== undefined) {
                localVarQueryParameter['systemId'] = systemId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestGet2: async (id?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tests/search/findByPrefabId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestGet3: async (name?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tests/search/findTestByName`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestSearchControllerApi - functional programming interface
 * @export
 */
export const TestSearchControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestSearchControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {System} [system] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSearchTestGet(system?: System, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSearchTestGet(system, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [systemId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSearchTestGet1(systemId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSearchTestGet1(systemId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSearchTestGet2(id?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSearchTestGet2(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSearchTestGet3(name?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSearchTestGet3(name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestSearchControllerApi - factory interface
 * @export
 */
export const TestSearchControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestSearchControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {System} [system] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestGet(system?: System, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.executeSearchTestGet(system, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [systemId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestGet1(systemId?: number, options?: any): AxiosPromise<void> {
            return localVarFp.executeSearchTestGet1(systemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestGet2(id?: number, options?: any): AxiosPromise<void> {
            return localVarFp.executeSearchTestGet2(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTestGet3(name?: string, options?: any): AxiosPromise<void> {
            return localVarFp.executeSearchTestGet3(name, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestSearchControllerApi - object-oriented interface
 * @export
 * @class TestSearchControllerApi
 * @extends {BaseAPI}
 */
export class TestSearchControllerApi extends BaseAPI {
    /**
     * 
     * @param {System} [system] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestSearchControllerApi
     */
    public executeSearchTestGet(system?: System, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return TestSearchControllerApiFp(this.configuration).executeSearchTestGet(system, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [systemId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestSearchControllerApi
     */
    public executeSearchTestGet1(systemId?: number, options?: AxiosRequestConfig) {
        return TestSearchControllerApiFp(this.configuration).executeSearchTestGet1(systemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestSearchControllerApi
     */
    public executeSearchTestGet2(id?: number, options?: AxiosRequestConfig) {
        return TestSearchControllerApiFp(this.configuration).executeSearchTestGet2(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestSearchControllerApi
     */
    public executeSearchTestGet3(name?: string, options?: AxiosRequestConfig) {
        return TestSearchControllerApiFp(this.configuration).executeSearchTestGet3(name, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TraceEntityControllerApi - axios parameter creator
 * @export
 */
export const TraceEntityControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * delete-trace
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourceTraceDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteItemResourceTraceDelete', 'id', id)
            const localVarPath = `/traces/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-trace
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourceTraceGet1: async (page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/traces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get-trace
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourceTraceGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getItemResourceTraceGet', 'id', id)
            const localVarPath = `/traces/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch-trace
         * @param {string} id 
         * @param {TraceRequestBody} traceRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourceTracePatch: async (id: string, traceRequestBody: TraceRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchItemResourceTracePatch', 'id', id)
            // verify required parameter 'traceRequestBody' is not null or undefined
            assertParamExists('patchItemResourceTracePatch', 'traceRequestBody', traceRequestBody)
            const localVarPath = `/traces/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(traceRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create-trace
         * @param {TraceRequestBody} traceRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourceTracePost: async (traceRequestBody: TraceRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'traceRequestBody' is not null or undefined
            assertParamExists('postCollectionResourceTracePost', 'traceRequestBody', traceRequestBody)
            const localVarPath = `/traces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(traceRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update-trace
         * @param {string} id 
         * @param {TraceRequestBody} traceRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourceTracePut: async (id: string, traceRequestBody: TraceRequestBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putItemResourceTracePut', 'id', id)
            // verify required parameter 'traceRequestBody' is not null or undefined
            assertParamExists('putItemResourceTracePut', 'traceRequestBody', traceRequestBody)
            const localVarPath = `/traces/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(traceRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TraceEntityControllerApi - functional programming interface
 * @export
 */
export const TraceEntityControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TraceEntityControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * delete-trace
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteItemResourceTraceDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteItemResourceTraceDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-trace
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollectionResourceTraceGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedModelEntityModelTrace>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollectionResourceTraceGet1(page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get-trace
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getItemResourceTraceGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelTrace>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getItemResourceTraceGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * patch-trace
         * @param {string} id 
         * @param {TraceRequestBody} traceRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchItemResourceTracePatch(id: string, traceRequestBody: TraceRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelTrace>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchItemResourceTracePatch(id, traceRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * create-trace
         * @param {TraceRequestBody} traceRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCollectionResourceTracePost(traceRequestBody: TraceRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelTrace>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCollectionResourceTracePost(traceRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update-trace
         * @param {string} id 
         * @param {TraceRequestBody} traceRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putItemResourceTracePut(id: string, traceRequestBody: TraceRequestBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityModelTrace>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putItemResourceTracePut(id, traceRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TraceEntityControllerApi - factory interface
 * @export
 */
export const TraceEntityControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TraceEntityControllerApiFp(configuration)
    return {
        /**
         * delete-trace
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemResourceTraceDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteItemResourceTraceDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get-trace
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectionResourceTraceGet1(page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PagedModelEntityModelTrace> {
            return localVarFp.getCollectionResourceTraceGet1(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * get-trace
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemResourceTraceGet(id: string, options?: any): AxiosPromise<EntityModelTrace> {
            return localVarFp.getItemResourceTraceGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * patch-trace
         * @param {string} id 
         * @param {TraceRequestBody} traceRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchItemResourceTracePatch(id: string, traceRequestBody: TraceRequestBody, options?: any): AxiosPromise<EntityModelTrace> {
            return localVarFp.patchItemResourceTracePatch(id, traceRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * create-trace
         * @param {TraceRequestBody} traceRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCollectionResourceTracePost(traceRequestBody: TraceRequestBody, options?: any): AxiosPromise<EntityModelTrace> {
            return localVarFp.postCollectionResourceTracePost(traceRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * update-trace
         * @param {string} id 
         * @param {TraceRequestBody} traceRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putItemResourceTracePut(id: string, traceRequestBody: TraceRequestBody, options?: any): AxiosPromise<EntityModelTrace> {
            return localVarFp.putItemResourceTracePut(id, traceRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TraceEntityControllerApi - object-oriented interface
 * @export
 * @class TraceEntityControllerApi
 * @extends {BaseAPI}
 */
export class TraceEntityControllerApi extends BaseAPI {
    /**
     * delete-trace
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceEntityControllerApi
     */
    public deleteItemResourceTraceDelete(id: string, options?: AxiosRequestConfig) {
        return TraceEntityControllerApiFp(this.configuration).deleteItemResourceTraceDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-trace
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceEntityControllerApi
     */
    public getCollectionResourceTraceGet1(page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return TraceEntityControllerApiFp(this.configuration).getCollectionResourceTraceGet1(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get-trace
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceEntityControllerApi
     */
    public getItemResourceTraceGet(id: string, options?: AxiosRequestConfig) {
        return TraceEntityControllerApiFp(this.configuration).getItemResourceTraceGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * patch-trace
     * @param {string} id 
     * @param {TraceRequestBody} traceRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceEntityControllerApi
     */
    public patchItemResourceTracePatch(id: string, traceRequestBody: TraceRequestBody, options?: AxiosRequestConfig) {
        return TraceEntityControllerApiFp(this.configuration).patchItemResourceTracePatch(id, traceRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create-trace
     * @param {TraceRequestBody} traceRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceEntityControllerApi
     */
    public postCollectionResourceTracePost(traceRequestBody: TraceRequestBody, options?: AxiosRequestConfig) {
        return TraceEntityControllerApiFp(this.configuration).postCollectionResourceTracePost(traceRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update-trace
     * @param {string} id 
     * @param {TraceRequestBody} traceRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceEntityControllerApi
     */
    public putItemResourceTracePut(id: string, traceRequestBody: TraceRequestBody, options?: AxiosRequestConfig) {
        return TraceEntityControllerApiFp(this.configuration).putItemResourceTracePut(id, traceRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TraceSearchControllerApi - axios parameter creator
 * @export
 */
export const TraceSearchControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [testResultId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTraceGet: async (testResultId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/traces/search/findAllByTestResultId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (testResultId !== undefined) {
                localVarQueryParameter['testResultId'] = testResultId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [targetDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTraceGet1: async (targetDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/traces/search/findByCreationTsBefore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (targetDate !== undefined) {
                localVarQueryParameter['targetDate'] = (targetDate as any instanceof Date) ?
                    (targetDate as any).toISOString() :
                    targetDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TraceSearchControllerApi - functional programming interface
 * @export
 */
export const TraceSearchControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TraceSearchControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [testResultId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSearchTraceGet(testResultId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionModelEntityModelTrace>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSearchTraceGet(testResultId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [targetDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSearchTraceGet1(targetDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionModelEntityModelTrace>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSearchTraceGet1(targetDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TraceSearchControllerApi - factory interface
 * @export
 */
export const TraceSearchControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TraceSearchControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [testResultId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTraceGet(testResultId?: number, options?: any): AxiosPromise<CollectionModelEntityModelTrace> {
            return localVarFp.executeSearchTraceGet(testResultId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [targetDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSearchTraceGet1(targetDate?: string, options?: any): AxiosPromise<CollectionModelEntityModelTrace> {
            return localVarFp.executeSearchTraceGet1(targetDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TraceSearchControllerApi - object-oriented interface
 * @export
 * @class TraceSearchControllerApi
 * @extends {BaseAPI}
 */
export class TraceSearchControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} [testResultId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceSearchControllerApi
     */
    public executeSearchTraceGet(testResultId?: number, options?: AxiosRequestConfig) {
        return TraceSearchControllerApiFp(this.configuration).executeSearchTraceGet(testResultId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [targetDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TraceSearchControllerApi
     */
    public executeSearchTraceGet1(targetDate?: string, options?: AxiosRequestConfig) {
        return TraceSearchControllerApiFp(this.configuration).executeSearchTraceGet1(targetDate, options).then((request) => request(this.axios, this.basePath));
    }
}


